export default {
  locales: {
    sv: "Swedish",
  },
  fatca: "FATCA",
  crs: "CRS",
  acttrader: "ActTrader",
  compairacc: "Jämför konton",
  ecnacc: "ECN-KONTO",
  openacc: "Öppna konto",
  crypto: "Cyr-kryptovalutor",
  stock: "Aktier",
  forex: "Forex",
  indices: "Index",
  commodities: "Råvaror",
  negativebalance: "Skydd mot negativ balans",
  minorderdest: "Min.order Avstånd",
  stopout: "stopp",
  margincall: "Margin Call",
  yes: "Ja",
  no: "Nej",
  lot: "parti",
  usd: "USD",
  eur: "EUR",
  gbp: "GBP",
  aud: "AUD",
  basecurrency: "Basvalutor",
  upto: "upp till",
  mindeposit: "Min. Insättning",
  account: "Konto",
  zulu: "zulu",
  zulu_trade: "Zulu Handel",
  plus: "plus",
  max: "max",
  min: "min",
  leverage: "Hävstångseffekt",
  per: "per",
  commission: "Kommissionen",
  minpip: "min. pip",
  spreads: "Spreadar",
  spread: "Spridning",
  ecn: "ECN",
  keyinfo: "Dokument med nyckelinformation",
  mifid: "MIFID-lagstiftning",
  privacypolicy: "Integritetspolicy",
  contact: "Kontakt 24/5",
  webtrader: "Webbhandlare",
  login: "Logga in",
  joinNow: "Gå med nu",
  aboutAAAfx: {
    name: "Om AAAFx",
    submenu: {
      why: {
        title: "Varför AAAFx",
        tagline: "Vet vilka vi är",
      },
      safety: {
        title: "Säkerhet för fonder",
        tagline: "Vi har din rygg",
      },
      servers: {
        title: "Våra servitörer",
        tagline: "Bästa system för bästa resultat",
      },
      regulations: {
        title: "Föreskrifter och licenser",
        tagline: "Pålitlig och säker handel",
      },
      legalDocs: {
        title: "Juridiska dokument",
        tagline: "Läs alla juridiska dokument",
      },
      careers: {
        title: "Karriär",
        tagline: "Bli en del av vårt team",
      },
      contactUs: {
        title: "Kontakta oss",
        tagline: "Vi skulle gärna vilja höra från dig",
      },
    },
    title:
      "Triple A Experts Investment Services Single Member SA är auktoriserat av EU och regleras av Hellenic Capital Market Commission (id:2/540/17.2.2010) med registrerad adress på Triple A Experts Investment Services Single Member S. A, 580 Vouliagmenis Avenue 16452, Argyroupoli Attica, Greece. And Registration Authority Entity ID 4480770 7000",
  },
  trading: {
    name: "Handel",
    submenu: {
      products: {
        title: "Handelsprodukter",
        tagline: "Handelsinstrument vi erbjuder",
      },
      accountTypes: {
        title: "Kontotyper",
        tagline: "Välj det som passar dina behov",
      },
      tradingConditions: {
        title: "Villkor för handel",
        tagline: "Allt för att tillgodose dina bästa intressen",
      },
      depWithdrawal: {
        title: "Insättningar och uttag",
        tagline: "Bekymmersfri penninghantering",
      },
    },
  },
  platforms: {
    name: "Plattformar",
    submenu: {
      mt4: {
        title: "MT4",
        tagline: "Mest populära handelsplattformen",
      },
      mt5: {
        title: "MT5",
        tagline: "Avancerad och multifunktionell",
      },
      act: {
        name: "ACT",
        title: "ActTrader",
        tagline: "Lätt att använda och mycket bekvämt",
      },
      comparison: {
        title: "Jämförelse av plattformar",
        tagline: "Fatta ett välgrundat beslut",
      },
    },
  },
  promotions: {
    name: "Kampanjer",
    submenu: {
      bonus: {
        title: "Insättningsbonus",
        tagline: "Fördubbla dina marginaler utan kostnad",
      },
      refer: {
        title: "Värva och tjäna pengar",
        tagline: "Bjud in dina vänner och dela med dig av fördelarna",
      },
      vps: {
        title: "Gratis VPS",
        tagline: "Utnyttja gratis höghastighetshandel",
      },
    },
  },
  tools: {
    name: "Verktyg och resurser",
    submenu: {
      zulu: {
        title: "ZuluTrade",
        tagline: "Gå med i det största sociala handelsnätverket",
      },
      calculators: {
        title: "Kalkylatorer för handel",
        tagline: "Beräkningar som gör det enkelt för dig",
      },
      ecoCalendar: {
        title: "Ekonomisk kalender",
        tagline: "Håll dig uppdaterad och handla klokt",
      },
      partnerships: {
        title: "Partnerskap",
        tagline: "Bli partner med oss och väx",
      },
      faq: {
        title: "Vanliga frågor",
        tagline: "Få svar på vanliga frågor",
      },
    },
  },
  legalinfo: {
    name: "Juridisk information",
    para1:
      "Triple A Experts Investment Services Single Member SA är auktoriserat av EU och regleras av Hellenic Capital Market Commission (id:2/540/17.2.2010) med registrerad adress på Triple A Experts Investment Services S.A., 14 Akti Kondyli street, 18545 Piraeus, Grekland.",
    para2:
      "Sikhula Venture Capital (Pty) Ltd. är auktoriserat och regleras av den sydafrikanska myndigheten Financial Sector Conduct Authority (FSCA nr 2017/315029/07).",
    para3:
      "www.aaafx.com drivs av Triple A Experts Investment Services Single Member SA",
    para4:
      "www.aaafx.com drivs av Triple A Experts Investment Services Single Member SA.",
  },
  riskdisc: {
    name: "Upplysning om risker",
    para_one:
      "CFD:er är komplexa instrument och innebär en hög risk att snabbt förlora pengar på grund av hävstången.",
    para_two:
      "av kontona för icke-professionella investerare förlorar pengar när de handlar med CFD:er med AAAFx. Du bör överväga om du förstår hur CFD:er fungerar och om du har råd att ta den höga risken att förlora dina pengar. Detaljer kan hittas",
    link: "här.",
    acceptedLang: "Godtagbara länder",
    countries:
      "Triple A Experts Investment Services Single Member S.A accepterar kunder från 27 länder inom Europeiska ekonomiska samarbetsområdet (EU och Island, Schweiz och Liechtenstein) Kunder från Belgien och Storbritannien accepteras inte.",
  },
  accounttypepage: {
    title: "Kontotyper",
    tagline1:
      "Välj det konto som passar dina handelsbehov! Vi har spännande erbjudanden för",
    tagline2: "varje handlare, på ett mycket förenklat sätt.",
    zeroPointZero: "0.0",
    hundredDollar: "$100k",
    fiveDollar: "$5",
    threeDollar: "$3",
    thirtyX: "30X",
    hundered: "$100",
    tenThousand: "$10,000",
    chf: "CHF",
    seventyFifty: "70/50%",
    para1: {
      desc1:
        "Det finns tre olika kontotyper som matchar kraven hos en nybörjare, en professionell handlare eller en institutionell handlare. Några av de gemensamma spännande funktionerna som garanteras i alla konton är:",
      point1: "EU-reglerad mäklare",
      point2: "Ultra-tunna uppslag",
      point3: "Alla handelsstrategier tillåtna",
      point4:
        "Ingen Min. Beställningsavstånd - placera beställningar som du vill",
      point5: "Skydd mot negativ balans",
      point6: "Micro Lots-handel",
      desc2:
        "Utan diskriminering erbjuder vi spreadar och likviditet av institutionell kvalitet till alla handlare.",
    },
    accdesc: {
      title: "Beskrivning av konto",
      point1: {
        title: "ECN-konto",
        desc: "Njut av ECN-spreadar och blixtsnabb handel till en mycket låg kostnad. Låga kommissionsavgifter och låga swapavgifter i kombination med vår avancerade teknik gör din handelsupplevelse exemplarisk i alla avseenden. Vi inför inte heller några begränsningar för någon handelsstrategi.",
      },
      point2: {
        title: "ECN plus-konto",
        desc: "För handlare med en minsta insättning på $ 10,000 eller de i AAA-kategorin i Lojalitetsprogrammet är ECN zero en belöning att längta efter. Detta är den bästa möjliga kombinationen för alla handlare - nollprovision på Forex med tunna spreadar, utan påslag. Du kan njuta av allt detta tillsammans med vårt blixtsnabba handelsutförande.",
      },
      point3: {
        title: "ECN Zulu Handelskonto",
        desc: "Bli en del av den största sociala handelsgemenskapen genom att öppna ett Zulukonto hos oss. Detta konto ansluts automatiskt till Zulu-plattformen och inga ytterligare åtgärder krävs. Därmed får du automatiskt ta del av knivskarpa spreadar, låga courtage, vår avancerade teknik, djupa likviditet och blixtsnabba exekvering, tillsammans med direkt tillgång till ett handelssamhälle i världsklass.",
      },
      para1:
        "Mer flexibla handelsvillkor (ökad hävstångseffekt) kan gälla för kunder som klassificeras som Professional. Logga in på ditt konto och kontrollera om du är berättigad till Professional Client-klassificering, eller skriv till oss på",
    },
    supportEmail: "support{'@'}aaafx.com",
  },
  acttraderpage: {
    title: "ActTrader",
    para1:
      "Vill du handla men är osäker på hur du ska lära dig de avancerade handelsplattformarna?",
    para2:
      " Vi har täckt in dig med vår ActTrader-handelsplattform. ActTrader har varit ledande inom onlinehandelsbranschen sedan 2000 och är utrustad med den bästa tekniken i klassen. Plattformen fokuserar på enkelhet, läsbarhet och att utmana de befintliga handelstraditionerna med robust teknik så att användaren kan fokusera på handelsalternativen. ActTrader har bevittnat en flerfaldig ökning av handelsvolymen upp till 5 biljoner dollar per månad, vilket underbygger den djupa likviditeten på plattformen.",
    para3: "Börja din smidiga handelsresa med ActTrader:",
    questionnaire: {
      question1: {
        heading: "Steg för att ladda ner ActTrader Desktop",
        point: "1. Ladda ner plattformen från länken ovan.",
        point1: "2. Kör .exe-filen",
        point2:
          "3. Ange ditt handelskontonummer och lösenord på din ACT-plattform.",
        point3: " 4. Välj kontotyp : Demo för demokonto / Real för live-konto.",
        point4: "5. Välj önskat språk.",
        point5: '6. Klicka på "Logga in"',
        point6: "7. En liten ruta kommer att dyka upp. Välj tidszon.",
        point7:
          "8. Återigen kommer en liten ruta att dyka upp. Välj plattformens layout nybörjare / avancerad.",
      },
      question2: {
        heading: "Steg för att avinstallera ActTrader Desktop",
        point: "1. Klicka på Start-knappen i Windows",
        point1: "2. ACT-ansökan kommer att inkluderas i listan över program.",
        point2: '3. Högerklicka på programmets namn och välj "Avinstallera".',
      },
      question3: {
        heading: "Steg för att logga in på webbaserade Act Trader",
        point: "1. Klicka på länken Web Trader",
        aTag: "här",
        point1:
          '2. Välj "Demo web trader" för demo-konto eller "Live web trader" för live-konto.',
        point2: "3. En ny flik öppnas.",
        point3: "4. Fyll i inloggningsuppgifterna. Du är nu inloggad.",
      },
      question4: {
        heading: "Steg för att ladda ner ActTrader Android",
        point: "1. Installera programmet från länken ovan.",
        point1:
          "2. Klicka på den installerade applikationen på din Android-enhet.",
        point2: '3. Tryck på "Acceptera" på licensavtalet.',
        point3:
          "4. Du måste ange ditt handelskontonummer på användarnamnet och det är lösenord.",
        point4:
          "5. Välj kontotyp: AAAFX Demo för demo och AAAFX Live för live.",
        point5: '6. Klicka på "Logga in"',
      },
      question5: {
        heading: "Steg för att avinstallera ActTrader Android",
        point:
          "1. I menyn går du till Inställningar > Program > Hantera program",
        point1: "2. Hitta ACT listad där och tryck på dess namn.",
        point2: "3. Tryck på Avinstallera.",
      },
      question6: {
        heading: "Steg för att ladda ner ActTrader iOS",
        point: "1. Öppna appen ActPhone.",
        point1: "2. Ange inloggningsuppgifterna som du har fått via e-post.",
        point2:
          "3. I Kontotyp bläddrar du nedåt och väljer AAAFX Demo för ett demokonto eller AAAFX Live för ett livekonto.",
        point3: "4. Välj Logga in och vänta tills ditt konto har laddats.",
      },
      question7: {
        heading: "Steg för att avinstallera ActTrader iOS",
        point:
          "1. Tryck länge på applikationsikonen ActTrader tills alla ikoner på skärmen börjar skaka.",
        point1:
          '2. Klicka på "x" i det övre vänstra hörnet av ikonen för ActTrader-programmet.',
      },
    },
    journey: "Börja din smidiga handelsresa med ActTrader:",
    heading:
      "AAAFx ActTrader lovar att låta en användare utforska en mängd olika handelsmöjligheter med skräddarsydda villkor och möjlighet att överblicka allt från grunden.",
    features: "Viktiga funktioner i AAAFx ActTrader-plattformen:",
    platform:
      "Fortfarande tveksam? Ta en titt på den korta översikten över de funktioner som tillhandahålls via ActTrader-plattformen:",
    depth: "Fördjupade analytiska verktyg:",
    ul: {
      li: "Stort utbud av redan installerade indikatorer",
      li1: "Flera ritverktyg att använda över diagrammen",
      li2: "Förenklat arbete med handelsalternativ med ett klick",
      li3: "Ställ in viktiga prisvarningar så att du aldrig missar någon möjlighet",
      li4: "Exportera kontodata direkt till Excel med största möjliga bekvämlighet",
      liTag: "Lägg till/ta bort ytterligare arbetsyta",
      liTag1: "Formatera inställningarna för datum/tid",
      liTag2:
        "Sätt färg på din handelsterminal och skapa en rolig arbetsyta för dig själv",
      liTag3: "Strömma plattformspriser på det sätt du vill",
      liTag4: "70+ forex-valutor",
      liTag5: "Populära råvaror som guld och olja",
      liTag6: "11 globala index - Nasdaq, Dow Jones, etc.",
      liTag7: "6 stora och mest omsatta kryptovalutor",
    },
    tradingWindow: "Anpassa ditt handelsfönster:",
    instument: "Instrument som erbjuds:",
    liveAccount: "ÖPPNA LIVE-KONTO",
    demoAccount: "ÖPPET DEMOKONTO",
  },
  loginPage: {
    h3Tag: "Var vänlig och vänta. Omdirigering till ditt konto",
  },
  compensation: {
    title: "Ersättningsfond",
    questions: {
      ques: "Vad är Finansinspektionen?",
      ans: "Financial Commission är ett unikt bildat oberoende organ för att få handlare att känna sig säkra och bevakade. Huvudsyftet med Financial Commission är att få till stånd snabba och effektiva lösningar på tvister mellan handlare och mäklare. Den arbetar på ett sätt där transparens, snabbhet och utbildning är de viktigaste värdena. Alla Financial Commission-tjänster är helt gratis för våra kunder.",
      ques1: "Hur fungerar det?",
      ans1: "En kompensationsfond finansieras av Financial Commission genom att 10% av medlemsavgifterna avsätts till fonden som hålls på ett separat bankkonto och som inte får användas för att finansiera organisationens verksamhet eller andra aktiviteter. Fonden ger AAAFx-kunder ett skyddsnät på upp till 20 000 euro för ett enda klagomål.",
      ques2: "Varför gick vi med i finanskommissionen?",
      ans2: "Financial Commission har sammanförts av några av de ledande branschspecialisterna vars primära mål är att öka marknadstransparensen och servicestandarderna i hela Forex-industrin. Detta är i linje med vad vi på AAAFx verkligen tror på - ärlighet och transparens. Att hålla kunderna i centrum för vår verksamhet är en av våra kärnideologier. Därför har vi gått samman med Financial Commission för att tillhandahålla effektiv och snabb tvistlösning till våra kunder.",
    },
    steps: "Vilka är stegen i en tvist?",
    process: "Resolutionsprocess?",
    complaint: "Klagomål",
    pTag: "En kund kan kontakta kommissionen om han eller hon",
    brTag: "har fått ett officiellt svar från",
    brTag1: "mäklare angående en olöst tvist som",
    brTag2: "kunden anser vara otillfredsställande.",
    investigation: "Undersökning",
    pTag1: "När deras kommitté för tvistlösning",
    brTag3: "har mottagit klagomålet, utredningen och",
    brTag4: "forskningen inleds och ett beslut fattas",
    brTag5: "inom 1-2 veckor.",
    text: "Kompensation",
    pTag2: "Om mäklaren vägrar att följa beslut",
    brTag6: "av finansutskottet, en av de",
    brTag7: "ersättning betalas ut till näringsidkaren från den särskilda",
    brTag8: "kompensationsfond.",
    decision: "Beslut",
    resolutionRegarding: "Utskottets resolution om",
    brTag9: "bedömningen av tvisten är bindande för",
    brTag10: "mäklaren och måste följas av",
    brTag11: "mäklaren.",
  },
  zuluTools: {
    title: "ZULUTRADE",
    pTag: "Handla inte ensam - gå med i det största sociala handelsnätverket",
    para: "På AAAFx får du chansen att handla med likviditet av institutionell kvalitet och använda dig av våra överlägsna handelsvillkor. Handel kan dock ibland vara mycket tidskrävande och känslomässigt krävande, vilket kan vara ett hinder för en framgångsrik handelsupplevelse för vissa människor.",
    bTag: "På AAAFx får du chansen att handla med likviditet av institutionell kvalitet och använda dig av våra överlägsna handelsvillkor. Handel kan dock ibland vara mycket tidskrävande och känslomässigt krävande, vilket kan vara ett hinder för en framgångsrik handelsupplevelse för vissa människor.",
    bTag1:
      "ZuluTrade, som bildades 2007, hjälper investerare att upptäcka exceptionella handlare från hela världen och kopiera deras strategier för att handla för sig själva. Detta är en onlineplattform för social handel och kopiering som gör det möjligt för användare att anta expertplan för sina affärer. Det rankar experternas prestanda och gör det möjligt för näringsidkaren att lätt märka och kopiera affärer från sin portfölj. Idag är det ett av de mest populära sociala handelsnätverken.",
    copier: "Bli en kopiator",
    pTag1:
      "Med vårt ZuluTrade-konto får du direkt och automatisk och direkt tillgång till en uppsjö av möjligheter att göra vinster genom Zulu-anslutning.",
    brTag:
      "Du kan helt enkelt granska experthandlarnas handelsresultat, kopiera dem och bara koppla av!",
    register: "REGISTRERA",
    master: "Bli en mästare",
    pTag2:
      "Om du vill bli en Master trader och vill att andra ska se och kopiera din handelsexpertis, får du också det alternativet hos oss. Ditt AAAFx-konto är automatiskt anslutet till Zulu.",
    brTag1:
      "Så du får tjäna vinster på ditt handelskonto och tjäna prestationsavgifter från dina kopiatorer också!",
    offers:
      "ZuluTrade erbjuder en mängd olika funktioner och produkter, några av dem listas nedan:",
    platform: "ZuluTrade Social plattform:",
    pTag3:
      "Oavsett om du är en handlare och har en framgångsrik handelsstrategi att dela med dig av, eller om du är en investerare och vill diskutera Zulu Traders och deras resultat, så finns det ett forum här. ZuluTrade har en omfattande plattform för sociala handelsgemenskaper som inkluderar bloggar, handelsdiskussioner och sociala flöden. Detta innebär en chans att interagera med handelsgemenskapen och lära sig av dem också.",
    zuluGuard: "ZuluTrade Guard:",
    pTag4:
      "ZuluTrade Guard erbjuder kontoskydd genom att övervaka expertens beteende och avfölja signalleverantören om några ändringar görs i handelsstrategin.",
    brTag2:
      "Det görs genom att beräkna ett utgångsvärde för de öppna affärerna på kontot och när tröskeln nås stängs affärerna",
    automator: "Automator:",
    pTag5:
      "Automator står för Automated Trading. Det hänvisar till handel genom fördefinierade regler för inträde och utträde ur de affärer som utförs av ett automatiserat program. Det hjälper till att eliminera handelskänslor och sparar tid.",
    combos: "Kombinationer:",
    pTag6:
      "Handlare grupperas av ZuluTrade i kombinationer baserat på deras riskaptit och strategier. Investeraren kan välja en kombination att följa. Varje kombination förvaltas av ZuluTrades Certified Management Portfolio Team.",
    quickSteps: "Tre snabba steg för att börja kopiera:",
    openFund: "Öppna och fondera din AAAFx",
    zuluAccount: "ECN zulu-konto",
    cred: "Få inloggningsuppgifter för Zulu i e-postmeddelandet",
    zuluTrade: "Börja kopiera affärer från Zulu Trade",
    openLive: "ÖPPNA LIVE-KONTO",
    openDemo: "ÖPPET DEMOKONTO",
  },
  zuluTrade: {
    mt4: "MT4",
    zulutrade: "ZuluTrade",
    h5Tag:
      "Människor tenderar att prestera bättre i gemenskaper och genom att följa dem som man kan lita på.",
    pTag: "AAAfx förstår detta behov och erbjuder därför den mest eftertraktade Zulu Trade-plattformen. Zulu Trade grundades 2007, i en tid då världen saknade en lämplig mekanism för att granska handelsmetoder och för att dela med sig av sin handelskunskap till varandra. Denna plattform eliminerade också behovet av att sitta timmar framför en skärm och introducerade automatiserad och professionell finansiell handel till mainstream.",
    brTag:
      "Zulu Trade är en automatiserad handelsplattform som ger en grundlig statistisk analys av de bästa handlarna för att göra det möjligt för en användare att få insikt och skapa ett system för att kopiera affärer och tjäna fördelen",
    startTrading: "Börja handla i bara 3 enkla steg:",
    openFund: "Öppna och fondera din AAAFx",
    ecnPlus: "ECN Zulu Handelskonto",
    variousTraders: "Analysera olika handlares resultat.",
    copy: "Välj den handlare som du vill kopiera.",
    pTag1:
      "Du kan också välja mellan diversifierade strategier som bygger på de bästa kombinationerna av de bästa handlarna på Zulu Trade. Välj Combo+-tjänsten och få ditt konto förvaltat av ZuluTrades Certified Management Portfolio Team i helautomatiskt eller halvautomatiskt läge, som du vill!",
    ztp: "ZTP är en renodlad webbaserad plattform som enkelt kan nås här",
    webBase: "Webbaserad plattform",
    h3Tag:
      "AAAFx erbjuder en exceptionell handelsupplevelse i kombination med ZTP:s följande funktioner i världsklass:",
  },
  why: {
    title: "Varför AAAFx?",
    honesty: "Par Excellence med ärlighet och transparens",
    believe: "Varför tro på AAAFx?",
    pTag: "Vi har under mer än ett decennium försett våra globala kunder med tillförlitlig och utmärkt service. Vi skapar full transparens med våra kunder, så att de kan fatta välgrundade beslut.",
    brTag:
      "Vi vet vad som krävs för att vara en framgångsrik handlare och strävar därför efter att tillhandahålla förstklassiga handelsvillkor och kundsupport till våra kunder. Vi är stolta över att vara en av de mest betrodda mäklarna på valutamarknaden och betjänar såväl privatkunder som institutionella kunder.",
    listing: {
      point: "Säker och pålitlig mäklare",
      point1: "Blixtsnabbt genomförande",
      point2: "Noll provision, Raw Spreads på Forex",
      point3: "Pool för djupa vätskor",
      point4: "3 Premium-handelsplattformar",
      point5: "Equinix datacenter utrustade med avancerad teknik",
      point6: "14 års erfarenhet",
      point7: "Flera metoder för att göra kostnadsfria insättningar och uttag",
    },
    more: "Vad är det mer?",
    socialTrading: "Auto Connect till den största sociala handelsgemenskapen",
    entireTeam: "Och hela AAAFx-teamet står omedelbart till din tjänst!!!",
    pledge: "Vi lovar...",
    liTag:
      "För att förse dig med en mäklartjänst som arbetar i handlarnas bästa intresse.",
    liTag1:
      "Att följa de regler som publicerats inom ramen för relevanta regelverk.",
    liTag2: "Att ständigt leta efter möjligheter att förnya och improvisera.",
    liTag3: "Att alltid hålla fast vid våra kärnvärden.",
    founded: "GRUNDAD I",
    serve: "LÄNDER VI BETJÄNAR",
    trade: "Instrument för handel",
    platform: "Plattformar vi erbjuder",
    support: "LIVE-support",
    number: {
      twoThousand: "2008",
      thirty: "30",
      twoHundred: "200+",
      three: "3",
      twentyFour: "24/5",
    },
    team: "Vårt team...",
    pTag1:
      "Var och en för sig kan våra ideal verka självklara. Men när vi lägger ihop dem alla har vi vår egen företagskultur. Vilka vi är, vad vi står för och hur vi agerar formas av våra värderingar.",
    pTag2:
      "Vår ledning är ett team av starkt sinnade skickliga proffs som har stor erfarenhet av att arbeta på Wall Street. Därför vet de exakt vad som krävs för att vara en framgångsrik näringsidkare. Med sin formidabla bakgrund och affärserfarenhet har de insiktsfull kunskap om alla branschens bästa och värsta metoder.",
    wallStreet:
      "Viljestarka individer med omfattande erfarenhet av wall-street",
    innovation: "Strävar alltid efter innovation och förbättring",
    approach: "Klienten i centrum,",
    weDo: "i allt vi gör",
    values: "Våra värderingar, din framgång!!!",
    pTag3:
      "Vi står på en stabil grund eftersom vi främjar en värdebaserad miljö på alla våra kontor, vilket drivs av vår lednings starka tro på affärsetik.",
    pTag4:
      "Vi håller oss till våra 5 kärnvärden, så att du kan lysa i den globala handelsgemenskapen.",
    h3Tag: "Nöjda kunder i mer än",
    countries: "30 EU-länder*",
    taking: ", tar",
    worldClass: "dra nytta av våra tjänster i världsklass.",
    france: "*Utan Belgien och Frankrike",
    info: "ΕΝΗΜΕΡΩΤΙΚΑ ΣΤΟΙΧΕΙΑ ΕΤΑΙΡΕΙΑΣ/FÖRETAGSINFORMATION",
    data: "ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ/FINANSIELLA UPPGIFTER",
    date1: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2024",
    date: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2024",
    thirtyFirst: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2023",
    thirty: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2023",
    financeStatement: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2022",
    financialData: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2022",
    statement: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2021",
    aTag: {
      li: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2021",
      liTag: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2020",
      liTag1: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2020",
      liTag2: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2019",
      liTag3: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2019",
      liTag4: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2018",
      liTag5: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2018",
      liTag6: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2017",
      liTag7: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2017",
      liTag8: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2016",
      liTag9: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2016",
      li1: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2015",
      li2: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2015",
      li3: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2014",
      li4: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2014",
      li5: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2013",
      li6: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2013",
      li7: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2012",
      li8: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2012",
      li9: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2011",
      liTag10: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2011",
      liTag11: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2010",
      liTag12:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 2015-12-31",
      liTag13:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 2014-12-31",
      liTag14:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 2013-12-31",
      liTag15:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 2012-12-31",
      liTag16:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 2011-12-31",
      liTag17:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 2010-12-31",
    },
    dropdown: {
      title: "ΕΠΟΠΤΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ/ÖVERVAKNINGSINFORMATION",
      aTag2: {
        pillar2024: "Pillar III Disclosure Triple A 2024",
        pillar2023:
          "2023 Rapport om marknadsdisciplin och offentliggörande inom Pelare III",
        pillar2022:
          "2022 Pelare III-rapport om marknadsdisciplin och offentliggörande",
        pillar2021:
          "2021 Pelare III-rapport om marknadsdisciplin och offentliggörande",
        regulatory2023:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2024_α80&87_Ν4261_2014",
        corporateGovernance2022:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2022_α80&87_Ν4261_2014",
        financial2021:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2021_α80 ΕΩΣ 87_Ν4261_2014",
        financial2020:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2020",
        financial2019:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2019",
        financial2018:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2018",
        financial2017:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 2017-12-31",
        financial2016:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2016",
        financial2015:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2015",
        financial2014:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2014",
        financial2013:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2013",
        financial2012:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2012",
        financial2011:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2011",
        financial2010:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2010",
        details2020:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2020_α80 ΕΩΣ 87_Ν4261_2014",
        details2019:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2019_α80 ΕΩΣ 87_Ν4261_2014",
        details2018:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2018_α80 ΕΩΣ 87_Ν4261_2014",
        details2017:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2017_α80 ΕΩΣ 87_Ν4261_2014",
        details2016:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2016_α80 ΕΩΣ 87_Ν4261_2014",
        details2015:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2015_α81&82_Ν4261_2014",
        details2014b:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2015_α80 ΕΩΣ 87_Ν4261_2014",
        details2014:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2014_α81&82_Ν4261_2014",
      },
    },
    announcment: "ΑΝΑΚΟΙΝΩΣΕΙΣ/MEDDELANDEN",
    aTag3: {
      executionVenues2024:
        "2024 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2024 UTFÖRINGSPLATSER",
      executionVenues2023:
        "2023 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2023 AVRÄTTNINGSPLATSER",
      executionVenues2022:
        "2022 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2022 AVRÄTTNINGSPLATSER",
      executionVenues2021:
        "2021 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2021 AVRÄTTNINGSPLATSER",
      executionVenues2020:
        "2020 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2020 AVRÄTTNINGSPLATS",
      executionVenues2019:
        "2019 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2019 AVRÄTTNINGSPLATS",
      executionVenues2018:
        "2018 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2018 AVRÄTTNINGSPLATS",
      executionVenues2017:
        "2017 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2017 AVRÄTTNINGSPLATS",
      generalMeetingInvite2013:
        "ΠΡΟΣΚΛΗΣΗ ΤΑΚΤΙΚΗΣ ΓΕΝΙΚΗΣ ΣΥΝΕΛΕΥΣΗΣ 28-06-2013",
    },
    accordion: "ΟΡΓΑΝΟΓΡΑΜΜΑ/FÖRETAGETS ORGANISATIONSSCHEMA",
    officialOrganization: "AAAFx - Officiellt organisationsschema (HCMC)",
    certifiedEmploy: {
      title: "ΠΙΣΤΟΠΟΙΗΜΕΝΟΙ ΥΠΑΛΛΗΛΟΙ/CERTIFIERADE MEDARBETARE",
    },
    name: "NAMN",
    cretificate: "CERTIFIERING",
    issuer: "ISSUER",
    year: "ÅR",
    table: {
      td: "DIMOPOULOS CHRISTOS",
      td1: "Mottagande, vidarebefordran och utförande av order för tredje mans räkning i värdepapper (A1)",
      td2: "HCMC",
      td0: "DORDA AIKATERINI",
      td3: "Mottagande, vidarebefordran och utförande av order för tredje mans räkning i värdepapper (A1)",
      td4: "KARLIS KONSTANTINOS",
      td5: "Förvaltning av kundens portfölj (C)",
      td6: "KONTOGEORGI ELENI",
      td7: "Mottagande, vidarebefordran och utförande av order för tredje mans räkning i värdepapper (A1)",
      td8: "TZIANOUMI GIANNOULA",
      td9: " Tillhandahållande av investeringsrådgivning i värdepapper, andelar i företag för kollektiva investeringar, penningmarknadsinstrument, derivat och strukturerade finansiella produkter (B)",
      td10: "Värdepappershandlare",
      td11: "ASE",
      td12: "POLYCHRONEAS EFSTRATIOS",
      td13: "Genomföra analyser av finansiella instrument eller emittenter (D)",
    },
    maria: "CHRYSAITOU MARIA ARGYRO",
    investment:
      "Tillhandahållande av investeringsrådgivning i värdepapper, andelar i företag för kollektiva investeringar, penningmarknadsinstrument, derivat och strukturerade finansiella produkter (B)",
    text: "PANAGIOTIS KOURBELIS",
    text1: "Utövare handelsdisk",
    text2: "GEORGIOS KARMIS",
    responsive: {
      trTag: {
        line: "ΟΝΟΜΑΤΕΠΩΝΥΜΟ",
        line1: "ΠΙΣΤΟΠΟΙΗΣΗ",
        line2: "ΦΟΡΕΑΣ",
        line3: "ΕΤΟΣ ΚΤΗΣΗΣ/ΑΝΑΝΕΩΣΗΣ",
        line4: "Δημόπουλος Χρήστος",
        line5: "Λήψη, Διαβίβαση και Εκτέλεση Εντολών σε Κινητές Αξίες (Α1)",
        line6: "Επιτροπή Επιτροπή",
        line7: "Καρλής Κωνσταντίνος",
        line8: "Διαχείριση Χαρτοφυλακίων (Γ)",
        line9: "Επιτροπή Κεφαλαιαγοράς",
        line10: "Κοντογεώργη Ελένη",
        line11: "Ντόρντα Αικατερίνη",
        line12: "Ντόρντα Αικατερίνη Εκτέλεση Εντολών σε Κινητές Αξίες (Α1)",
        line13: "Τζιανούμη Γιαννούλα",
        line14: "Παροχή Επενδυτικών Συμβουλών (Β)",
        line15: "Παναγιώτης Κουρμπέλης",
        line16: "Ασκούμενος Trading Desk",
        line17:
          "ΓΝΩΣΤΟΠΟΙΗΣΕΙΣ ΚΑΝΟΝΙΣΜΟΥ ΑΕΙΦΟΡΙΑΣ (SFDR)/SUSTAINABILITY REGULATION DISCLOSURES (SFDR)",
        line18: "Upplysningar om hållbarhetsreglering (SFDR)",
        line19:
          "Γνωστοποιήσεις Κανονισμού Αειφορίας (SFDR) και Πολιτική Βιωσιμότητας (ESG)",
        line20: "Πιστοποιημένος Διαπραγματευτής Αξιών",
        line21: "Χρηματιστήριο Αξιών Αθηνών",
        line22: "Χρυσαΐτου Μαρία Αργυρώ",
        line23: "Γεώργιος Καρμής",
      },
    },
  },
  faq: {
    heading: "Vanliga frågor och svar",
  },
  comparePlatform: {
    heading: "Jämför handelsplattformar",
    content: '"Ju fler desto bättre"',
    h6Tag:
      "AAAFx ser till att tillhandahålla en enda och den bästa lösningen för varje näringsidkares behov med de många handelsplattformar som erbjuds.",
    pTag: "Varje plattform levereras med de grundläggande förutsättningarna för snabbast möjliga exekveringshastighet, olika anpassningsbara alternativ som gör det möjligt att använda indikatorer och expertrådgivare och de bästa tillgängliga marknadspriserna.",
    condition: "Villkor för handel",
    timeFrames: "Tidsramar",
    leverage: "Hävstångseffekt",
    microLot: "Handel med mikrolotter",
    yes: "Ja",
    scalping: "Hedging och scalping",
    attachment: "EAs/Indikatorer bifogad fil",
    other: "Andra verktyg",
    economic: "Inbyggd ekonomisk kalender",
    no: "Nej",
    report: "Format för kontorapporter",
    html: "HTML",
    language: "Plattformar språkkonverterare",
    priceAlert: "Prisvarningar",
    device: "Enhetens driftskompatibilitet",
    window: "Windows skrivbord",
    mac: "Mac/iPad",
    android: "Android",
    ios: "iOS",
    webBased: "Webbaserad",
    sutability: "Lämplighet",
    beginner: "Nybörjare",
    intermediate: "Mellanliggande",
    advance: "Avancerad",
    openAccount: "Öppna konto",
    platform: "Vilken plattform skulle du vilja ha själv?",
    choice: "Det kan vara ett svårt val. Följande är vad du kan tänka på:",
    point: "Hur enkelt är användargränssnittet för dig?",
    point1: "Vilken plattform passar dina handelsstrategier?",
    point2: "Har ni någon support tillgänglig för den plattformen?",
    point3:
      "När det gäller den sista frågan har vi lösningen. Vi tillhandahåller fullständig teknisk support om du stöter på problem med någon plattform.",
    point4: "För de andra två frågorna kan du öppna en",
    point5: "Demo-konto",
    point6:
      "och vänja dig vid alla nyanser i våra fantastiska handelsplattformar!",
  },
  depWith: {
    heading: "Insättningar och uttag",
    title:
      "En mängd olika enkla och bekväma alternativ, helt utan kostnad från vår sida",
    pTag: "Att sätta in och ta ut pengar från ditt handelskonto har aldrig varit så enkelt! Investera i ditt handelskonto utan att betala någon extra avgift. Vi har olika tillförlitliga insättnings- och uttagsalternativ för att göra din handelsresa smidig och enkel.",
    serviceFee: "0% Serviceavgift",
    charge:
      "Vi tar inte ut några avgifter för vare sig insättningar eller uttag",
    safety: "Transaktioner Säkerhet",
    funds:
      "Medlen förvaras i Tier-1-banker och är åtskilda från bolagets egna medel",
    quickProcessing: "Snabb bearbetning",
    deposit: "Insättningar och uttag hos AAAFX behandlas omedelbart",
    minDeposit: "Minsta insättningsbelopp",
    globalCurrency: "Globala valutor accepteras",
    control: "Ökad kontroll",
    security: "Obligatorisk KYC ger ökad säkerhet",
    with: "AVDRAGNINGAR",
    seamless:
      "Sömlösa uttag gör varje handlare lycklig, eller hur? Det är vad vi strävar efter att göra för våra kunder. Här är några snabba och enkla alternativ att använda för att ta ut dina hårt förtjänade pengar inom 12 timmar.",
    step: "Steg för att ta ut pengar från ditt AAAFx Live-konto:",
    step1: "1. Logga in på klientportalen.",
    step2: '2. Skapa ett bankkonto under "Bank setup".',
    step3: '3. Klicka på "Funds" och sedan på "Withdraw".',
    depositText: "Insättning",
    withdrawal: "Uttag av pengar",
    bankCard: "Bankkort",
    region: "Region",
    currencies: "Valuta",
    min: "Min. Insättning",
    service: "Serviceavgift",
    processing: "Bearbetningstid",
    worldWide: "Över hela världen",
    instant: "INSTANT",
    fund: "FUND",
    bankWire: "Banköverföring",
    days: "2-3 ARBETSDAGAR",
    europe: "Europa",
    southEast: "Sydostasien",
    latinAmerica: "Latinamerika",
    mexico: "Mexiko",
    eastAfrica: "Östafrika",
    global: "Globalt",
    info: "Ytterligare information:",
    step4:
      "1. Alla uttag kommer att behandlas via den metod som användes för att göra en insättning på handelskontot.",
    step5:
      "2. Ingen transaktionsavgift tas ut av AAAFx vare sig vid insättningar eller uttag.",
    step6:
      "3. Vi ersätter transaktionskostnaden som du ådrar dig upp till 5% av ditt insättningsbelopp, till ditt handelskonto.",
    live: "ÖPPNA LIVE-KONTO",
    demo: "ÖPPET DEMOKONTO",
  },
  whiteLabels: {
    banner: {
      menu: {
        white_label: "Vit etikett",
      },
      title: "Vit etikett",
      subtitle: "Vår erfarenhet, din framgång!",
    },
    pamm_content: {
      intro: {
        heading:
          "En unik möjlighet att starta ett eget mäklarföretag med hjälp av vår kunskap, erfarenhet och support.",
      },
      description: {
        paragraph_1:
          "Ett white label-program är ett utmärkt sätt att snabbt skapa en stark position på marknaden. Detta är möjligt med hjälp av vår teknik, oklanderliga handelsvillkor, supporttjänster och användbara CRM-verktyg för backoffice.",
        paragraph_2:
          "AAAFx-teamet är dedikerat till din framgång genom vår tekniska och professionella support.",
        paragraph_3:
          "Vårt white label-program ger dig full flexibilitet att utforma dina produkter och tjänster, så att du kan få den bästa möjligheten att blomstra ditt företag.",
        paragraph_4:
          "Att välja rätt mäklare är det första steget för att uppnå dina önskade mål.",
        paragraph_5: "Gör dig redo och gör rätt val nu!",
      },
    },
    expectations_section: {
      heading: "Vad kan du förvänta dig?",
      list: {
        item_1: "Samarbete med det största sociala handelsnätverket",
        item_2: "Dedikerade kundansvariga för investerare och förvaltare",
        item_3:
          "Flexibilitet när det gäller att fastställa parametrar och villkor för kontot",
        item_4: "Ultralåga provisioner med låga spreadar",
        item_5: "Säkra medel hos en betrodd mäklare",
        item_6: "Liten investering krävs för att starta",
        item_7: "Öppenhet för investerarna - inga dolda klausuler",
        item_8: "Full kontroll för investerare avseende insättningar och uttag",
      },
    },
    contact_section: {
      title:
        "Är du redo att få skräddarsydda lösningar för din nya verksamhet?",
      contact_us: "Kontakta oss nu",
      email_link: "här",
      email_info: "eller skriv till oss på",
      email_address: "support{'@'}aaafx.com",
    },
  },
  vpsHosting: {
    banner: {
      title: "Gratis VPS-hosting",
    },
    bonus_trade_section: {
      description:
        "Handla bekvämt från var som helst i världen utan avbrott i anslutningen och slipp oroa dig för internet eller strömavbrott. Det är viktigt att minimera eventuella fördröjningar när du handlar eftersom en mindre fördröjning kan kosta dig en förmögenhet.",
      customer_approach:
        "I linje med vår kundcentrerade strategi vill vi alltid att våra kunder ska ha den bästa möjliga handelsupplevelsen. AAAFx erbjuder virtuella privata servertjänster utan någon som helst extra kostnad för dig.",
      advantages_title: "Fördelar med att handla med VPS",
      advantages_list: {
        item_1:
          "VPS gör att dina affärer kan utföras när som helst med minsta möjliga fördröjning, vilket leder till mindre slippage.",
        item_2:
          "VPS ger oändlig drift av handelsplattformen och gör den mer lämplig om du använder handelsrobotar eller handelssignaler.",
        item_3:
          "Det gör att du kan handla från vilken plats som helst i världen även om det inte finns någon ordentlig internetanslutning, strömmen går eller systemet kraschar.",
        item_4:
          "VPS erbjuder anonymitet, integritet och säkerhet, vilket gör att du kan handla med sinnesfrid och veta att dina viktiga uppgifter är säkra.",
      },
    },
    accordion_section: {
      how_to_get_vps: {
        title: "Hur kan jag få en gratis VPS?",
        content:
          "Om du är en kund med något höga handelsvolymer (med en insättning på minst 5 000 USD) är du berättigad till en gratis VPS.",
      },
      why_free_vps: {
        title: "Varför ger AAAFX en gratis VPS?",
        content:
          "Vår teknikpartner erbjuder oss VPN-hosting till låg kostnad i utbyte mot stora volymer. Vi gillar att föra vidare de fördelar vi tjänar till våra kunder.",
      },
      lesser_deposit: {
        title: "Vad händer om min insättning är mindre?",
        content:
          "Det är inget problem. Du kan fortfarande använda vår VPS till en mycket låg hyra på endast $ 25 per månad. Denna hyra kommer att dras automatiskt från ditt handelskonto.",
      },
      other_vps: {
        title:
          "Vad händer om jag vill använda någon annan VPS istället för den AAAFx-anpassade VPS:en?",
        content:
          "Om du vill använda din egen VPS eller från en tredje part kan vi ge dig en ersättning för din VPS på upp till 25 USD/månad, förutsatt att din totala nettoinsättning för månaden är minst 5 000 USD. Dela bara med dig av dina VPS-köpdetaljer och månatliga betalningskvitton för att få denna ersättning.",
      },
    },
    vps_configuration_section: {
      title: "Gratis VPS-konfiguration",
      configuration: {
        intel: {
          title: "INTEL",
          description: "Processor",
        },
        ram: {
          title: "1300 MB",
          description: "RAM",
        },
        bandwidth: {
          title: "25 GB",
          description: "Bandbredd",
        },
        disk_space: {
          title: "2 TB",
          description: "Diskutrymme",
        },
      },
    },
    apply_vps_section: {
      title: "Hur ansöker man om gratis VPS?",
      steps: {
        step_1: {
          description: "Öppna ett Live-konto",
        },
        step_2: {
          description: "Insättning minst 5.000 USD eller motsvarande valuta",
        },
        step_3: {
          description: "Mejla oss på",
          email: "support{'@'}aaafx.com",
        },
      },
    },
  },
  tradingCondition: {
    heading: "Villkor för handel",
    pTag: "Funktioner som gör att du handlar mer lönsamt! En handelsmiljö som är bäst lämpad för alla typer av handelsstrategier.",
    h5Tag:
      "Ta en titt på alla villkor och förutsättningar för att planera för en oklanderlig handelsupplevelse:",
    content:
      "AAAFx presenterar handelsvillkor som passar alla handlare - oavsett om det är en nybörjare eller en expert. Vi vill att våra kunder ska handla med största möjliga förtroende och komfort.",
    deepLiquidity: "ECN-handel med djup likviditet",
    buySell:
      "ECN-konton (Electronic Communication Network) är utformade för att matcha köp- och säljorder genom direkt tillgång till likviditetsgaranter.",
    brTag:
      "Genom våra Prime LPs kan vi vidarebefordra de bästa rådande marknadspriserna och likviditeten till alla våra kunder på ett smidigt sätt. Därför får du tillgång till de djupa likviditetspoolerna direkt till en försumbar spreadkostnad.",
    powerfulArsenal: "AAAFx kraftfull handelsarsenal",
    arsenalContent:
      "Vi vet hur viktigt det är att välja en bra handelsplattform för att genomföra din handelsstrategi! Vi har tagit hand om alla dina krav för att handla snabbt med enkel navigering och användargränssnitt och tjäna pengar på över 200+ handelsinstrument som finns tillgängliga på tre fullpackade handelsplattformar - MT4, MT5, ActTrader. Pricken över i:et är anslutningen till Zulu Trade via Zulu Account, som hjälper dig att få omedelbar anslutning till den största sociala handelsgemenskapen.",
    zeroCommission: "Noll provision och rakbladstunna spreadar",
    commissionContent:
      "Vi ger dig de bästa förutsättningarna för att handla till lägsta kostnad. Med vårt ECN plus-konto kan du handla utan provisionskostnader på alla valutapar. Med ultratunna spreadar från 0,0 pips på alla våra handelsbara instrument kan du börja använda vår likviditet av institutionell kvalitet till en mycket låg kostnad. Vi får dessa handelsvillkor från våra förstklassiga likviditetsleverantörer för att ge dig det bästa i din handelsresa.",
    fastExecution: "Blixtsnabbt genomförande",
    executionContent:
      "Den förstklassiga kvaliteten och platsen för våra severs möjliggör snabbast möjliga handelsutförande med en hastighet så snabb som 10 ms. Du kan placera handelsorder på upp till 100 partier. Du är fri från förseningar, rekvisitioner och handelsdiskar. Detta gör vår plattform idealisk för alla typer av handlare - scalpers, nybörjare, EA-användare, manuella handlare etc.",
    fundingOptions: "Många olika finansieringsalternativ",
    fundingContent:
      "Sömlösa insättningar och uttag går långt för att göra din handelsresa enkel och smidig. Du kan välja din insättningsmetod från olika tillgängliga alternativ. Vi vet att varje öre räknas för att finansiera dina handelskonton. Därför tar vi inte ut några avgifter när vi accepterar insättningar eller behandlar uttag. Uttag behandlas ultrasnabbt på ett sömlöst sätt och du får en mängd olika uttagslägen att välja mellan.",
    lowRollover: "Låga Rollover-avgifter",
    rolloverContent:
      "Flera handlare gillar att hålla sina affärer över natten och för det ändamålet spelar swapräntor roll. Varje handelspar har sina egna swapavgifter (utom på islamiska konton). Dessa räntor tillämpas kl. 00:00 servertid. Marknaderna är stängda under helgen, men bankerna beräknar fortfarande ränta även på positioner som innehas under helgen. Så om du har en position över natten på en fredag kommer du att få betala 3X swapränta. Vi erbjuder konkurrenskraftiga och låga swapavgifter så att du har större flexibilitet att bestämma när du vill stänga dina affärer.",
    doubt: "Är du osäker på något handelsvillkor? Prova vår",
    demoAccount: "Demo-konto",
    stayAware: "Var medveten om och använd dig av omfattande",
    calculate: "Kalkylatorer för handel",
    getAll: "för att få alla siffror rätt!",
    liveAccount: "ÖPPNA LIVE-KONTO",
    openAccount: "ÖPPET DEMOKONTO",
  },
  tradingCalculator: {
    title: "Kalkylatorer för handel",
    madeEasy: "Beräkningar som gör det enkelt för dig",
    neverMiss:
      "Gå aldrig miste om handelsvinster på grund av dåliga beräkningar!",
    pTag: "Gör korrekta bedömningar på ett ögonblick genom att använda våra Trading Calculators. Vi är fast beslutna att hjälpa dig att få ut det mesta av dina affärer genom att spara tid och fokusera på viktiga handelsbeslut istället för att ägna dig åt tråkiga beräkningar. Vi har handplockat de mest användbara kalkylatorerna för handel och inkluderat dem här för dig. Du behöver inte ladda ner någonting. Välj bara den kalkylator du vill ha, ange dina ingångar och kalkylatorn ger dig svaret!",
    swap: "Swap-kalkylator",
    margin: "Marginalkalkylator",
    pip: "Pip-kalkylator",
    calculate: "Kalkylator",
  },
  forexStock: {
    innerPages: {
      forex: "Forex",
      indices: "Index",
      commodities: "Råvaror",
      stocks: "Aktier",
      crypto: "Kryptovalutor",
    },
    title: "FOREX",
    trade: "Handla i framstående valutapar med AAAFx",
    min: "min.",
    commission: "Kommissionen",
    execution: "avrättning",
    spread: "Spridning",
    upTo: "Upp till",
    leverage: "Hävstångseffekt",
    paris: "Par",
    contract: "Forex kontrakt",
    specification: "Specifikationer",
    flexible:
      "Mer flexibla handelsvillkor (ökad hävstångseffekt) kan gälla för kunder som klassificeras som Professional. Logga in på ditt konto och kontrollera om du är berättigad till Professional Client-klassificering, eller skriv till oss på",
    email: "support{'@'}aaafx.com",
    instument: "Instrument",
    bid: "Bud",
    ask: "Fråga",
    size: "Kontraktets storlek",
    minTrade: "Min. Handelsstorlek",
    tickValue: "Tick Värde",
    hours: "Öppettider för handel",
    h3Tag: "Vad är Forex Trading?",
    pTag: "Forexmarknaden är en expansiv global marknad för utbyte av de internationella valutorna. Forexhandel är det allmänna köpet och försäljningen av valutor med huvudsyftet att tjäna vinst. Den globala valutamarknaden är den största och mest likvida marknaden i världen, med en daglig transaktionsvolym på mer än 6 biljoner dollar.",
    how: "Hur fungerar det?",
    trading:
      "Valutahandel innebär att man köper en valuta och säljer den för en annan valuta till den rådande marknadskursen. Det finns ingen leverans av någon valuta och skillnaden mellan försäljningspris och inköpspris justeras helt enkelt på handelskontot. Därför är dessa valutapar som Forex CFD: er till Spot-priser.Om du vill handla på kärnvalutamarknaden måste du betala ut hundratusentals dollar. Men med fördelen med hävstångshandel och CFD: er behöver du bara så lite som 100 enheter av en valuta, och du kan börja dra nytta av prisrörelser. Dessutom kan du också dra nytta av räntedifferensen mellan två valutor via swapräntor. Om du håller en öppen position i ett valutapar över natten, och räntan på den valuta du har köpt är högre än räntan på den valuta du har sålt, kommer du att tjäna en del ränteintäkter. Annars kommer du att betala en avgift. Denna ränta kallas swap- eller rollover-ränta.",
    account: "Konto",
    type: "Typer",
    compare: "Jämför kontotyper",
    online: "Vår online",
    tradingText: "Handel",
    platform: "Plattformar",
    desktop: "Skrivbord",
    webTrade: "Webbhandlare",
    android: "Android",
    ios: "iOS",
    learn: "LÄR DIG MER",
    negative: "Negativt saldo",
    protection: "Skydd",
    pSubTag: "Pålitligt skydd av dina medel på AAAFx-konton",
    pTag1:
      "Vi strävar alltid efter att arbeta för våra kunders bästa. När du handlar i volatila tider, om ditt konto blir negativt, har vi fått din rygg! Vi kommer att återställa ditt negativa saldo till noll, så att du inte bär någon extra förlust. Du kan sätta in pengar och börja handla igen. Därför kan du inte förlora mer än vad du sätter in.",
    live: "ÖPPNA LIVE-KONTO",
    demo: "ÖPPET DEMOKONTO",
  },
  pageNotFound: {
    title:
      "Sidan du letar efter kan ha tagits bort, fått ett nytt namn eller är tillfälligt otillgänglig.",
    redirect: "Gå till AAAFx hemsida",
  },
  annualLoser: {
    winner: "Vinnare",
    loser: "Förlorare",
    total: "Totalt",
    percentage: "Procentandel av förlorarna",
    annually: "Årligen",
    semi_annually: "Halvårsvis",
    quaterly: "Kvartalsvis",
    monthly: "Månadsvis",
  },
  safetyFund: {
    title: "Säkerhet för fonder",
    heading: "Integritet, förtroende och full tillförlitlighet",
    safety: "Fonder Trygghet och säkerhet",
    investor:
      "Investerare bör fokusera all sin tid och energi på att bygga effektiva strategier, snarare än att oroa sig för sina fonders säkerhet.",
    protect:
      "Vi finns här för att skydda dina pengar eftersom vår grund vilar på ditt förtroende. Vi vill att du ska investera smart och handla tryggt.",
    heading1: "REGLERAD & BEVAKAD",
    strict:
      "I överensstämmelse med det strikta regelverket från EU:s Hellenic Capital Market Commission (HCMC)",
    responsible: "ANSVARIG FÖRVALTARE",
    client:
      "Kundens pengar förvaras säkert på säkra bankkonton hos pålitliga banker.",
    audit: "SÄRSKILDA REVISIONER OCH",
    review: "GRANSKNING AV EFTERLEVNAD",
    internal:
      "Interna och externa revisioner, dedikerad compliancefunktion för att ständigt granska tillämpningen av rutinerna för kundtillgångar.",
    negativeBalance: "SKYDD AV NEGATIV BALANS",
    pTag: "Kunderna kan inte förlora mer än sitt kontosaldo. Om deras saldo blir negativt återställer vi det till noll",
    funds: "SEGREGERADE FONDER OCH REGISTER",
    companyFunds:
      "Strikt segregering mellan kunder och företagsfonder. En tydlig åtskillnad upprätthålls mellan klientmedel / register och företagets",
    policies: "ROBUSTA IT-POLICYER",
    secure:
      "Säkra webbsocklar på webbplatsen, Cloudflare-teknik och tvåfaktorsautentisering (2FA) finns för alla kundkonton.",
    investorFund: "FOND FÖR ERSÄTTNING TILL INVESTERARE",
    perPerson:
      "AAAFx investerare är skyddade upp till 30.000 euro per person av den grekiska garantifonden i enlighet med det europeiska direktivet 93/22/EEG.",
    security: "Vi strävar alltid efter att garantera din säkerhet.",
    awareness: "Men din medvetenhet och vakenhet är lika viktig:",
    never: "Aldrig",
    click: "klicka på oidentifierade länkar i e-postmeddelanden.",
    unSecured:
      "använda osäkra trådlösa nätverk eller någon annan offentlig enhet för att komma åt finansiella konton.",
    otps: "svara på e-postmeddelanden eller SMS där personlig information eller OTP:er efterfrågas.",
    websites:
      "ange din personliga eller finansiella information på osäkra webbplatser.",
    leave:
      "lämna din enhet utan uppsikt när du är inloggad på säkrade personliga eller finansiella konton.",
    twoFa: "använda ett finansiellt konto utan 2FA.",
  },
  regulations: {
    title: "Föreskrifter och licenser",
    multiple:
      "Vi har flera registreringar och regleringar runt om i världen. Full insyn i våra registreringsuppgifter innebär mer tillförlitlighet, säkerhet och sinnesfrid för våra kunder!",
    capitalMarket: "Hellenic Capital Market Commission (HCMC), Grekland",
    member:
      "Triple A Experts Investment Services Single Member SA är auktoriserat och reglerat i Europeiska unionen av Hellenic Capital Market Commission. (id:2/540/17.2.2010) Skatteidentifikationsnummer: 998281207.",
    h5Tag: "Om HCMC",
    pTag: "Hellenic Capital Market Commission (HCMC) inrättades som en juridisk person i Grekland för att övervaka att kapitalmarknadslagstiftningen tillämpas korrekt. HCMC är medlem av Europeiska värdepappers- och marknadsmyndigheten (ESMA) och International Organization of Securities Commissions (IOSCO).",
    about: "Om MiFID II",
    adopted:
      "Europaparlamentet och rådet antog den 15 maj 2014 direktiv 2014/65/EU om marknader för finansiella instrument och om ändring av direktiv 2002/92/EG och direktiv 2011/61/EU (omarbetning) (MiFID II), som trädde i kraft den 03/01/2018. Syftet är att reglera marknaderna för finansiella instrument för tillhandahållande av investeringstjänster och investeringsverksamhet inom Europeiska ekonomiska samarbetsområdet (EES). MiFID införlivades i den grekiska lagstiftningen genom lag nr 4514/2018. Huvudsyftena med direktivet är att öka effektiviteten, förbättra den finansiella transparensen, öka konkurrensen och erbjuda ett bättre konsumentskydd inom investeringstjänster.",
    gdpr: "Om GDPR",
    aboutGDPR:
      'Den allmänna dataskyddsförordningen (GDPR) anses vara en av de hårdaste integritetslagarna i världen. Den utarbetades och antogs av Europeiska unionen (EU) och trädde i kraft den 25 maj 2018. Den fastställer en rättslig ram som anger riktlinjer för insamling och fri rörlighet för personuppgifter för individer inom Europeiska unionen (EU). "AAAFx" och dess närstående företag, inklusive dess dotterbolag, filialer, representationskontor, styrelseledamöter, tjänstemän och anställda vidtar alla rimliga åtgärder för att följa GDPR.',
    investor: "Om Investor Compensation Fund",
    hcmc: "AAAFx investerare skyddas av den grekiska garantifonden i enlighet med det europeiska direktivet 93/22/EEG. Om ett värdepappersföretag inte fullgör sina skyldigheter kommer den grekiska garantifonden att agera för att kompensera investerarna upp till 30 000 euro per person. Den grekiska garantifonden finansieras av medlemmarna i ATHEX (Athens Exchange) och står under tillsyn av HCMC.",
    group: "Koncernens regelverk",
    sector: "Financial Sector Conduct Authority (FSCA), Sydafrika",
    southAfrica:
      "Sikhula Venture Capital (Pty) Ltd. är auktoriserat och reglerat i Sydafrikas Financial Sector Conduct Authority (FSCA). (Licensnummer: 2017/315029/07).",
    view: "Visa licens",
    register: "Registreringar i andra jurisdiktioner",
  },
  homePage: {
    h3tag: "Framtiden för FOREX är...",
    h1tag: "ULTRA-LÅG provision!",
    ul: {
      lTag: "Råa bredbara pålägg",
      strong: "från",
      strong1: "0.0",
      lTag1: "pips",
      lTag2: "Hävstångseffekt upp till",
      strong2: "500x*",
      supTag: "professionella kunder",
      lTag3: "och EU:s förordningar och registreringar",
      lTag4: "Insättningar och uttag*",
    },
    liveAccount: "ÖPPNA LIVE-KONTO",
    demoAccount: "ÖPPET DEMOKONTO",
    tabs: {
      forex: "Forex",
      indices: "Index",
      commodities: "Råvaror",
      stocks: "Aktier",
      cryptoCurrencies: "Kryptovalutor",
    },
    forex: {
      title: "70+ FX-par",
      point1: "1",
      content: "Världens mest likvida marknad",
      pTag: "Få tillgång till världens mest likvida marknader",
      point2: "2",
      h5Tag: "Handla mikropartistorlekar",
      pTag1:
        "Handla enligt vilken strategi som helst, mikropartier upp till 100 partier",
      point3: "3",
      h5Tag1: "Avancerade diagramindikatorer",
      pTag2:
        "Använd våra fantastiska handelsplattformar med avancerade verktyg",
      startTrading: "START TRADING",
      tryDemo: "PRÖVA EN DEMO",
      tableRow: {
        tableHeading: {
          pair: "Par",
          bid: "Bud",
          ask: "Fråga",
          spread: "Spreadar",
          trade: "Handel",
        },
      },
      buySell: "KÖPA/SÄLJA",
      SeeAll: "Se alla",
    },
    indices: {
      title: "11+ Index",
      point1: "1",
      content: "Handeln växer ständigt Index",
      pTag: "såsom DOW JONES, S&P 500, Nasdaq och många fler...",
      point2: "2",
      h5Tag: "Låga spreadar och låga marginalsäkerhetskrav",
      pTag1:
        "Vi har de minsta spreadarna, hög hävstångseffekt på alla globala index",
      point3: "3",
      h5Tag1:
        "Diversifiera - handla med en portfölj, inte med en enskild aktie",
      pTag2: "Vi erbjuder alla större globala index för handel",
      startTrading: "START TRADING",
      tryDemo: "PRÖVA EN DEMO",
      tableRow: {
        tableHeading: {
          pair: "Par",
          bid: "Bud",
          ask: "Fråga",
          spread: "Spreadar",
          trade: "Handel",
        },
      },
      buySell: "KÖPA/SÄLJA",
      SeeAll: "Se alla",
    },
    commodities: {
      title: "9 Råvaror",
      point1: "1",
      content: "Brett utbud av råvaror",
      pTag: "Alla större ädelmetaller, olja och naturgas tillgängliga",
      point2: "2",
      h5Tag: "Investera mindre, få ut mer",
      pTag1: "Få tag på värdefulla tillgångar enkelt med hävstångseffekt",
      point3: "3",
      h5Tag1: "Noll latens, minimala avvikelser",
      pTag2: "Minimal påverkan av volatilitet med exekveringshastighet 10 ms.",
      startTrading: "START TRADING",
      tryDemo: "PRÖVA EN DEMO",
      tableRow: {
        tableHeading: {
          pair: "Par",
          bid: "Bud",
          ask: "Fråga",
          spread: "Spreadar",
          trade: "Handel",
        },
      },
      buySell: "KÖPA/SÄLJA",
      SeeAll: "Se alla",
    },
    stocks: {
      title: "100+ aktier",
      point1: "1",
      content: "Handla Blue Chip-aktier",
      pTag: "Dra in pålitliga blue-chip-aktier i din portfölj",
      point2: "2",
      h5Tag: "Tjäna utdelning utan att äga aktier",
      pTag1: "Tjäna spännande utdelningsinkomster från förstklassiga företag",
      point3: "3",
      h5Tag1: "Gå lång eller gå kort, enligt marknaden",
      pTag2:
        "Handla inte bara med stigande utan även med fallande aktier, med vilken handelsstrategi som helst",
      startTrading: "START TRADING",
      tryDemo: "PRÖVA EN DEMO",
      tableRow: {
        tableHeading: {
          pair: "Par",
          bid: "Bud",
          ask: "Fråga",
          spread: "Spreadar",
          trade: "Handel",
        },
      },
      buySell: "KÖPA/SÄLJA",
      SeeAll: "Se alla",
    },
    crypto: {
      title: "6 Kryptovalutor",
      point1: "1",
      content: "Handla pengar genom att snurra krypton",
      pTag: "Handla med de mest lukrativa tillgångarna i dagens tidsålder",
      point2: "2",
      h5Tag:
        "De mest kraftfulla kryptovalutorna direkt på din handelsplattform",
      pTag1: "Alla större kryptovalutor tillgängliga för handel",
      point3: "3",
      h5Tag1: "Tillförlitlig handel med volatila tillgångar",
      pTag2:
        "Ha tillgång till djup likviditet med en reglerad, pålitlig mäklare",
      startTrading: "START TRADING",
      tryDemo: "PRÖVA EN DEMO",
      tableRow: {
        tableHeading: {
          pair: "Par",
          bid: "Bud",
          ask: "Fråga",
          spread: "Spreadar",
          trade: "Handel",
        },
      },
      buySell: "KÖPA/SÄLJA",
      SeeAll: "Se alla",
    },
    youShouldJoin: "Varför du bör gå med",
    aaafx: "AAAFx",
    content: {
      h3Tag: "Förstklassiga handelsvillkor",
      ul: {
        liTag: "Snabbast möjliga handelsutförande med spreadar nära noll",
        liTag1: "Låga avgifter för provision och rollover",
        liTag2: "Alla handelsstrategier tillåtna",
        liTag3: "Inga dolda påslag",
      },
    },
    content1: {
      h3Tag: "Säkerhet och tillförlitlighet",
      ul: {
        liTag: "EU-reglerad mäklare.",
        liTag1: "Registreringsnummer: 2/540/17.2.2010.",
        liTag2: "Skydd mot negativ balans.",
        liTag3: "Strikt efterlevnad av fiduciary compliance.",
      },
    },
    content2: {
      h3Tag: "14 års erfarenhet av branschen",
      ul: {
        liTag: "I branschen sedan mer än ett decennium",
        liTag1: "Team av kunniga och erfarna yrkesmän",
        liTag2: "Pålitlig och transparent mäklare",
        liTag3: "Djup förståelse för handlarnas behov",
      },
    },
    content3: {
      h3Tag: "Deep Liquidity Pool",
      ul: {
        liTag: "Likviditet av institutionell kvalitet",
        liTag1: "Inga krav och minimal glidning",
        liTag2: "Garanterad likviditet på alla prisnivåer",
        liTag3: "Lämplig för handel med höga volymer",
      },
    },
    content4: {
      h3Tag: "Teknik",
      ul: {
        liTag: "Avancerad intern teknik",
        liTag1: "Servrar i förstklassiga Equinix-datacenter",
        liTag2: "Snabbaste exekveringshastighet under 10 ms",
        liTag3: "Gratis samlokaliserad VPS som ger ännu lägre latens",
      },
    },
    content5: {
      h3Tag: "Ultrasnabba uttag",
      ul: {
        liTag: "Gratis uttag inom 24 timmar",
        liTag1: "Inga begränsningar av belopp eller frekvens",
        liTag2: "Flera flexibla uttagsalternativ",
        liTag3: "Behandling av uttag med hög säkerhet",
      },
    },
    rawSpread: "Raw Spreads, noll provision",
    plusAccount: "på valutapar med ett ECN plus-konto",
    pTag: " AAAFx är här för att minska spänningen och provisionerna från din handelsresa. Ja, du läste det rätt! Vi har plats för dig att manövrera en billig handelsupplevelse med oss. För mer information om AAAFx",
    clickHere: "Klicka här",
    brTag:
      "Vi ger dig full potential för att uppnå bästa möjliga resultat. Med hjälp av toppmodern teknik har vi bemyndigat oss att ge dig omedelbar tillgång till djup likviditetspool till låg kostnad.",
    ecn: "ECN",
    commission: "Kommissionen",
    minSpread: "min. Sprid ut",
    minDeposit: "min. Insättning",
    plus: "plus",
    forexCommission: "Provision på Forex",
    pips: "pips",
    compare: "Jämför kontotyper",
    experience:
      "Erfaren, betrodd och reglerad med ett löfte om skydd av dina medel",
    security: "Säkerhet är inte en produkt, utan en process.",
    strongValue:
      "Med ett starkt värdesystem levererar vi en handelsupplevelse i världsklass. Vi följer ett strikt regelverk för att skydda dina medel. Vi står under tillsyn av Hellenic Capital Market Commission (HCMC), som styrs av grekisk och europeisk lagstiftning.",
    ourClient:
      "Våra kunder litar på oss eftersom vi vidtar alla åtgärder för att säkerställa säkerheten för deras medel och sömlöst utförande av deras affärer.",
    success: "Handel med fred, handel för framgång!",
    live: "ÖPPNA LIVE-KONTO",
    demo: "ÖPPET DEMOKONTO",
    zuluTrade: "ZuluTrade",
    treasure: "En skattkammare för Forex Traders!",
    copyTrade: "Kopiera en handelsmästare eller bli en!",
    socialTrading:
      "Få tillgång till det största sociala handelsnätverket genom en pålitlig mäklare med vårt Zulu-konto. Det låter dig automatiskt kopiera affärer från några framgångsrika handlare som visar upp sina livehandelsprestanda.",
    investor:
      "av sina investerare gör vinster när de kopierar topphandlare korrekt.",
    topTrader: "Bli en topphandlare eller följ en topphandlare.",
    yourTrading: "Din handel",
    arsenal: "Arsenal",
    actTrader: "Act Trader",
    mostAdvance: "Mest avancerade tekniken",
    comming: "Kommer snart",
    desktop: "Skrivbord",
    ios: "iOS",
    android: "Android",
    web: "Webb",
    mt4: "MetaTrader 4",
    popularPlatform: "Mest populära plattform",
    mt5: "MetaTrader 5",
    nextGen: "Nästa generations plattform",
    firstTrade: "Gör din första affär med AAAFx på mindre än 15 minuter",
    register: "Registrera",
    min: "Inom en minut",
    kyc: "KYC",
    photo: "Giltig fotolegitimation",
    addressProof: "Ett aktuellt adressbevis",
    deposit: "Insättning",
    instantly: "Omedelbart",
    method: "Över 5 insättningsmetoder",
    trade: "Handel",
    range: "En rad olika marknader",
    spread: "Råa bredbara pålägg",
    ultraLow: "Ultra-låg provision",
    create: "SKAPA DITT KONTO",
  },
  contactUsPage: {
    heading: "Kontakta oss",
    headingDescription: "Vårt supportteam finns här för dig 24/5",
    requestCallBack: "Begär ett återuppringningssamtal:",
    FullName: "Fullständigt namn",
    EmailAddress: "E-postadress",
    PhoneNumber: "Telefonnummer",
    Are_you_an_existing_client: "Är du en befintlig kund?",
    Yes: "Ja",
    No: "Nej",
    Select_your_Timezone: "Välj din tidszon",
    How_can_we_help_you: "Hur kan vi hjälpa dig?",
    Select_a_topic: "Välj ett ämne",
    NewAccounts: "Nya konton",
    CustomerSupport: "Kundtjänst",
    TechnicalQueries: "Tekniska frågor",
    IBProgram: "IB-programmet",
    PAMM_Accounts: "PAMM-konton",
    WhiteLabel: "Vit etikett",
    BestTimeToCallMessage:
      "När är bästa tiden att ringa dig? Vänligen välj här",
    SelectPreferredTime: "Välj önskad tid",
    eightAM: "8:00",
    tenAM: "10:00",
    twelveNoon: "12:00",
    twoPM: "14:00",
    fourPM: "16:00",
    sixPM: "18:00",
    eightPM: "20:00",
    Message: "Meddelande",
    I_agree_to_AAAFx: "Jag håller med om AAAFx's",
    PrivacyPolicy: "Integritetspolicy",
    LiveChat: "Chatt i realtid",
    AvailableMondayToFriday: "(24/5, måndag-fredag)",
    CallUs: "Ring oss",
    GreeceAndAthens: "Grekland, Aten",
    GreeceAndAthensContactNumber: "+30 213 0176300",
    AvailableMondayToFridayTime: "Måndag till fredag 9:00-18:00",
    EmailAddresses: "E-postadresser",
    Support: "STÖD",
    Complaints: "KLAGOMÅL",
    FollowUs: "Följ oss",
    RegisteredAddress: "Registrerad adress",
    ProvidedRegisteredAddressOne:
      "Triple A Experts Investment Services Single Member S.A.",
    ProvidedRegisteredAddressTwo: "580 Vouliagmenis Avenue 16452",
    ProvidedRegisteredAddressThree: "Argyroupoli Attika, Greece",
  },
  depositBonusPage: {
    heading: "Insättningsbonus",
    headingDescription: "Varför nöja sig med mindre?",
    subHeadingOne: "Med AAAFX Bonus kan du handla dubbelt med samma insättning",
    subHeadingOneDescription:
      "Vi tillhandahåller för närvarande ett kampanjerbjudande om att utnyttja gratis kredit (aka bonuspengar) i samma belopp som du gör din insättning. Dessa bonuspengar fördubblar omedelbart din marginal så att du kan handla mer och potentiellt tjäna mer.",
    What_is_Bonus: "Vad är bonus?",
    What_is_Bonus_desc:
      "Bonus läggs till som en extra marginal på ditt handelskonto. Den läggs direkt till som en kredit på ditt handelskonto och ökar ditt handelskontos totala eget kapital.",
    Why_should_I_avail_Bonus: "Varför ska jag använda Bonus?",
    Why_should_I_avail_Bonus_pointOne:
      "Dubbel handelsmarginal tillgänglig utan extra kostnad",
    Why_should_I_avail_Bonus_pointOne_desc:
      "Låt oss säga att du sätter in $ 1,000, vi lägger till ytterligare $ 1,000 till ditt konto. Därför får du ett totalt kapital på 2,000 XNUMX dollar att handla med. Du kan använda de gratis bonuspengarna direkt när du har gjort insättningen.",
    Why_should_I_avail_Bonus_pointTwo:
      "Omedelbart tillskott av extra medel på kontot",
    Why_should_I_avail_Bonus_pointTwo_desc:
      'För att utnyttja bonus måste du helt enkelt logga in på ditt säkra kundområde efter att du har gjort insättningen och klicka på "Avail Bonus". Den läggs till direkt på ditt handelskonto.',
    Why_should_I_avail_Bonus_pointThree:
      "VINSTEN FRÅN BONUSEN ÄR HELT OCH HÅLLET DIN",
    Why_should_I_avail_Bonus_pointThree_desc:
      "Du är inte skyldig oss något från de vinster du tjänar antingen från handel med din egen insättning eller den bonus som vi lägger till. Du kan ta ut alla vinster som du tjänar på ditt konto när du vill.",
    Why_should_I_avail_Bonus_pointFour: "Fördröjd stoppnivå",
    Why_should_I_avail_Bonus_pointFour_desc:
      'En annan fördel med att använda bonuspengarna är att i händelse av en olycklig draw drown, blir ditt kontos Stop-out försenat. Dina affärer kommer inte att tvingas stängas av systemet förrän "ALLA" av dina egna medel går förlorade i handeln. Den vanliga stoppnivån är 50%, dvs. när ditt förhållande mellan "Eget kapital" och "Begagnad marginal" når 50%, stoppas ditt konto. Denna extra kudde ger en ytterligare möjlighet för handeln att gå i motsatt riktning och potentiellt bli lönsam.',
    Why_should_I_avail_Bonus_pointFive:
      "Vi backar upp dig för alla negativa balans",
    Why_should_I_avail_Bonus_pointFive_desc:
      "Om du råkar förlora dina egna medel och ditt saldo blir negativt, ger vi dig fullt skydd. Du kan inte förlora mer än vad du sätter in. Vi återställer ditt negativa kontosaldo till noll.",
    Why_should_I_avail_Bonus_pointSix: "Kan mina förluster kvittas mot bonus?",
    Why_should_I_avail_Bonus_pointSix_desc:
      "Förluster kan inte doppas i bonus. När alla dina egna medel har gått förlorade i handeln kommer alla öppna affärer att stängas till rådande marknadspriser.",
    ReadAllTermsCondition: "Läs alla villkor och bestämmelser för bonus",
    here: "här",
    ClaimBonus: "ANSÖK OM BONUS",
    ClaimBonusQuestion:
      "Har du några frågor? Kontakta oss på Live Chat eller skriv till oss på",
  },
  depositWithdrawalPage: {
    heading: "Insättningar och uttag",
    headingDescription:
      "En mängd olika enkla och bekväma alternativ, helt utan kostnad från vår sida",
    subHeading:
      "Att sätta in och ta ut pengar från ditt handelskonto har aldrig varit så enkelt! Investera i ditt handelskonto utan att betala någon extra avgift. Vi har olika tillförlitliga insättnings- och uttagsalternativ för att göra din handelsresa smidig och enkel.",
    subHeadingPointOne: "0% Serviceavgift",
    subHeadingPointOneDesc:
      "Vi tar inte ut några avgifter för vare sig insättningar eller uttag",
    subHeadingPointTwo: "Transaktioner Säkerhet",
    subHeadingPointTwoDesc:
      "Medlen förvaras i Tier-1-banker och är åtskilda från bolagets egna medel",
    subHeadingPointThree: "Snabb bearbetning",
    subHeadingPointThreeDesc:
      "Insättningar och uttag med AAAFx behandlas omedelbart",
    subHeadingPointFour: "$100",
    subHeadingPointFourDesc: "Minsta insättningsbelopp",
    subHeadingPointFive: "10+",
    subHeadingPointFiveDesc: "Globala valutor accepteras",
    subHeadingPointSix: "Ökad kontroll",
    subHeadingPointSixDesc: "Obligatorisk KYC ger ökad säkerhet",
    WithdrawalUpperCase: "AVDRAGNINGAR",
    WithdrawalDesc:
      "Sömlösa uttag gör varje handlare lycklig, eller hur? Det är vad vi strävar efter att göra för våra kunder. Här är några snabba och enkla alternativ att använda för att ta ut dina hårt förtjänade pengar inom 24 timmar.",
    StepsToWithdrawal: "Steg för att ta ut pengar från ditt AAAFx Live-konto",
    StepsToWithdrawalPointOne: "Logga in på klientportalen.",
    StepsToWithdrawalPointTwo: 'Upprätta ett bankkonto under "Bank setup".',
    StepsToWithdrawalPointThree: 'Klicka på "Fonder" och sedan på "Uttag".',
    Deposit: "Insättning",
    Withdrawals: "Uttag av pengar",
    BankCards: "Bankkort",
    Region: "Region",
    Currencies: "Valuta",
    MinDeposit: "Min. Insättning",
    ServiceFee: "Serviceavgift",
    ProcessingTime: "Bearbetningstid",
    WorldWide: "Över hela världen",
    EUR: "EUR",
    USD: "USD",
    CHF: "CHF",
    GBP: "GBP",
    JPY: "JPY",
    AUD: "AUD",
    BGN: "BGN",
    zero: "0",
    ten: "10",
    instantCaps: "INSTANT",
    fundCaps: "FUND",
    BankWire: "Banköverföring",
    twoToThreeBusinessDays: "2-3 ARBETSDAGAR",
    MY: "MY",
    TH: "TH",
    ID: "ID",
    PH: "PH",
    VN: "VN",
    BTC: "BTC",
    AdditionalInformation: "Ytterligare information",
    AdditionalInformationPointOne:
      "Alla uttag kommer att behandlas via den metod som användes för att göra en insättning på handelskontot.",
    AdditionalInformationPointTwo:
      "Ingen transaktionsavgift tas ut av AAAFx vare sig vid insättningar eller uttag.",
    AdditionalInformationPointThree:
      "Vi ersätter transaktionskostnaden som du ådrar dig upp till 5% av ditt insättningsbelopp, till ditt handelskonto.",
    CapsOpenLiveAccount: "ÖPPNA LIVE-KONTO",
    CapsOpenDemoAccount: "ÖPPET DEMOKONTO",
    DepositUpperCase: "DEPOSITIONER",
    DepositDesc:
      "Vad är viktigare än att sätta in pengar på ett säkert sätt på ditt handelskonto? Börja din handelsresa med en minsta insättning på bara 10 USD. Vi erbjuder ett brett utbud av alternativ som du kan använda för att finansiera ditt handelskonto.",
    Steps_to_make_a_deposit:
      "Steg för att göra en insättning på ditt AAAFx Live-konto",
    Steps_to_make_a_deposit_pointOne: "Logga in på klientportalen.",
    Steps_to_make_a_deposit_pointTwo:
      'Klicka på "Fonder" och sedan på "Insättning".',
    Bitcoin: "Bitcoin",
    uptoThirtyMin: "Upp till 30 minuter",
    e_wallets: "E-plånböcker",
    depositNoteOne:
      "Vid överbelastning av nätverket kan Bitcoin-transaktioner ta flera timmar.",
    depositNoteTwo:
      "För banköverföringar täcker AAAFx endast de avgifter som tillämpas av vår mottagande bank, dvs Eurobank och upp till ett belopp på 25 USD. AAAFx känner inte till några andra avgifter som kan tas ut av avsändaren eller någon annan förmedlande bank och därför kommer dessa avgifter inte att täckas.",
    EuroBankCaps: "EUROBANK",
    Currency: "Valuta",
    SwiftCode: "Swift-kod",
    BeneficiaryName: "Förmånstagarens namn",
    ProvidedBeneficiaryName: "TRIPPEL A EXPERTER",
    ProvidedBeneficiaryNameTwo: "TRIPLE A EXPERTS INVESTMENT SERVICES SA",
    IBAN: "IBAN",
    Address: "Adress",
    ProvidedAddress: "Akti Kondili 26-28, 18545 Piraeus, GREECE",
    ProvidedAddressTwo: "Chemin de la Crétaux 33, 1196 Gland, Schweiz",
    ProvidedSwiftCode: "ERBKGRAA",
    ProvidedSwiftCodeTwo: "SWQBCHZZXXX",
    IBANCodeOne: "GR9502600590000421200023114",
    IBANCodeTwo: "GR3202600590000410200460346",
    IBANCodeThree: "GR9702600590000441200009691",
    IBANCodeFour: "GR4202600590000451200009759",
    IBANCodeFive: "GR0602600590000411200012446",
    IBANCodeSix: "GR6202600590000441200012358",
    IBANCodeSeven: "GR5402600590000471200017496",
    IBANCodeEight: "CH0708781000097621100",
    Warning: "Varning",
    WarningMessage:
      "Inkludera alltid din e-post, ditt fullständiga namn och ditt kontonummer (bara e-post och fullständigt namn för nya konton) i uppgifterna om den utgående överföringen för omedelbar behandling. Annars kan AAAFx försena din insättning.",
    swissubebankSA: "SWISSYUBE BANK SA",
  },
  stocksPage: {
    Forex: "Forex",
    Indices: "Index",
    Commodities: "Råvaror",
    Stocks: "Aktier",
    Cryptocurrencies: "Kryptovalutor",
    heading: "STOCKS",
    headingDescription:
      "Investera dina andelar i världens största blue-chip-aktier",
    min: "min",
    zeroPointZeroSeventyFive: "0.075",
    zeroPointZero: "0.0",
    five: "5",
    one: "1",
    Commission: "Kommissionen",
    minExecution: "min. utförande",
    tenMiliSeconds: "10 ms",
    Spread: "Spridning",
    hundredPlus: "100+",
    UpTo: "Upp till",
    Leverage: "Hävstångseffekt",
    StocksContract: "Aktier Kontrakt",
    Specifications: "Specifikationer",
    StocksContractSpecifications:
      "Mer flexibla handelsvillkor (ökad hävstångseffekt) kan gälla för kunder som klassificeras som Professional. Logga in på ditt konto och kontrollera om du är berättigad till Professional Client-klassificering, eller skriv till oss på",
    supportMail: "support{'@'}aaafx.com",
    Instrument: "Instrument",
    Bid: "Bud",
    Ask: "Fråga",
    ContractSize: "Kontraktets storlek",
    MinTradeSize: "Min. Handelsstorlek",
    TickValue: "Tick Värde",
    TradingHours: "Öppettider för handel",
    sevenAM: "7:00 på morgonen",
    twelvePM: "12:00 på eftermiddagen",
    Treasury_products_description:
      "Treasury-produkter har en kvartalsvis utgång (se tabellen nedan). Kunder som har en öppen position på förfallodagen kommer att stängas vid vårt bud/erbjudande kl. 21:00 GMT för BUND, den enda konsekvensen av detta är att kunden kommer att realisera eventuell flytande P/L vid tidpunkten för stängningen. Det finns inga rollovers för alla Treasury-kontrakt som erbjuds.",
    ExpirationDateCaps: "UTGÅNGSDATUM",
    Bund: "Bund",
    CORNF: "CORNF",
    WHEATF: "WHEATF",
    SOYF: "SOYF",
    seventhDecemberTwentyTwentyOne: "7 december-21",
    twentysixNovemberTwentyOne: "26 november-21",
    twentysevenNovemberTwentyOne: "27 november-21",
    twentyFourFebruaryTwentyTwo: "24-feb-22",
    twentyNineDecemberTwentyOne: "29 december-21",
    WhatisStocksCFD: "Vad är CFD-handel med aktier?",
    WhatisStocksCFDDesc:
      "Aktie-CFD:er är ett billigt sätt att dra nytta av prisrörelser i aktiekurserna för toppföretag. Den stora fördelen med att handla med CFD-aktier jämfört med aktier är det låga kapitalkravet. När du handlar med aktier måste du betala hela priset för en aktie. Men när det gäller CFD-aktier får du inte det faktiska ägandet av aktier och därför betalar du bara en liten andel av priset, bara för att dra nytta av prisrörelserna. Du får också utnyttja hävstångseffekten för att maximera din intjäningspotential.",
    How_does_it_work: "Hur fungerar det?",
    How_does_it_work_desc:
      "När du handlar med CFD-aktier äger du inte aktien du investerar i. Du sätter helt enkelt in en liten marginal, mycket lägre än den faktiska kostnaden för aktien, och drar nytta av fördelarna med hävstångshandel. Vinsterna eller förlusterna beräknas genom att subtrahera köpkursen och från försäljningskursen och sedan multiplicera resultatet med din positionsstorlek. Till exempel, för att köpa motsvarande 100 Facebook-aktie-CFD:er hos oss kan du bara behöva en insättning på 20 % av det totala positionsvärdet jämfört med vad du skulle betala för att köpa fysiska aktier. Låt oss säga att aktiekursen är 320 USD. Nu skulle du bara behöva sätta in 6400 USD i marginal hos oss (20 % av 32 000 USD = 6400 USD), exklusive provisionen. Om du däremot skulle köpa samma antal aktier direkt från en aktiemäklare skulle du behöva betala hela 32 000 USD, plus provision och skatter.",
    Account: "Konto",
    Types: "Typer",
    ECN: "ECN",
    plus: "plus",
    zulu: "zulu",
    DepositMin: "Insättning (min.)",
    hundred: "100",
    tenThousand: "10,000",
    CommissionPerLakh: "Provision (per 100 000 USD)",
    zeroPointZeroNinetyThree: "0.093",
    SpreadMin: "Spridning (min.)",
    CompareAccountTypes: "Jämför kontotyper",
    OurOnline: "Vår online",
    Trading: "Handel",
    Platforms: "Plattformar",
    Desktop: "Skrivbord",
    WebTrader: "Webbhandlare",
    Android: "Android",
    iOS: "iOS",
    LeranMore: "LÄR DIG MER",
    NegativeBalance: "Negativt saldo",
    Protection: "Skydd",
    ReliableProtectionHeading: "Pålitligt skydd av dina medel på AAAFx-konton",
    ReliableProtectionDescription:
      "Vi strävar alltid efter att arbeta för våra kunders bästa. När du handlar i volatila tider, om ditt konto blir negativt, har vi fått din rygg! Vi kommer att återställa ditt negativa saldo till noll, så att du inte bär någon extra förlust. Du kan sätta in pengar och börja handla igen. Därför kan du inte förlora mer än vad du sätter in.",
    OpenLiveAccount: "ÖPPNA LIVE-KONTO",
    OpenDemoAccount: "ÖPPET DEMOKONTO",
  },
  referAndEarnPage: {
    heading: "Referera och tjäna",
    headingDescription: "Ju mer du delar, desto mer får du",
    startsWithSharing: "Allt börjar med att dela med sig!",
    startsWithSharingDescOne:
      "Känner du någon som du vill introducera till trading? Tja, de kan tjäna pengar åt dig. Bjud in dina vänner att gå med i AAAFx via din unika värvningslänk. Du och din värvning tjänar 25 USD vardera.",
    startsWithSharingDescTwo:
      "Öka helt enkelt din inkomst utan att ta några extra kostnader. Ju fler vänner du värvar, desto mer tjänar du!",
    startsWithSharingDescThree:
      "Håll alltid koll på ditt konto med våra rapporteringsverktyg i realtid och övervaka statusen för dina värvningar för att maximera dina intäkter:",
    startsWithSharingDescThreePointOne:
      "Få din unika referenslänk när och om det behövs.",
    startsWithSharingDescThreePointTwo: "Se hur mycket du har tjänat hittills",
    startsWithSharingDescThreePointThree: "Kontrollera remisshistorik",
    startsWithSharingDescThreePointFour: "Alltid tillgång till statistik",
    How_to_get_started: "Hur kommer man igång?",
    How_to_get_started_pointOne: "Logga in på ditt säkra kundområde",
    How_to_get_started_pointTwo:
      "Hämta din värvningslänk och dela med dig till dina vänner.",
    How_to_get_started_pointThree:
      "Tjäna $25 när dina värvningar registrerar sig och kvalificerar sig.",
    WhatDoYourReferrals: "Vad måste dina värvningar göra?",
    WhatDoYourReferralsDescOne:
      "Dina värvningar behöver bara använda din värvningslänk för att registrera sig hos oss. Om de missar att göra det är det inget problem! De kan",
    WhatDoYourReferralsDescTwo:
      "kom bara över Live Chat och låt oss veta att de kom genom dig. Vi kommer att lägga till dem i din lista över referenser.",
    Benefits_to_you: "Fördelar för dig",
    Benefits_to_you_pointOne: "Obegränsade intäkter från referenser.",
    Benefits_to_you_pointTwo:
      "När du har hänvisat 10 kunder kan du antingen fortsätta i Refer and Earn-planen eller byta till IB-programmet.",
    Benefits_to_you_pointThree: "Spårning av dina intäkter i realtid.",
    Benefits_to_you_pointFour:
      "Locka kunder med våra lukrativa kampanjerbjudanden inklusive bonus.",
    Benefits_to_you_pointFive: "24/5 kundsupport och personlig kundansvarig.",
    Benefits_to_your_referrals: "Fördelar för dina remitteringar",
    Benefits_to_your_referrals_pointOne:
      "Njut av våra oklanderliga handelsvillkor.",
    Benefits_to_your_referrals_pointTwo:
      "Tjäna Referral Reward, precis som den som värvat dig.",
    Benefits_to_your_referrals_pointThree:
      "Dra nytta av våra helt integrerade konton med ZuluTrading.",
    Benefits_to_your_referrals_pointFour:
      "Dra nytta av våra kampanjer, inklusive bonus och lojalitetsprogram.",
    Benefits_to_your_referrals_pointFive:
      "Använda sin egen referenslänk och ta med sina egna kunder.",
    How_is_AAAFx_Refer_and: "Hur är AAAFx Refer and",
    Earn_Plan_different_from_the_IB_Program:
      "Earn Plan skiljer sig från IB-programmet?",
    How_is_AAAFx_Refer_desc:
      "Även om båda programmen låter likadana är de ganska olika varandra. Här är de viktigaste skillnaderna",
    Feature: "FEATURE",
    referandEarnPlan: "VÄRVA OCH TJÄNA PENGAR-PLAN",
    IBProgram: "IB-PROGRAM",
    Earnings: "Intäkter",
    EarningsPointOneP1: "$25 till dig och din referens; upp till",
    EarningsPointOneP2: "10 kunder (ändras till $20 efter",
    EarningsPointOneP3: "10 kvalificerade kunder)",
    EarningsPointTwop1: "20% provisionsandel i Standard IB",
    EarningsPointTwop2: "Program och skräddarsydd aktie i",
    EarningsPointTwop3: "Avancerat IB-program",
    Earning_frequency: "Intjäningsfrekvens",
    Earning_frequency_p1: "Engångsbelöning",
    Earning_frequency_p2: "Livslånga uppdrag",
    Live_tracking: "Spårning i realtid",
    Yes: "Ja",
    No: "Nej",
    View_of_referrals_activities: "Visning av remissernas aktiviteter",
    Limited: "Begränsad",
    Full_fledged: "Fullfjädrad",
    SeparatePortal: "Separat portal",
    Pay_out_frequency: "Utbetalningsfrekvens",
    Weekly: "Veckovis",
    you_can_read_terms_and_condition:
      "Du kan läsa alla villkor och bestämmelser för Refer and Earn Plan",
    here: "här",
    capsStartRefering: "BÖRJA REFERERA",
    readyToGoBeyondEarnPlan: "Är du redo att gå längre än Refer and Earn Plan?",
    signUpAsIBWithUs: "Registrera dig som IB hos oss. Läs alla förmåner",
  },
  commoditiesPage: {
    Forex: "Forex",
    Indices: "Index",
    Commodities: "Råvaror",
    Stocks: "Aktier",
    Cryptocurrencies: "Kryptovalutor",
    heading: "HANDELSVAROR",
    headingDescription:
      "Bygg upp din diversifierade portfölj genom att handla med viktiga råvaror",
    min: "min",
    hundred: "100",
    tenThousand: "10,000",
    CommissionPerLakh: "Provision (per 100 000 USD)",
    zeroPointNinentyNine: "0.99",
    zeroPointSeventyFour: "0.74",
    Commission: "Kommissionen",
    zeroPintZero: "0.0",
    Spread: "Spridning",
    execution: "avrättning",
    tenMiliSec: "10 ms",
    ten: "10",
    Up_to: "Upp till",
    twenty: "20",
    Leverage: "Hävstångseffekt",
    CommoditiesContract: "Råvaruavtal",
    Specifications: "Specifikationer",
    CommoditiesContractDesc:
      "Mer flexibla handelsvillkor (ökad hävstångseffekt) kan gälla för kunder som klassificeras som Professional. Logga in på ditt konto och kontrollera om du är berättigad till Professional Client-klassificering, eller skriv till oss på",
    supportmail: "support{'@'}aaafx.com",
    Instrument: "Instrument",
    Bid: "Bud",
    Ask: "Fråga",
    ContractSize: "Kontraktets storlek",
    MinTradeSize: "Min. Handelsstorlek",
    TickValue: "Tick Värde",
    TradingHours: "Öppettider för handel",
    sevenAM: "7:00 på morgonen",
    twelvePM: "12:00 på eftermiddagen",
    TreasuryProductsDescription:
      "Treasury-produkter har en kvartalsvis utgång (se tabellen nedan). Kunder som har en öppen position på förfallodagen kommer att stängas vid vårt bud/erbjudande kl. 21:00 GMT för BUND, den enda konsekvensen av detta är att kunden kommer att realisera eventuell flytande P/L vid tidpunkten för stängningen. Det finns inga rollovers för alla Treasury-kontrakt som erbjuds.",
    capsExpirationDates: "UTGÅNGSDATUM",
    Bund: "Bund",
    cornf: "CORNF",
    wheatf: "WHEATF",
    soyf: "SOYF",
    seventhDecemberTwentyTwentyOne: "7 december-21",
    twentysixNovemberTwentyOne: "26 november-21",
    twentysevenNovemberTwentyOne: "27 november-21",
    twentyFourFebruaryTwentyTwo: "24-feb-22",
    twentyNineDecemberTwentyOne: "29 december-21",
    What_is_Commodities_Trading: "Vad är råvaruhandel?",
    What_is_Commodities_Trading_desc:
      'Råvaror omfattar ädelmetaller, olja och naturgas. Dessa instrument har lägre korrelation med alla andra tillgångar på marknaden och kan vara ett bra alternativ för diversifiering. Med tanke på den grundläggande volatiliteten i världens länder anses råvaror vara en "säker hamn" som skyddar dem mot kraftiga prisfluktuationer.',
    How_does_it_work: "Hur fungerar det?",
    How_does_it_work_desc:
      "Handel med råvaror innebär inte att man får fysisk leverans av någon tillgång. Potentialen för vinster ligger i prisrörelserna. Eftersom tillgången på dessa tillgångar är begränsad på jorden och de används i industriproduktionen är de ibland utsatta för volatilitet, beroende på olika ekonomiska och politiska faktorer. Utan att faktiskt äga tillgången kan handlaren helt enkelt spekulera i dess pris. Med en uppsjö av tillgänglig information om olika länders ekonomi, politiska situationer, investeringsinformation, utbuds- och efterfrågefaktorer etc. har det blivit bekvämare än någonsin för handlarna att förutse stora prisrörelser och spekulera i dem.Råvarupriserna noteras huvudsakligen i USD. Till exempel hänvisar XAUUSD till priset på guld i USD. För att faktiskt investera i guld behöver du ett betydande kapital. Men med hävstångshandel kan du investera i alla ädelmetaller, olja etc med minimalt kapitalutlägg.",
    Account: "Konto",
    Types: "Typer",
    ECN: "ECN",
    plus: "plus",
    zulu: "zulu",
    DepositMin: "Insättning (min.)",
    spreadMin: "Spridning (min.)",
    CompareAccountTypes: "Jämför kontotyper",
    OurOnline: "Vår online",
    Trading: "Handel",
    Platforms: "Plattformar",
    Desktop: "Skrivbord",
    WebTrader: "Webbhandlare",
    Android: "Android",
    iOS: "iOS",
    capsLearnMore: "LÄR DIG MER",
    NegativeBalance: "Negativt saldo",
    Protection: "Skydd",
    NegativeBalanceDesc1: "Pålitligt skydd av dina medel på AAAFx-konton",
    NegativeBalanceDesc2:
      "Vi strävar alltid efter att arbeta för våra kunders bästa. När du handlar i volatila tider, om ditt konto blir negativt, har vi fått din rygg! Vi kommer att återställa ditt negativa saldo till noll, så att du inte bär någon extra förlust. Du kan sätta in pengar och börja handla igen. Därför kan du inte förlora mer än vad du sätter in.",
    CapsOpenLiveAccount: "ÖPPNA LIVE-KONTO",
    CapsOpenDemoAccount: "ÖPPET DEMOKONTO",
  },
  careerPage: {
    heading: "Karriär",
    headingDescription:
      "Vi älskar det vi gör och tror att du också kommer att älska det! Inkludering, mångfald, innovation och lojalitet är anledningarna till att våra medarbetare älskar sitt arbete och älskar att komma till jobbet varje dag.",
    Join_us_and_help_us:
      "Bli en del av oss och hjälp oss att skapa mervärde i allt vi gör!",
    OurCulture: "Vår kultur",
    OurCulturePointOne:
      "Ingen kan vissla en symfoni. Det krävs en hel orkester för att spela den. - (H.E. Luccock)",
    OurCulturePointTwo:
      "På AAAFx uppmuntrar vi dig att vara den bättre versionen av dig själv. Uttryck vem du verkligen är; lär dig och lyckas! För närvarande sysselsätter vi 80+ personer och strävar efter att ytterligare utöka vårt team. Vårt mål är att skapa en gynnsam arbetsmiljö som ger dig en känsla av tillfredsställelse.",
    When_our_clients: "När våra kunder",
    succeed_we_succeed: "lyckas, så lyckas vi!",
    succeed_we_succeed_pointOneP1: "Vi är mindre när vi inte inkluderar alla.",
    succeed_we_succeed_pointOneP2: "- (Stuart Milk)",
    succeed_we_succeed_pointOnedesc1:
      "Vi har byggt en sammanhållen och inkluderande kultur som omfattar ett brett spektrum av medarbetare, som har gedigna listor över personliga prestationer och en enorm laganda. Inkludering främjar en känsla av tillhörighet och respekt för organisationen. Detta är anledningen till att våra medarbetare känner sig viktiga och uppskattade.  Vi strävar efter att skapa en miljö där alla känner att de arbetar för samma sak tillsammans-",
    succeed_we_succeed_pointOnedesc2:
      '"utmärkta prestationer för en bättre morgondag".',
    succeed_we_succeed_pointTwoP1:
      "Styrkan ligger i olikheter, inte i likheter.",
    succeed_we_succeed_pointTwoP2: "- (Stephen R. Covey)",
    succeed_we_succeed_pointTwodesc1:
      "Att ha ett team med mångfald vad gäller kön och kultur är viktigt för att vi ska kunna ha en bredare och global påverkan. Vår princip är att ha lika många manliga som kvinnliga medarbetare, med respekt och acceptans. Genom att hålla fysiska förmågor, rasism och religiösa övertygelser åt sidan kan vi samexistera och blomstra i en utvecklande miljö. Varje individ som arbetar här ges lika möjligheter, lika lön och hjälper till att övervinna samhällets stereotyper.",
    succeed_we_succeed_pointThreeP1:
      "Medarbetarnas lojalitet börjar med arbetsgivarens lojalitet.",
    succeed_we_succeed_pointThreeP2: " - (Harvey Mackay)",
    succeed_we_succeed_pointThreedesc:
      "Utan stöd från vårt team hade vi inte kunnat nå dit vi är idag. Vårt varumärke lever på lojaliteten hos våra medarbetare, oavsett om det är kunder eller anställda. Lojalitet är inte bara en vanlig egenskap; det är en kraft som driver medarbetarna att göra sitt bästa och prestera enligt högsta möjliga standard. Dessutom sägs det ofta att medarbetarnas lojalitet är smittsam. Det börjar från toppen och sträcker sig över alla delar av vårt team. Vårt team är stolta över vad de gör och de är fast beslutna att ge 100%.",
    succeed_we_succeed_pointFourP1: "Innovation är det enda sättet att vinna.",
    succeed_we_succeed_pointFourP2: "- (Steve Jobs)",
    succeed_we_succeed_pointFourdesc:
      "Vi främjar nytänkande på alla nivåer för att få fram det bästa hos våra medarbetare. Kreativitet är en förutsättning för att kunna skapa nya saker med hjälp av fantasin, och våra medarbetares unika kompetens förädlar dem sedan ytterligare. Det här är något som har lett till att vi har kunnat förbättra kundrelationerna, öka produktiviteten, ge bättre service, sänka kostnaderna och bygga ett starkt varumärke tillsammans.",
    Rewards_and_Benefits: "Belöningar och förmåner",
    Rewards_and_Benefits_PointOne:
      "Belöningen för ett väl utfört arbete är möjligheten att göra mer. - (Jonas Salk)",
    Rewards_and_Benefits_PointTwo:
      "Vill du spendera mer tid tillsammans med din familj eller på din hälsa och träning? Är du redo att utveckla ditt yrke men ändå behålla en balans? Vi erbjuder inte bara våra anställda en ersättning som motsvarar branschstandarderna, utan också en flexibel arbetsmiljö, lukrativa belöningar och olika former av uppskattning och erkännande.",
    CurrentVacancies: "Aktuella lediga tjänster",
    CurrentVacanciesDescOne:
      "Gå med oss och bli en del av en enastående arbetsstyrka som drivs av excellens och engagemang i en sammanhållen teammiljö. Alla som arbetar med AAAFx känner sig värderade på jobbet!",
    CurrentVacanciesDescTwo:
      "Lär dig vad som krävs för att bli en av oss och hur du bäst kan förbereda dig. Vi ser fram emot att ta emot din ansökan och höra från dig.",
    ReadyForChallengesReadyForYou:
      "Om du är redo för utmaningar, är vi redo för dig",
    CustomerSupportGreece: "Kundtjänstmedarbetare, Grekland",
    What_the_job_looks_like: "Hur ser jobbet ut?",
    What_the_job_looks_like_pointOne:
      "Tillhandahålla kundsupport via chatt, e-post och telefon.",
    What_the_job_looks_like_pointTwo:
      "Undersöka kundfrågor på ett ansvarsfullt och proaktivt sätt.",
    What_the_job_looks_like_pointThree: "Undersöka kunders affärer, vid behov.",
    What_the_job_looks_like_pointFour:
      "Kommunicera med kunder på ett mjukt, vänligt och mycket professionellt sätt.",
    What_the_job_looks_like_pointFive:
      "Nära samarbete med ledningen om kortsiktiga och långsiktiga mål och syften.",
    What_the_job_looks_like_pointSix:
      "Anteckna kundernas önskemål och vidarebefordra dem proaktivt till relevanta team.",
    What_the_job_looks_like_pointSeven:
      "Uppföljning med närstående team, när så krävs för att leverera utmärkt service till kunderna.",
    What_the_job_looks_like_pointEight:
      "Att säkerställa att högsta möjliga nivå av kundservice levereras till kunderna.",
    What_do_we_look_for: "Vad letar vi efter?",
    What_do_we_look_for_pointOne:
      "Stark sinnesnärvaro och problemlösningsförmåga.",
    What_do_we_look_for_pointTwo: "Utmärkt kommunikationsförmåga.",
    What_do_we_look_for_pointThree: "Stark laganda",
    What_do_we_look_for_pointFour:
      "Positiv attityd tillsammans med ett lugnt och sansat beteende.",
    What_do_we_look_for_pointFive:
      "Tidigare erfarenhet av Investment Finance eller kundsupport.",
    What_do_we_look_for_pointSix: "Professionalism, ärlighet och integritet.",
    applyForTheJob: "SÖK JOBBET",
    FinanceExecutiveGreece: "Ekonomichef, Grekland",
    What_the_job_looks_like_point1:
      "Bistå vid upprättande av kvartals- och årsbudgetar",
    What_the_job_looks_like_point2: "Hantering av register och kvitton",
    What_the_job_looks_like_point3:
      "Utarbeta analyser och rapporter om budget och utfall",
    What_the_job_looks_like_point4:
      "Avstämning av dagliga, månatliga, kvartalsvisa och årliga transaktioner",
    What_the_job_looks_like_point5: "Utarbeta kvartalsvisa balansräkningar",
    What_the_job_looks_like_point6: "Hantering av fakturor",
    What_the_job_looks_like_point7:
      "Upprättande av kassaflödesanalys för avdelningen",
    What_the_job_looks_like_point8:
      "Vara en kontaktpunkt för andra avdelningar i finansrelaterade frågor.",
    What_the_job_looks_like_point9: "Kvittning av ersättningar till anställda.",
    What_the_job_looks_like_point10:
      "Beräkna och publicera finansiella nyckeltal",
    What_the_job_looks_like_point11: "Bistå vid revisioner, när så krävs.",
    What_the_job_looks_like_point12:
      "Att ta tillvara idéer och förslag för en effektiv fondförvaltning",
    What_do_we_look_for_point1: "Passion för ekonomi och redovisning",
    What_do_we_look_for_point2: "Fullständig kunskap om ERP och MS Office",
    What_do_we_look_for_point3:
      "Redovisningsmaster och minst 3 års erfarenhet av att arbeta med en global mäklare.",
    What_do_we_look_for_point4: "Starka analytiska färdigheter",
    What_do_we_look_for_point5: "Utmärkt lagspelare",
    What_do_we_look_for_point6: "Positiv attityd",
    DataAdministratorGreece: "Dataadministratör, Grekland",
    What_the_job_looks_like_p1:
      "Kontrollera åtkomstbehörigheter och privilegier.",
    What_the_job_looks_like_p2: "Ge stöd och hjälp till utvecklare.",
    What_the_job_looks_like_p3:
      "Övervaka och underhålla systemets hälsa och säkerhet.",
    What_the_job_looks_like_p4:
      "Utforma backup-processer för server och tillhörande data.",
    What_the_job_looks_like_p5:
      "Skapa konton för alla användare och tilldela säkerhetsnivåer.",
    What_the_job_looks_like_p6:
      "Tillhandahålla teknisk support och problemlösning från början till slut.",
    What_the_job_looks_like_p7:
      "Schemalägg och utför regelbundet underhåll av servern.",
    What_the_job_looks_like_p8: "Skapa rutiner för databashantering.",
    What_the_job_looks_like_p9:
      "Förbereda statistisk information för internt och externt bruk.",
    What_the_job_looks_like_p10:
      "Utvärdera modeller och förfaranden för dataanalys.",
    What_the_job_looks_like_p11: "Delta i företagets korsutbildningsprogram.",
    What_do_we_look_for_p1: "Kandidatexamen i datavetenskap.",
    What_do_we_look_for_p2: "1+ års erfarenhet av en liknande roll.",
    What_do_we_look_for_p3: "Avancerad kunskap om databasstruktur och -teori.",
    What_do_we_look_for_p4: "Erfarenhet av MySQL och MSSQL.",
    What_do_we_look_for_p5:
      "Förståelse för rutiner för säkerhetskopiering av databaser.",
    What_do_we_look_for_p6: "PostgreSQL-certifiering föredras.",
    What_do_we_look_for_p7:
      "Förmåga att arbeta självständigt med minimal övervakning och assistans.",
    How_to_Apply: "Hur ansöker du?",
    How_to_Apply_p1:
      'Om du tror att du kan passa bra i någon av ovanstående roller, klicka bara på knappen "Ansök" och skicka oss din',
    How_to_Apply_p2: "CV. Vår HR Associate kommer att återkomma till dig.",
  },
  autoChartistPage: {
    heading: "Autochartist",
    headingDesc: "Låter dig investera din handelstid på ett klokt sätt",
    subHeadingOne:
      "Få tillgång till ett av de mest populära handelsverktygen gratis på AAAFx",
    subHeadingOneP1:
      "Fatta välgrundade beslut när Autochartist analyserar alla diagram och mönster åt dig.",
    subHeadingOneP2:
      "Om du är trader känner du till värdet av tid som ingen annan. Vi presenterar ett utmärkt verktyg som kan spara all din tid och energi och göra flera olika typer av analyser åt dig.",
    subHeadingTwo: "Hur fungerar Autochartist?",
    subHeadingTwoP1: "Missa aldrig ett tillfälle!",
    subHeadingTwoP2: "Autochartist arbetar med tre typer av mönster:",
    ChartPatterns: "Mönster i diagram",
    FibonacciPatterns: "Fibonacci-mönster",
    KeyLevels: "Nyckelnivåer",
    subHeadingTwoDesc:
      "Den övervakar marknaden och skickar kontinuerligt varningar om handelsmöjligheter. Låt tekniken arbeta åt dig 24 timmar om dygnet, nonstop.",
    One_stop_solution: "En enda lösning för marknadsanalys",
    One_stop_solution_p1: "Identifiering av stöd- och motståndsnivåer",
    One_stop_solution_p2: "Realtidsvarningar vid överdrivna rörelser",
    One_stop_solution_p3: "Djupgående analys av makroekonomiska nyheter",
    One_stop_solution_p4: "Identifiering av stöd- och motståndsnivåer",
    Single_Screen_access_to_everythinig: "Tillgång till allt via en enda skärm",
    Get_simply_plugged_in_to_MT4_and_MT5:
      "Bli enkelt ansluten till MT4 och MT5",
    API_Driven_Technology_free_from_manual_errors:
      "API-driven teknik, fri från manuella fel",
    All_rounder_for_all_types_of_Traders:
      "Allroundverktyg för alla typer av traders",
    Autochartist_Volatility_Analysis: "Autochartist Volatilitetsanalys",
    Autochartist_Volatility_Analysis_p1:
      "Bygg din handelsstrategi baserad på fakta.",
    Autochartist_Volatility_Analysis_p2:
      "Hitta den bästa tiden att handla ett instrument genom att skaffa dig kunskap om de mest och minst volatila tiderna under dagen.",
    Autochartist_Volatility_Analysis_p3:
      "Med det här verktyget får du se följande",
    Autochartist_Volatility_Analysis_sub_p1:
      "Förväntade prisintervall inom olika tidsramar",
    Autochartist_Volatility_Analysis_sub_p2:
      "Förväntad prisrörelse per timme under dagen",
    Autochartist_Volatility_Analysis_sub_p3:
      "Förväntad prisrörelse per veckodag",
    Know_more_here: "Läs mer här",
    AutochartistRiskCalculator: "Autochartist Riskkalkylator",
    AutochartistRiskCalculatorP1: "Mät din risk innan du handlar.",
    AutochartistRiskCalculatorP2:
      "Nu kan du alltid vara medveten om den perfekta handelsvolymen för dig, med tanke på din riskaptit.",
    AutochartistRiskCalculatorP3:
      "Detta verktyg visar dig de förväntade prisrörelseintervallen",
    AutochartistRiskCalculatorSubP1:
      "Ställ in önskad startnivå och stop loss-nivå",
    AutochartistRiskCalculatorSubP2:
      "Ange den summa pengar du är villig att riskera för affären",
    AutochartistRiskCalculatorSubP3:
      "Kalkylatorn talar om för dig vilken positionsstorlek du ska ta",
    CapsOpenLiveAccount: "ÖPPNA LIVE-KONTO",
    CapsOpenDemoAccount: "ÖPPET DEMOKONTO",
  },
  cryptoCurrency: {
    innerPages: {
      forex: "Forex",
      indices: "Index",
      commodities: "Råvaror",
      stocks: "Aktier",
      crypto: "Kryptovalutor",
    },
    title: "KRYPTOVALUTOR",
    heading:
      "Handla de mest kraftfulla kryptovalutorna på våra handelsplattformar",
    min: "min .",
    tradeSize: "Handelsstorlek",
    execution: "avrättning",
    paris: "Par",
    leverage: "Hävstångseffekt",
    upTo: "Upp till",
    contract: "Kryptovalutor Kontrakt",
    specification: "Specifikationer",
    pTag: "Mer flexibla handelsvillkor (ökad hävstångseffekt) kan gälla för kunder som klassificeras som Professional. Logga in på ditt konto och kontrollera om du är berättigad till Professional Client-klassificering, eller skriv till oss på",
    email: "support{'@'}aaafx.com",
    table: {
      heading: {
        instrument: "Instrument",
        bid: "Bud",
        ask: "Fråga",
        spread: "Spridning",
        contractSize: "Kontraktets storlek",
        tradeSize: "Min. Handelsstorlek",
        tickValue: "Tick Värde",
        tradingHours: "Öppettider för handel",
      },
    },
    trading: "Vad är handel med kryptovalutor?",
    pTag1:
      "Kryptovalutor är i huvudsak digitala tillgångar som är säkrade med kryptografi och som rör sig genom ett decentraliserat elektroniskt nätverk. Dessa tillgångar backas inte upp av eller kan inte konverteras till någon råvara. De fungerar via en offentlig liggare, baserad på Blockchain-teknik. Bitcoin, som lanserades 2009, är den första decentraliserade kryptovalutan. Sedan dess har många andra kryptovalutor skapats. Dessa mynt har verkligen förändrat spelplanen på finansmarknaderna.",
    howItWork: "Hur fungerar det?",
    pTag2:
      "De traditionella fiatvalutorna påverkas i allmänhet av de ekonomiska och politiska händelser som sker runt om i världen. Men eftersom kryptovalutor inte är relaterade till något särskilt land och i allmänhet är decentraliserade, tenderar deras priser att röra sig oberoende. De är en volatil tillgångsklass av hög kvalitet, vilket gör det absolut nödvändigt för handlare att väga risken innan de handlar med dem. Vi erbjuder CFD:er på krypton, vilket innebär att du helt enkelt kan handla med krypton utan att behöva äga dem. Vinster och förluster på grund av prisskillnader justeras helt enkelt på ditt konto.Dessa instrument visas som ett par, noterade mot USD. Till exempel BTCUSD. Priset på detta par kommer att innebära hur många USD som krävs mot 1 BTC.",
    account: "Konto",
    types: "Typer",
    ecn: "ECN",
    plus: "plus",
    zulu: "zulu",
    deposit: "Insättning",
    commission: "Kommissionen",
    compare: "Jämför kontotyper",
    ourOnline: "Vår online",
    tradingText: "Handel",
    platform: "Plattformar",
    desktop: "Skrivbord",
    webTrade: "Webbhandlare",
    android: "Android",
    ios: "iOS",
    learn: "LÄR DIG MER",
    negative: "Negativt saldo",
    protection: "Skydd",
    pSubTag: "Pålitligt skydd av dina medel på AAAFx-konton",
    pTag3:
      "Vi strävar alltid efter att arbeta för våra kunders bästa. När du handlar i volatila tider, om ditt konto blir negativt, har vi fått din rygg! Vi kommer att återställa ditt negativa saldo till noll, så att du inte bär någon extra förlust. Du kan sätta in pengar och börja handla igen. Därför kan du inte förlora mer än vad du sätter in.",
    live: "ÖPPNA LIVE-KONTO",
    demo: "ÖPPET DEMOKONTO",
  },
  ib: {
    whiteLabel: "Vit etikett",
    pamm: "PAMM/MAM",
    title: "Introducerande mäklare",
    heading: "Utveckla en permanent inkomstkälla för dig själv",
    h3Tag:
      "Framgång idag handlar om att bygga ett starkt nätverk, låt ditt nätverk arbeta med att tjäna pengar åt dig, även när du sover!",
    pTag: "Vill du ta fram det bästa i dina marknadsföringsfärdigheter? AAAFx har tagit fram ett berikande program för våra kunder för att sprida ordet om vår fantastiska plattform och tjäna obegränsad inkomst. Bjud helt enkelt in handlare till oss och tjäna provision när de handlar!",
    h3Tag1: "Sprid ordet - Skapa en inverkan på handelssamhället",
    pTag1:
      "Vi erbjuder enastående handelsvillkor och verktyg för handlare och hjälper våra IB-partners att växa tillsammans med sina kunder:",
    ul: {
      li: "Hög likviditet för handel",
      liTag: "Noll provisioner på Forex",
      liTag1: "Råa Spreads",
      liTag2: "Hög hävstångseffekt upp till 500X",
      liTag3: "Betrodd och pålitlig mäklare",
      liTag4: "Tillgång till handelsverktyg som Auto chartist",
      liTag5: "Direkt tillgång till Zulu Trade",
      liTag6: "Teknik i framkant",
    },
    question: {
      ques: "Varför ska du bli en del av AAAFx IB?",
      point:
        "Belöningen för ditt smarta arbete och din konsekvens kan bli enorm om du fortsätter att utveckla vår handelsgrupp och hjälper dem att använda olika funktioner i våra handelsplattformar. På AAAFx erbjuder vi det mest skräddarsydda och enklaste IB-programmet. Alla IB:s är inte likadana. Men vi har något att erbjuda för alla.",
      point1: "Därför har vi skapat två kategorier av IB-program:",
      point2:
        "Standard IB-program - Du får direkt 20 % av våra provisionsintäkter från dina kunder. Detta är användbart för en nybörjare IB som vill börja om på nytt eller kan börja ta med en begränsad volym kunder till oss.",
      point3:
        "Advanced IB Program - Detta är ett mycket givande och anpassat IB-program för våra större IB:s. Detta är användbart för någon med en betydande kundbas som kan ta in större volym.",
      point4:
        "Du kan gå från Standard IB-programmet till Advanced IB-programmet när du har fått ett tillräckligt stort nätverk.",
    },
    signUp: "Registrera dig som IB",
    referralLink: "Dela hänvisningslänk",
    clients: "Få dina kunder",
    earn: "Tjäna som de handlar",
    benefits: "Andra fördelar med vårt IB-program",
    zero: "Tjäna med noll investering eller erfarenhet",
    ibCommission: "Utbetalningar av IB-provisioner varje vecka",
    earning: "Obegränsad intjäningspotential",
    customized: "Mycket skräddarsytt och givande Advanced IB-program",
    ultraFast: "Ultrasnabba uttag av IB-provisioner",
    easyUser: "Enkelt användargränssnitt för IB-portalen",
    accountManager: "Dedikerad kundansvarig",
    helpful: "Hjälpsamt och kostnadsfritt marknadsföringsmaterial",
    h6Tag:
      "Vårt avancerade IB-program är mycket anpassningsbart med hög inkomstpotential. Om du tror att du har den potentialen, kontakta oss för att få veta mer. Kontakta oss nu",
    click: "här",
    orWrite: "eller skriv till oss på",
    email: "support{'@'}aaafx.com.",
  },
  mt4PageData: {
    MT4: "MT4",
    MetaTrade4: "MetaTrader 4",
    MT5: "MT5",
    ActTrader: "ActTrader",
    ZuluTrade: "ZuluTrade",
    MetaTrade4DescOne:
      "MetaTrader 4-plattformen skapades redan 2002 av MetaQuotes. MT4-plattformen anses vara guldstandardprogramvaran bland det stora utbudet av handelsplattformar; används för handel med forex, CFD, aktier och olika populära kryptovalutor.",
    MetaTrade4DescTwo:
      "AAAFx MT4-plattform har ett användarvänligt gränssnitt som gör det möjligt för användare att förstå plattformens funktioner med absolut lätthet. Den assimilerar en användares krav och erbjuder bästa möjliga lösning genom att ge möjlighet att tillämpa olika analysverktyg, köra handelsrobotar (expertrådgivare) och kopiera affärer från andra.",
    MetaTrade4DescThree:
      "Förbättra din handelsupplevelse på en större skärm med fler funktioner och större fokus genom att ladda ner MT4-plattformen på din dator eller helt enkelt få tillgång till vår webbaserade plattform.",
    Steps_to_download_MT4_Desktop: "Steg för att ladda ner MT4 Desktop",
    Steps_to_download_MT4_Desktop_point1:
      "1. Ladda ner plattformen från länken ovan.",
    Steps_to_download_MT4_Desktop_point2: "2. Kör .exe-filen",
    Steps_to_download_MT4_Desktop_point3: '3. Gå till Arkiv> Öppna ett konto"',
    Steps_to_download_MT4_Desktop_point4:
      "4. Klicka på Add New Broker och skriv AAAFX. Välj AAAFX-FX-DEMO för demo-konto och AAAFX-FX-REAL för live-konto.",
    Steps_to_download_MT4_Desktop_point5:
      "5. Klicka på knappen Scan. Servern är nu tillagd.",
    Steps_to_download_MT4_Desktop_point6:
      '6. Klicka på nästa> välj kryssrutan "Befintligt handelskonto" och ange ditt inloggnings-ID och lösenord. Klicka på Finish.',
    Steps_to_uninstall_MT4_Desktop: "Steg för att avinstallera MT4 Desktop",
    Steps_to_uninstall_MT4_Desktop_point1:
      "1. Klicka på Start-knappen i Windows",
    Steps_to_uninstall_MT4_Desktop_point2:
      "2. MT4-applikationen kommer att ingå i listan över program.",
    Steps_to_uninstall_MT4_Desktop_point3:
      '3. Högerklicka på programmets namn och välj "Avinstallera".',
    Steps_to_log_into_Webbased_MT4: "Steg för att logga in på webbaserat MT4",
    Steps_to_log_into_Webbased_MT4_point1:
      '1. På Web-Trader, gå till "File" alternativet på menyraden och välj "Logga in på handelskonto"',
    Steps_to_log_into_Webbased_MT4_point2:
      "2. Ange ID och lösenord för handelskontot.",
    Steps_to_log_into_Webbased_MT4_point3:
      '3. Välj server som "AAAFX-FX-REAL" för live-konto och "AAAFX-FX-DEMO" för demo-konto',
    Steps_to_log_into_Webbased_MT4_point4:
      '4. Välj sedan plattformen MT4 och klicka på "OK".',
    AAAFx_mobile_trading_application_description:
      "Ta med dig din handelseufori vart du än går med alla de handelsverktyg och indikatorer som finns tillgängliga för AAAFx mobila handelsapplikation.",
    Steps_to_download_MT4_Android: "Steg för att ladda ner MT4 Android",
    Steps_to_download_MT4_Android_point1:
      "1. Ladda ner ansökan från ovanstående länk.",
    Steps_to_download_MT4_Android_point2:
      '2. Klicka på de tre horisontella linjerna i menyn och gå till "Hantera konton"/"Kom igång".',
    Steps_to_download_MT4_Android_point3:
      '3. Klicka på "+"-tecknet i det övre högra hörnet.',
    Steps_to_download_MT4_Android_point4:
      '4. Välj "Logga in på ett befintligt konto"',
    Steps_to_download_MT4_Android_point5:
      '5. Under "Hitta din mäklare" väljer du AAAFX-FX-DEMO för demo-konto och AAAFX-FX-REAL för live-konto. Ange nu ditt inloggnings-ID och lösenord och klicka på logga in.',
    Steps_to_uninstall_MT4_Android: "Steg för att avinstallera MT4 Android",
    Steps_to_uninstall_MT4_Android_point1:
      "1. På menyn går du till Inställningar > Program > Hantera program",
    Steps_to_uninstall_MT4_Android_point2:
      "2. Hitta MT4 listad där och tryck på dess namn.",
    Steps_to_uninstall_MT4_Android_point3: '3. Tryck på "Avinstallera".',
    Steps_to_download_MT4_iOS: "Steg för att ladda ner MT4 iOS",
    Steps_to_download_MT4_iOS_point1:
      "1. Ladda ner ansökan från ovanstående länk.",
    Steps_to_download_MT4_iOS_point2:
      '2. Klicka på "Inställningar" och gå till alternativet "Nytt konto",',
    Steps_to_download_MT4_iOS_point3:
      '3. Klicka sedan på "Logga in på ett befintligt konto"',
    Steps_to_download_MT4_iOS_point4: '4. Ange "AAAFX" under hitta mäklare.',
    Steps_to_download_MT4_iOS_point5:
      "5. Välj AAAFX-FX-DEMO för demokonto och AAAFX-FX-REAL för livekonto.",
    Steps_to_download_MT4_iOS_point6:
      '6. Ange ditt inloggnings-ID och lösenord och klicka på "Logga in"',
    Steps_to_uninstall_MT4_iOS: "Steg för att avinstallera MT4 iOS",
    Steps_to_uninstall_MT4_iOS_point1:
      "1. Tryck länge på MT4-applikationens ikon tills alla ikoner på skärmen börjar skaka.",
    Steps_to_uninstall_MT4_iOS_point2:
      '2. Klicka på "x" i det övre vänstra hörnet av ikonen för MT4-programmet.',
    take_trading_experience_to_next_level:
      "Ta din handelsupplevelse på MT4-plattformen med AAAFx till nästa nivå med följande funktioner",
    Why_AAAFxs_MT4: "Varför AAAFx MT4?",
    Why_AAAFxs_MT4_point1:
      "Associerad med den största handelsgemenskapen i MQL",
    Why_AAAFxs_MT4_point2: "20+ grafiska objekt för djupgående analys",
    Why_AAAFxs_MT4_point3: "Marknadspris i realtid",
    Why_AAAFxs_MT4_point4: "Enkelt att förstå gränssnittet",
    Why_AAAFxs_MT4_point5:
      "Kompatibel med Windows, iPhone, Android eller handla direkt från webben",
    Why_AAAFxs_MT4_point6:
      "Färdiga skript som möjliggör en automatiserad handelsupplevelse",
    Why_AAAFxs_MT4_point7:
      "1000+ gratis och nedladdningsbara indikatorer/EAs som erbjuds av MQL4",
    Why_AAAFxs_MT4_point8:
      "Snabbaste exekveringshastigheten med flera servrar över hela världen",
    Why_AAAFxs_MT4_point9:
      "70+ valutapar, globala index och råvaror tillgängliga för handel",
    Why_AAAFxs_MT4_point10:
      "Marknadsexekvering och 4 typer av väntande order tillgängliga",
    capsOpenLiveAccount: "ÖPPNA LIVE-KONTO",
    capsOpenDemoAccount: "ÖPPET DEMOKONTO",
  },
  mt5PageData: {
    MT4: "MT4",
    MetaTrade5: "MetaTrader 5",
    MT5: "MT5",
    ActTrader: "ActTrader",
    ZuluTrade: "ZuluTrade",
    MetaTrade5DescOne:
      "MT5-plattformen släpptes 2010 med stöd för snabbare bearbetningsteknik än någonsin och ytterligare layouter.",
    MetaTrade5DescTwo:
      "AAAFx MT5-plattform erbjuder en omfattande lista över handelsinstrument inklusive CFD:er för kryptovalutor, vilket hjälper den avancerade plattformen att uppfylla sina futuristiska utsikter.",
    download_mt5_preferred_device:
      "Det är alltid bättre på en större skärm. Ladda ner vår MT5-plattform på den enhet du föredrar.",
    Steps_to_download_MT5_Desktop: "Steg för att ladda ner MT5 Desktop",
    Steps_to_download_MT5_Desktop_point1:
      "1. Ladda ner plattformen från länken ovan.",
    Steps_to_download_MT5_Desktop_point2: "2. Kör .exe-filen",
    Steps_to_download_MT5_Desktop_point3: '3. Gå till Arkiv> Öppna ett konto"',
    Steps_to_download_MT5_Desktop_point4:
      '4. Skriv AAAFX och i "Add New Broker" och klicka på "Find your broker".',
    Steps_to_download_MT5_Desktop_point5:
      '5. Välj "AAAFX" och klicka på "Nästa"',
    Steps_to_download_MT5_Desktop_point6:
      '6. Klicka på "Anslut med ett befintligt handelskonto" och ange dina inloggningsuppgifter',
    Steps_to_download_MT5_Desktop_point7:
      '7. För att logga in på ett Live-konto väljer du servernamnet "AAAFX-FX-REAL" och "AAAFX-FX-DEMO" för Demo-kontot i rullgardinsmenyn och klickar på "Finish".',
    Steps_to_uninstall_MT5_Desktop: "Steg för att avinstallera MT5 Desktop",
    Steps_to_uninstall_MT5_Desktop_point1:
      "1. Klicka på Start-knappen i Windows",
    Steps_to_uninstall_MT5_Desktop_point2:
      "2. MT5-applikationen kommer att ingå i listan över program.",
    Steps_to_uninstall_MT5_Desktop_point3:
      '3. Högerklicka på programmets namn och välj "Avinstallera".',
    Steps_to_log_into_Webbased_MT5: "Steg för att logga in på webbaserat MT5",
    Steps_to_log_into_Webbased_MT5_point1:
      '1. På Web-Trader. gå till "File" alternativet på menyraden och välj "Logga in på handelskonto".',
    Steps_to_log_into_Webbased_MT5_point2:
      "2. Ange ID och lösenord för handelskontot.",
    Steps_to_log_into_Webbased_MT5_point3:
      '3. Välj server som "AAAFX-FX-REAL" för live-konto och "AAAFX-FX-DEMO" för demo-konto',
    Steps_to_log_into_Webbased_MT5_point4:
      '4. Välj sedan plattformen MT5 OCH klicka på "OK"',
    AAAFx_mobile_trading_application:
      "Ta med dig din handelseufori vart du än går med alla de handelsverktyg och indikatorer som finns tillgängliga för AAAFx mobila handelsapplikation.",
    Steps_to_download_MT5_Android: "Steg för att ladda ner MT5 Android",
    Steps_to_download_MT5_Android_point1:
      "1. Ladda ner ansökan från ovanstående länk.",
    Steps_to_download_MT5_Android_point2:
      '2. Klicka på de tre horisontella linjerna i menyn och gå till "Hantera konton"/"Kom igång".',
    Steps_to_download_MT5_Android_point3:
      '3. Klicka på "+"-tecknet i det övre högra hörnet.',
    Steps_to_download_MT5_Android_point4:
      '4. Under "Hitta din mäklare" väljer du AAAFX-FX-DEMO för demo-konto och AAAFX-FX-REAL för live-konto. Ange nu ditt inloggnings-ID och lösenord och klicka på logga in.',
    Steps_to_uninstall_MT5_Android: "Steg för att avinstallera MT5 Android",
    Steps_to_uninstall_MT5_Android_point1:
      "1. På menyn går du till Inställningar > Program > Hantera program",
    Steps_to_uninstall_MT5_Android_point2:
      "2. Hitta MT4 listad där och tryck på dess namn.",
    Steps_to_uninstall_MT5_Android_point3: '3. Tryck på "Avinstallera".',
    Steps_to_download_MT5_iOS: "Steg för att ladda ner MT5 iOS",
    Steps_to_download_MT5_iOS_point1:
      "1. Ladda ner ansökan från ovanstående länk.",
    Steps_to_download_MT5_iOS_point2:
      '2. Klicka på "Inställningar" och gå till alternativet "Nytt konto",',
    Steps_to_download_MT5_iOS_point3:
      '3. Klicka sedan på "Logga in på ett befintligt konto"',
    Steps_to_download_MT5_iOS_point4:
      '4. Ange "AAAFX" under hitta mäklare. br 5. Välj AAAFX-FX-DEMO för demokonto och AAAFX-FX-REAL för livekonto.',
    Steps_to_download_MT5_iOS_point5:
      '5. Ange ditt inloggnings-ID och lösenord och klicka på "Logga in"',
    Steps_to_uninstall_MT5_iOS: "Steg för att avinstallera MT5 iOS",
    Steps_to_uninstall_MT5_iOS_point1:
      "1. Tryck länge på MT5-applikationens ikon tills alla ikoner på skärmen börjar skaka.",
    Steps_to_uninstall_MT5_iOS_point2:
      '2. Klicka på "x" i det övre vänstra hörnet av ikonen för MT5-programmet.',
    trading_experience_the_next_level:
      "Ta din handelsupplevelse med AAAFx på MT5-plattformen till nästa nivå med följande funktioner:",
    Why_AAAFxs_MT5: "Varför AAAFx MT5?",
    TechnicalAnalysisTools: "Verktyg för teknisk analys",
    TechnicalAnalysisToolsPoint1:
      "21 olika tidsramar så att du aldrig förlorar en enda sekund av möjligheten",
    TechnicalAnalysisToolsPoint2:
      "30+ inbyggda indikatorer och 40+ tekniska objekt",
    TechnicalAnalysisToolsPoint3:
      "Tillgång till historiska diagramdata på upp till 30 år",
    TechnicalAnalysisToolsPoint4:
      "6 typer av väntande ordertyper tillgängliga tillsammans med marknadsexekveringen",
    TechnicalAnalysisToolsPoint5:
      "Inbyggda och modifierande alternativ för skript",
    FundamentalAnalysisTools: "Verktyg för fundamental analys",
    FundamentalAnalysisToolsPoint1:
      "Inbyggd ekonomisk kalender; håller dig uppdaterad om alla volatila händelser",
    FundamentalAnalysisToolsPoint2:
      "Möjlighet att ladda ner ett detaljerat kontoutdrag för en valfri tidsperiod",
    FundamentalAnalysisToolsPoint3:
      "Verktyg för marknadsdjup som ger dig ett försprång i dina handelsstrategier",
    capsOpenLiveAccount: "ÖPPNA LIVE-KONTO",
    capsOpenDemoAccount: "ÖPPET DEMOKONTO",
  },
  ourServicesPage: {
    heading: "Våra servitörer",
    headingDescription: "Robusta installationer för en felfri upplevelse",
    EquinixDataCenters: "Equinix datacenter",
    EquinixDataCentersDescription:
      "I vår strävan att ge våra kunder en handelsupplevelse i världsklass förlitar vi oss på inget mindre än den bästa tekniken och infrastrukturen i världen. Vi strävar efter att tillhandahålla den mest tillförlitliga och snabbaste anslutningen när det gäller handelsutförande och därför använder vi världens mest avancerade globala nätverk och serverkluster.",
    What_are_the_advantages_of_Equinix: "Vilka är fördelarna med Equinix?",
    FastestExecution: "Snabbaste exekvering",
    FastestExecutionDescription:
      "Datacentret är samlokaliserat med våra största LPs, vilket ger snabbast möjliga anslutning.",
    Low_latency_connection: "Anslutning med låg latenstid",
    Low_latency_connection_description:
      "Den snabba anslutningen mellan våra handelsservrar och LPs via en dedikerad kanal säkerställer minsta möjliga latens.",
    Uninterrupted_trading: "Oavbruten handel",
    Uninterrupted_trading_description:
      "Omedelbar och sömlös anslutning, maximal drifttid, vilket gör din handelsupplevelse felfri.",
    Low_slippage: "Låg glidning",
    Low_slippage_description:
      "Ultrasnabb anslutning innebär att du får det pris du vill ha, med minimal risk för avvikelser",
    Easy_connectivity: "Enkel anslutning",
    Easy_connectivity_description:
      "Du behöver inte kämpa med uppkopplingen när du ansluter till ett tätt nätverk som arbetar med den senaste tekniken",
    What_is_Equinix: "Vad är Equinix?",
    What_is_Equinix_desone:
      "Equinix, Inc (NASDAQ: EQIX) är ett amerikanskt multinationellt företag med huvudkontor i Redwood City, Kalifornien, som specialiserar sig på internetanslutning och datacenterhantering.",
    What_is_Equinix_destwo:
      "Företaget är ledande inom global samlokalisering med 229 datacenter i 27 länder på fem kontinenter. Dessutom har de vunnit flera utmärkelser för tillförlitlighet och hållbarhet. Deras datacenter anses vara guldstandarden och den mest tillförlitliga och säkra digitala infrastrukturen.",
    What_is_the_LD4_Data_Center: "Vad är LD4 Data Center?",
    What_is_the_LD4_Data_Center_descOne:
      "Equinix LD4-datacenter där de flesta av AAAFx-servrarna är inrymda är Forex-branschens främsta plats för serverplacering, eftersom det möjliggör en direkt direktanslutning till alla större globala likviditetsleverantörer. Det är över 14 000 kvadratmeter stort och har olika globala certifieringar, som SOC 1 Type 1, SOC 2 Type 2, ISO 27001, PCI DSS, OHSAS 18001, ISO 9001:2015, ISO 22301, ISO 14001:1015 och ISO 50001.",
    What_is_the_LD4_Data_Center_descTwo:
      "Den snabba anslutningen till våra likviditetsleverantörer genom det täta nätverket möjliggör ultrasnabb exekvering av handel med kortast möjliga latens.",
  },
  LoyaltyBonusPageData: {
    heading: "Lojalitetsprogram",
    headingDescription:
      "Ju mer du handlar, desto fler belöningar tjänar du automatiskt!",
    LoyaltyBonusDescription:
      "Det sägs att lojalitet går åt båda hållen. Vi förtjänar våra kunders lojalitet genom hårt arbete <br /> och öppenhet, och vi tror på att återgälda den genom vårt kostnadsfria belöningsprogram.0",
    What_is_AAAFx_loyalty_program: "Vad är AAAFx lojalitetsprogram?",
    What_is_AAAFx_loyalty_program_descOne:
      "Varje handel räknas i en näringsidkares resa. Varje handel du gör med oss bidrar till att ge dig spännande avkastning genom vårt fantastiska lojalitetsprogram.",
    What_is_AAAFx_loyalty_program_descTwo:
      "Det finns inget behov av att registrera sig. Alla dina affärer kommer att fortsätta att tjäna in dina Reward Points (RP) automatiskt. När du har samlat ett visst antal belöningspoäng (RP) kan du lösa in dem på flera olika sätt, inklusive kontanter!",
    Deposit: "Insättning",
    Trade: "Handel",
    Earn_RPs: "Tjäna RPs",
    Redeem_RPs: "Lös in RPs",
    loyalty_program_descOne:
      "Vårt lojalitetsprogram är lämpligt för alla typer av",
    loyalty_program_descTwo: "handlare. Det finns två sätt att göra framsteg",
    loyalty_program_descThree: "genom dess nivåindelning:",
    ExpressRoute: "Expressväg",
    ExpressRouteDesc:
      "Lämplig för de handlare som gillar att handla mer på en gång",
    SteadyRoute: "Stadig väg",
    SteadyRouteDesc:
      "För dig som vill handla konsekvent under en längre tidsperiod",
    OurFabulousFourLoyaltyTiers: "Våra fantastiska fyra lojalitetsnivåer",
    OurFabulousFourLoyaltyTiersDescOne: "Handla mer, tjäna mer",
    OurFabulousFourLoyaltyTiersDescTwo:
      "Det blir bara större och bättre för varje nivå du klättrar upp.",
    OurFabulousFourLoyaltyTiersDescThree:
      "Vi har två mycket enkla och flexibla sätt att kvalificera sig för lojalitetsnivåerna. Oavsett vilken väg du tar kommer vi att se till att",
    OurFabulousFourLoyaltyTiersDescFour:
      "du tjänar samma tillämpliga Loyalty-nivåer och samma bonuspoäng. Om du överlappar i dessa två rutter kommer du att",
    OurFabulousFourLoyaltyTiersDescFive:
      "tilldelades den högre tillämpliga nivån av de två rutterna.",
    Redeem_your_Reward_Points: "Lös in dina belöningspoäng",
    EarnMoreRedeemMore: "Tjäna mer, lösa in mer",
    EarnMoreRedeemMoreDesc:
      "Flexibla och attraktiva alternativ för att omvandla dina Reward-poäng till många förmåner",
    Redeem_your_Reward_Points_point1:
      "Kontanter (Min. 500 RPs kan lösas in mot kontanter)",
    Redeem_your_Reward_Points_point2: "Gratis Basic VPS i 3 månader",
    Redeem_your_Reward_Points_point3: "Gratis Premium VPS i 3 månader",
    Redeem_your_Reward_Points_point4: "SeatsonAX Prenumeration för 3 månader",
    Redeem_your_Reward_Points_point5:
      "Ännu snabbare uttag under de kommande 20 dagarna",
    Redeem_your_Reward_Points_point6: "Gå till nästa nivå i belöningssystemet",
    Redeem_your_Reward_Points_point7:
      "Iphone/Ipad eller en liknande smart enhet till ett värde av upp till $1200",
    Redeem_your_Reward_Points_point8: "1 Pip fast spread för 10 handelsdagar",
    Redeem_your_Reward_Points_point9:
      "10% extra IB-provision för den senaste månaden",
    Redeem_your_Reward_Points_point10:
      "$ 100 extra för varje hänvisning under den senaste månaden",
    Redeem_your_Reward_Points_point11: "1 månads ersättning för provision",
    Redeem_your_Reward_Points_point12:
      "Förskottsdeposition för deposition i transit",
    Redeem_your_Reward_Points_point13: "Ytterligare bonus på konto",
    Redeem_your_Reward_Points_point14: "Återbetalning av 1 månads swapavgift",
    Redeem_your_Reward_Points_point15:
      "10% Extra (uttagbar) insättning på de 5 sista insättningarna",
    Redeem_your_Reward_Points_point16:
      "Ersättning för förlust på en handel under de senaste 20 handelsdagarna",
    Redeem_your_Reward_Points_point17:
      "Spread-återbetalning på 10 förlustaffärer (under de senaste 20 dagarna)",
    AdditionalCommAmount: "Ytterligare Comm. Belopp",
    AdvanceDepositAmount: "Belopp för förskottsinsättning",
    Reimbursement_amount: "Ersättningsbelopp",
    readTermsAndConditionHere:
      "Läs villkor och bestämmelser för vårt lojalitetsprogram",
    BonusAmount: "Bonusbelopp",
    here: "här",
    two: "2",
    six: "6",
    seven: "7",
    ten: "10",
    sixHundred: "600",
    sevenHundred: "700",
    oneThousand: "1000",
    twoThousand: "2000",
    twoThousandFivehundred: "2500",
    threeThousand: "3000",
    tenThousand: "10,000",
    twentyFiveThousand: "25,000",
    rps: "RP",
    rpsPerReferral: "RP per remiss",
    oneusd: "1USD",
  },
  legalDocument: {
    title: "Juridiska dokument",
    heading: "Vi på AAAFx är stolta över vår ärlighet och öppenhet",
    recommend: "Vi rekommenderar att du läser och förstår alla nödvändiga",
    tradingJourney:
      "juridiska dokument innan du börjar din handelsresa med oss.",
    policy: "Integritetspolicy",
    view: "utsikt",
    risk: "Friskrivning från risk",
    clientAgreement: "Avtal för privatkunder",
    refundPolicy: "Återbetalningspolicy",
    executionPolicy: "Policy för verkställighet",
    conflicts: "Policy för intressekonflikter",
    clientAsset: "Kundtillgångar",
    investor: "System för ersättning till investerare",
    h3Tag: "DOKUMENT MED NYCKELINFORMATION - CFDS FÖR RÅVAROR",
    h3Tag1: "DOKUMENT MED NYCKELINFORMATION-CFDS OM INDEX",
    h3Tag2: "KEY INFORMATION DOCUMENT-CFD:s OM AKTIER",
    h3Tag3: "DOKUMENT MED NYCKELINFORMATION-CFDS OM VALUTAPAR",
    h3Tag4: "Grunderna i MiFID ΙΙ-direktivet",
  },
  pamm: {
    whiteLabel: "Vit etikett",
    title: "PAMM/MAM",
    programm: "PAMM/MAM-program",
    heading:
      "En perfekt möjlighet att tjäna på många års erfarenhet som framgångsrik handlare",
    pTag: "På AAAFx ger vi handlare ett gyllene tillfälle att visa upp sin handelsexpertis för världen och tjäna pengar genom sina följare. Detta ger också investerare chansen att välja de bästa handlarna för att handla för dem.",
    account: "Vad är PAMM eller ett MAM-konto?",
    pTag1:
      "Detta är en form av poolad investeringsfond där en Money Manager handlar med de medel som samlas in av hans investerarkunder. Med en enda kontoåtkomst får Money Manager placera affärer på alla sina investerares konton. På ett PAMM-konto fördelas affärerna automatiskt och omedelbart i förhållande till det relativa kapitalet på investerarnas konton.  På MAM-kontot kan investeraren välja den risknivå han vill ta och besluta om handelsallokeringen i enlighet därmed.",
    combined: "Varför har vi kombinerat vår PAMM och MAM med ZuluTrade?",
    pTag2:
      "ZuluTrade är synonymt med transparens. När du samlar pengar som investerare och låter en handlare handla med dina pengar måste du ha tydlig insyn i handlarens historiska resultat, full flexibilitet att välja handelsfördelning, möjlighet att interagera med olika experthandlare, ställa frågor till dem, lära av dem osv. Vi ger dig allt detta i samarbete med ZuluTrade.",
    advantage: "Fördel för PAMM/MAM Manager",
    pTag3:
      "PAMM/MAM-förvaltaren kan dra nytta av sin expertis för att tjäna högre inkomster genom den prestationsbaserade avgift som debiteras hans kunder. Våra PAMM/MAM Managers får också full flexibilitet att fastställa sina villkor relaterade till handelsaktivitet och vinstfördelning.  PAMM/MAM Managers får också mycket attraktiva IB-utbetalningar, utöver prestationsbaserade avgifter från sina kunder.",
    investor: "Fördel för investerare",
    pTag4:
      "Investerarna får välja bland ett stort utbud av handlare som listas på ZuluTrade med AAAFx. De kan granska sina handelsprestationer och interagera med dem innan de deltar i PAMM- eller MAM-programmet. Därefter kan de helt enkelt koppla av och låta chefen göra sitt jobb. Efter att ha satt in pengar på sitt konto och godkänt ett helt transparent dokument med villkor och bestämmelser kan de kontinuerligt övervaka sitt kontos resultat. De har också full kontroll över sitt konto när det gäller insättningar, uttag och frånkoppling från Manager-kontot.",
    aaafxProgramm: "Varför AAAFx PAMM/MAM-program?",
    ul: {
      liTag: "Samarbete med det största sociala handelsnätverket",
      liTag1: "Dedikerade kundansvariga för investerare och förvaltare",
      liTag2:
        "Flexibilitet när det gäller att fastställa parametrar och villkor för kontot",
      liTag3: "Ultralåga provisioner med låga spreadar",
      liTag4: "Säkra medel hos en betrodd mäklare",
      liTag5: "Liten investering krävs för att starta",
      liTag6: "Öppenhet för investerarna - inga dolda klausuler",
      liTag7: "Full kontroll för investerare avseende insättningar och uttag",
    },
    minimum: "Minimikrav",
    liTag: "Den totala insättningen måste vara minst 5 000 USD.",
    subAccount: "Minst 4 underkonton krävs.",
    eachInvestor:
      "Varje investerare ska underteckna POA och godkänna alla villkor.",
    howTo: "Hur registrerar jag mig?",
    portal: "Registrera dig på AAAFx-portalen.",
    build: "Bygg upp ett team av investerare.",
    sign: "Få investerarna att underteckna POA.",
    earning: "Börja tjäna pengar.",
    titleHeading:
      "Vårt PAMM/MAM-program är mycket anpassningsbart, så kontakta oss för att få veta mer och för att starta en",
    contact: "PAMM/MAM-konto. Kontakta oss nu här eller skriv till oss på",
    email: "support{'@'}aaafx.com.",
  },
  indicesPages: {
    innerPages: {
      forex: "Forex",
      indices: "Index",
      commodities: "Råvaror",
      stocks: "Aktier",
      crypto: "Kryptovalutor",
    },
    title: "INDIKATIONER",
    heading: "Få ditt handelskonto att växa genom att handla med globala index",
    min: "min .",
    commission: "Kommissionen",
    execution: "avrättning",
    spread: "Spridning",
    upTo: "Upp till",
    leverage: "Hävstångseffekt",
    contract: "Index Kontrakt",
    specification: "Specifikationer",
    pTag: "Mer flexibla handelsvillkor (ökad hävstångseffekt) kan gälla för kunder som klassificeras som Professional. Logga in på ditt konto och kontrollera om du är berättigad till Professional Client-klassificering, eller skriv till oss på",
    email: "support{'@'}aaafx.com",
    instument: "Instrument",
    bid: "Bud",
    ask: "Fråga",
    size: "Kontraktets storlek",
    minTrade: "Min. Handelsstorlek",
    tickValue: "Tick Värde",
    hours: "Öppettider för handel",
    trading: "Vad är CFD-handel med index?",
    pTag1:
      "Ett index representerar en separat portfölj med en sammanslagning av olika företags profiler som hjälper till att minska en kunds riskprofil. Indexhandel befriar en handlare från den stora mängd tid som ska läggas på att analysera en enskild aktie. Index kan vara av olika typer, geografiskt baserade (som Spain Index, German Index, Hong Kong Index) och sektorbaserade (som NASDAQ).",
    how: "Hur fungerar det?",
    content:
      "Volatiliteten i aktieindexen drivs av politiska och ekonomiska faktorer och inte bara av enskilda aktiers utveckling. Handlare kan göra vinster genom att spekulera i aktieindexens rörelser i uppåtgående eller nedåtgående riktning. Handlaren behöver inte köpa alla enskilda aktier som är listade på Dow Jones, till exempel. Han kan helt enkelt handla Dow Jones CFD. Att handla med index är ett utmärkt sätt att diversifiera din portfölj med ett litet kapitalutlägg. Handlare förlitar sig i allmänhet på den ekonomiska utvecklingen i regioner (för landsbaserade index) eller även den övergripande utvecklingen för sektorn (för sektorbaserade index) för att bedöma om de ska gå lång eller kort i indexet. Indexet i sig är bara en siffra, men det fina med denna produkt är att man kan investera i alla enskilda aktier i indexet med ett mycket mindre kapital.",
    account: "Konto",
    type: "Typer",
    ecn: "ECN",
    plus: "plus",
    zulu: "zulu",
    deposit: "Insättning",
    compare: "Jämför kontotyper",
    online: "Vår online",
    tradingText: "Handel",
    platform: "Plattformar",
    desktop: "Skrivbord",
    webTrade: "Webbhandlare",
    android: "Android",
    ios: "iOS",
    learn: "LÄR DIG MER",
    negative: "Negativt saldo",
    protection: "Skydd",
    pSubTag: "Pålitligt skydd av dina medel på AAAFx-konton",
    workTowards:
      "Vi strävar alltid efter att arbeta för våra kunders bästa. När du handlar i volatila tider, om ditt konto blir negativt, har vi fått din rygg! Vi kommer att återställa ditt negativa saldo till noll, så att du inte bär någon extra förlust. Du kan sätta in pengar och börja handla igen. Därför kan du inte förlora mer än vad du sätter in.",
    live: "ÖPPNA LIVE-KONTO",
    demo: "ÖPPET DEMOKONTO",
  },
  economicCalander: {
    title: "Ekonomisk kalender",
    heading: "Globala evenemang till hands",
    h5Tag:
      "Låt vår ekonomiska kalender göra dig bekant med alla viktiga finansiella händelser som påverkar de globala marknaderna",
    news: "Ekonomisk kalender, Forex-nyheter",
    pTag: "Detta är ett oumbärligt verktyg för grundläggande analys av finansmarknaderna baserat på ekonomiska nyheter. Mer än 500 index för världens största ekonomier baseras på realtidsdata som samlas in från offentliga källor.",
    upNext: "Nästa steg",
    country: "Land",
    selectAll: "Välj alla",
    clear: "Klar",
    myFilter: "Mitt filter",
    default: "Standard",
    text: "Påverkan",
    type: {
      all: "Alla",
      medium: "Medium",
      high: "Hög",
    },
    saveSetting: "Spara inställning i mitt filter",
    apply: "Tillämpa filter",
    calander: {
      time: "Tid",
      country: "Land",
      event: "Händelse",
      actual: "Faktiskt",
      forecast: "Prognos",
      previous: "Föregående",
    },
    head: "Titel:",
    category: "Kategori:",
    desc: "Beskrivning:",
    defi: "Definition:",
  },
  faqs: {
    "Komma igång": {
      0: {
        label: "Hur registrerar jag mig hos AAAFx och verifierar mitt konto?",
        content:
          '\n\t\t\t<div class="innehåll">\n\t\t\t<p>För framgångsrik verifiering ska nedanstående process följas:</p>\n\t\t\t<ul> <ul>\n\t\t\t<li>Steg 1: Ange dina personuppgifter inklusive namn, telefonnummer, e-postadress etc.</li>\n\t\t\t<li>Steg 2: Efter att alla personuppgifter har lämnats, vänligen ladda upp ett foto-ID-bevis (licens, pass etc.)</li>\n\t\t\t<li>Steg 3: Av säkerhetsskäl, klicka på en selfie på plats och ladda upp den på önskad sida.</li>\n\t\t\t<li>Steg 4: I nästa steg, vänligen ladda upp ett nytt "bevis på bosättning" (utfärdat inom 3 månader från dagens datum), som innehåller ditt fullständiga namn och adress (en elräkning, kontoutdrag etc.)</li>\n\t\t\t<li>Steg 5: Vänligen fyll i uppgifterna och klicka på Skicka.</li>\n\t\t\t</ul> </ul>\n\t\t\t</div> </div>\n\t\t  ',
      },
      1: {
        label: "Vilket land tar ni emot kunder från?",
        content:
          '<div class="content"><p>Vi tar emot kunder från 27 länder inom Europeiska ekonomiska samarbetsområdet (EES) (EU samt Island, Schweiz och Liechtenstein). Kunder från Belgien och Storbritannien accepteras inte.</p> </div>',
      },
      2: {
        label: "Är AAAFx reglerat?",
        content:
          '<div class="content"><p>AAAFx är en reglerad finansiell tjänsteleverantör med licenser från HCMC, Grekland och FSCA, Sydafrika.</p></div>',
      },
      3: {
        label:
          "Kan jag registrera mig utan e-postadress/telefonnummer, jag har ingen?",
        content:
          '<div class="content"><p>Vänligt notera att du behöver en e-postadress / telefonnummer för att registrera dig hos oss, eftersom vi skickar e-postbekräftelser på den registrerade e-postadressen för att verifiera begäran från webbkontot. Vi ber dig också att ange ditt telefonnummer så att vi kan nå dig i brådskande fall.</p> </div>',
      },
      4: {
        label: "Vilka dokument behövs för att verifiera kontot?",
        content:
          "<div class=\"innehåll\">\n\t\t  <p>Följande dokument kommer att krävas för att öppna ett konto hos oss:</p>\n\t\t  <ul> <ul>\n\t\t  <li>1. Ett giltigt foto-ID-bevis (t.ex. pass, körkort eller annat foto-ID utfärdat av ett statligt kontor)</li> <li>2.\n\t\t  <li> 2. ett nyligen utfärdat uppehållsbevis (utfärdat inom 3 månader), som innehåller fullständigt namn och adress (det kan vara en elräkning, kontoutdrag etc.). Du kan ladda upp ovan nämnda nödvändiga dokument på webbkontot eller skicka dem via e-post till support{'@'}aaafx.com.</li>\n\t\t  </li> </ul>\n\t\t  </div> </div>",
      },
      5: {
        label:
          "Vad händer om jag behöver ändra mina uppgifter senare? Hur uppdaterar jag informationen i min profil?",
        content:
          "<div class=\"innehåll\">\n\t\t  <p>Du kan ändra följande personliga uppgifter genom att logga in på ditt webbkonto:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Primär telefon</li>\n\t\t  <li>Mobiltelefon</li>\n\t\t  <li>Kön</li>\n\t\t  <li>Marital status</li>\n\t\t  </ul> </ul>\n\t\t  <p>Du kan också ändra dina bankuppgifter genom att logga in på ditt webbkonto. För uppdatering av andra uppgifter, vänligen kontakta oss på Live Chat eller e-post på support{'@'}aaafx.com.</p>\n\t\t  </div> </div>",
      },
      6: {
        label: "Hur många Live-konton kan jag öppna?",
        content:
          '<div class="content"><p>Du kan öppna så många konton som du vill. Det finns ingen begränsning.</p></div>',
      },
      7: {
        label: "I hur många basvalutor kan jag öppna ett konto?",
        content:
          '<div class="content"><p>Du kan öppna ett konto med en basvaluta som USD, EUR och CHF.</p></div>',
      },
      8: {
        label: "Hur stor är den lägsta insättningen för att öppna ett konto?",
        content:
          '<div class="content"><p>Minsta insättning är endast $100.</p></div>',
      },
      9: {
        label: "Erbjuder ni islamiska (swapfria) konton?",
        content:
          '<div class="content"><p>Ja, du kan välja islamisk kontotyp när du skapar begäran.</p></div>',
      },
      10: {
        label: "Tillåter ni hedging?",
        content: '<div class="content"><p>Ja, vi tillåter Hedging.</p></div>',
      },
      11: {
        label: "Tillåter du Scalping?",
        content: '<div class="content"><p>Vi tillåter inte skalpering.</p></div>',
      },
    },
    "Insättningar och uttag": {
      0: {
        label: "Hur gör jag en insättning på mitt konto?",
        content:
          '<div class="innehåll">\n\t\t  <ul>\n\t\t  <li>1. Logga in på ditt webbkonto</li>\n\t\t  <li>2. Gå till fliken Fund i den vänstra rutan</li>\n\t\t  <li>3. Välj det handelskonto som du vill finansiera </li>\n\t\t  <li>4. Välj den betalningsmetod som du vill använda.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      1: {
        label: "Hur kan jag överföra pengar mellan mina konton?",
        content:
          '<div class="innehåll">\n\t\t  <ul>\n\t\t  <li>1. Logga in på ditt webbkonto</li>\n\t\t  <li>2. Gå till Hantera konton i den vänstra rutan</li>\n\t\t  <li>3. Klicka på knappen "Intern överföring".</li>\n\t\t  <li>4. Välj konton och ange det belopp som du vill överföra.</li>\n\t\t  <li>5. Klicka på Fortsätt. Pengarna kommer att överföras direkt.</li>\n\t\t  </ul> </ul>\n\t\t  <p>Vid intern överföring mellan konton med olika basvalutor kommer det överförda beloppet att vara enligt rådande marknadspriser.</p>\n\t\t  </div> </div>',
      },
      2: {
        label: "Hur tar jag ut pengar från mitt konto?",
        content:
          '<div class="innehåll">\n\t\t  <ul>\n\t\t  <li>1. Logga in på ditt webbkonto.</li>\n\t\t  <li>2. Gå till fliken Fond i den vänstra rutan.</li>\n\t\t  <li>3. Klicka på fliken Uttag.</li>\n\t\t  <li>4. Välj det handels-ID som du vill göra ett uttag från.</li>\n\t\t  <li>5. Ange det belopp som ska tas ut och välj uttagssätt.</li> <li>6.\n\t\t  <li>6. Klicka på Skapa transaktion.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      3: {
        label: "Hur lång tid tar det att behandla ett uttag?",
        content:
          '<div class="content"><p>Alla uttag är föremål för 24 timmars handläggningstid, inklusive helger.</p></div>',
      },
      4: {
        label: "Finns det några insättnings-/uttagsavgifter?",
        content:
          '<div class="content"><p>Nej, alla insättningar och uttag är gratis från vår sida.</p></div>',
      },
      5: {
        label:
          "Hur lång tid tar det innan insättningen syns på mitt handelskonto?",
        content:
          '<div class="innehåll">\n\t\t  <ul> <li\n\t\t  <li><b>Bankkort: </b> Betalningarna behandlas omedelbart.</li>\n\t\t  <li><b>Banköverföring: </b>Banköverföringstransaktioner tar vanligtvis 2-3 arbetsdagar att nå oss.</li>\n\t\t  <li><b>eWallets: </b> Betalningarna behandlas omedelbart. Det tar vanligtvis upp till 1 arbetsdag att återspegla beloppet på ditt handelskonto om insättningen initieras via Skrill.</li>\n\t\t  <li><b>Kryptovalutor: </b>Crypto-insättningar krediteras inom 30-40 minuter.</li>\n\t\t  </li> </ul>\n\t\t  </div> </div>',
      },
      6: {
        label: "Ersätter ni transaktionsavgifterna?",
        content:
          '<div class="content"><p>AAAFx ersätter den transaktionskostnad som du ådrar dig när du gör en insättning hos oss med högst 5% av insättningens transaktionsvärde.</p></div>',
      },
      7: {
        label:
          "Vad händer om jag inte gör transaktionerna i mitt kontos basvaluta?",
        content:
          '<div class="content"><p>När du gör en insättning via valfri valuta kommer pengarna att visas i ditt kontos basvaluta. Omvandlingen kommer att göras enligt det bästa tillgängliga marknadspriset vid den tidpunkten.</p></div>',
      },
      8: {
        label: "När kan jag avbryta en begäran om deposition?",
        content:
          "<div class=\"content\"><p>Du kan avbryta en begäran om insättning genom att skicka ett e-postmeddelande till oss på support{'@'}aaafx.com eller så kan du komma till vår livechatt så avbryter vi begäran åt dig.</p></div>",
      },
      9: {
        label:
          "Finns det något sätt att initiera en överföring av pengar till mitt handelskonto från en annan mäklare?",
        content:
          '<div class="content"><p>AAAFx stöder inte fondöverföringar mellan mäklare. De fastställda metoderna ska följas för att initiera överföring av medel.</p> </div>',
      },
      10: {
        label:
          "Finns det några gränser för det lägsta eller högsta uttagsbeloppet?",
        content:
          '<div class="content"><p>Det lägsta uttagsbeloppet är $10. Det finns ingen takgräns för uttag.</p></div>',
      },
      11: {
        label:
          "Hur går man tillväga för att ta ut pengar via tillgängliga finansieringsmetoder?",
        content:
          '<div class="innehåll">\n\t\t  <ul>\n\t\t  <li>Logga in på ditt webbkonto</li>\n\t\t  <li>Gå till fliken Fond i den vänstra rutan</li>\n\t\t  <li>Klicka på fliken Uttag.</li>\n\t\t  <li>Välj det handels-ID som du vill göra ett uttag från.</li>\n\t\t  <li>Ange det belopp som ska tas ut och välj uttagssätt.</li>\n\t\t  <li>Klicka på Skapa transaktion.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      12: {
        label: "Vad är den normala tidsramen för behandling av uttag?",
        content:
          '<div class="content"><p>Uttag bekräftas vanligtvis inom 1 arbetsdag. Från det att de frigörs från ditt konto tills de görs tillgängliga på ditt angivna bankkonto handlar det om några arbetsdagar beroende på faktorer som destinationsland, användning av förmedlande bank etc.</p></div>',
      },
      13: {
        label:
          "Kan jag begära ett uttag med en annan metod än den som jag ursprungligen använde för att göra insättningen?",
        content:
          "<div class=\"content\"><p>Om insättningskällan är ogiltig av någon anledning kan du nå oss för att vidta relevanta åtgärder antingen via livechatten eller e-posta oss på <a href=\"mailto:contactus{'@'}aaafx.com\">contactus{'@'}aaafx.com.</a></p></div>",
      },
      14: {
        label: "Behandlar ni uttag under helgen?",
        content:
          '<div class="content"><p>Ja, vi behandlar uttagen under helgen.</p></div>',
      },
      15: {
        label:
          "Finns det några omständigheter under vilka ett uttag kan nekas?",
        content:
          '<div class="innehåll">\n\t\t  <p>Ja, en begäran om uttag kan nekas. De möjliga orsakerna kan inkludera:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Otillräcklig fri marginal</li>\n\t\t  <li>Inkorrekt information om uttag</li>\n\t\t  </ul> </ul>\n\t\t  <p>Det kan finnas andra skäl som kommer att specificeras om uttaget nekas.</p>\n\t\t  </div> </div>',
      },
      16: {
        label: "När kan jag avbryta en begäran om uttag?",
        content:
          "<div class=\"content\"><p>Du kan avbryta en begäran om uttag på egen hand genom att skicka e-post till oss på <a href=\"mailto:support{'@'}aaafx.com\">support{'@'}aaafx.com</a> eller så kan du kontakta oss på vår Live Chat Support så avbryter vi begäran åt dig</p></div>.",
      },
      17: {
        label: "Finns det några villkor för uttag?",
        content:
          '<div class="content"><p>Begäran om uttag ska göras med samma finansieringsmetod och med samma belopp som insättningen gjordes.</p><p>Till exempel; om en insättning på 50 USD gjordes med ett bankkort och 100 USD med en banköverföring. Då kan du i det här fallet ta ut $ 50 med bankkortet och $ 100 med banköverföringen. Du kan inte initiera ett uttag på mer än $ 50 med bankkortet eller mer än $ 100 med banköverföring.</p> <p>Och när det uttagna beloppet överstiger det belopp som deponerats via en annan kanal än banköverföring (till exempel Instant Deposit via kreditkort eller Moneybookers) kommer det återstående uttagsbeloppet att skickas ut via banköverföring.</p> </div>',
      },
      18: {
        label: "Kan jag ta ut mina pengar under pågående handel?",
        content:
          '<div class="content"><p>Du kan bara ta ut belopp upp till den fria marginalen som finns tillgänglig på dina handelskonton. Det rekommenderas vanligtvis att begära uttag medan du inte har några öppna affärer.</p> <p> Men om du har några öppna affärer måste du undersöka den mest kvantitet som du verkligen vill ta ut. Om du inte har tillräcklig tillgänglig marginal på handelskontot kan begäran nekas.</p> </div>',
      },
      19: {
        label: "Accepterar ni några tredjepartsbetalningar?",
        content:
          '<div class="content"><p>Nej, vi accepterar inga tredjepartsbetalningar.</p></div>',
      },
      20: {
        label:
          "Hur kan jag lägga till och ta bort pengar till och från mitt demokonto?",
        content:
          '<div class="innehåll">\n\t\t  <ul>\n\t\t  <li>1. Logga in på ditt webbkonto.</li>\n\t\t  <li>2. Gå till fliken Fond i den vänstra rutan.</li>\n\t\t  <li>3. Välj Insättningar för att lägga till pengar på demokontot.</li>\n\t\t  <li>4. Välj Uttag för att minska medel från demokontot.</li>\n\t\t  <li>5. Välj kontonummer och ange sedan det belopp som du vill sätta in/ta ut.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
    },
    "Forex Trading": {
      0: {
        label: "Hur beräknar man vinst/förlust?",
        content:
          '<div class="innehåll">\n\t\t  <p>När värdet på en valuta som du har köpt stiger skapas vinst; du kan säkra vinsten av denna transaktion genom att sälja tillbaka valutan och därmed stänga positionen. Låt oss se det med ett exempel där vi köper amerikanska dollar och säljer schweiziska franc.</p> <p>Kursen du erbjuds är\n\t\t  <p>Kursen du är citerad är 1,2755 / 1,2760. Eftersom du köper amerikanska dollar kommer du att arbeta med "ask" -priset på 1,2760, eller den kurs som handlare är beredda att sälja till.</p> <\n\t\t  <p>Låt oss anta att du köper 1 standardparti (100 000 enheter) till 1,2760.</p> <p>Låt oss anta att du köper 1 standardparti (100 000 enheter) till 1,2760.\n\t\t  <p>Några timmar senare rör sig priset till 1,2780 och du bestämmer dig för att stänga din handel.</p> <p>\n\t\t  <p>Den nya noteringen för USD/CHF är 1,2780 / 1,2785. Eftersom du stänger din handel och du ursprungligen köpte för att gå in i handeln, säljer du nu för att stänga handeln så du måste ta "budpriset" på 1,2780, eller den kurs som handlare är beredda att köpa till.</p> <p>\n\t\t  <p>Skillnaden mellan 1,2760 och 1,2780 är .0020 eller 20 pips.</p> <p>\n\t\t  <p>Med hjälp av pipberäkningsformeln har vi nu (.0001/1.2780) x 100.000 = $ 7,82 per pip x 20 pips = $ 156,49 Tänk på att när du går in i eller ut ur en handel är du föremål för spridningen av bud / erbjudande citat.</p> <p>När du köper en valuta är du beredd att köpa den.\n\t\t  <p>När du köper en valuta använder du erbjudande- eller säljkursen och när du säljer använder du köpkursen.</p> <p>\n\t\t  </div> </div>',
      },
      1: {
        label: "Vilka är AAAFx:s öppettider?",
        content:
          '<div class="content"><p>Marknaden öppnar på söndag 22:00 UTC och stänger på fredag 22:00 UTC.\n\t\tNär östlig tid är i sommartid öppnar marknaden på söndag 21:00 UTC och stänger på fredag 21:00 UTC.</p></div>',
      },
      2: {
        label:
          "Varför ser jag att priserna uppdateras innan marknaden öppnar, men jag kan inte handla?",
        content:
          '<div class="content"><p>Även om marknaden öppnar på söndag kl. 00.00 kan du märka av små fluktuationer i kurserna före öppning. Trading Desk initierar relevanta tjänster och börjar uppdatera kurserna för att ha dem förberedda och tillgängliga när handeln återupptas. De kurser som visas före den officiella marknadsöppningen kan dock inte tillämpas på nya marknadsorder och handel kan inte utföras.</p></div>',
      },
      3: {
        label:
          "Hur kommer min öppna position att påverkas om kurserna ändras från fredagens stängning till söndagens öppning?",
        content:
          '<div class="content"><p>Under normala marknadsförhållanden när marknaden öppnar kan du se att öppningskursen för ett valutapar ligger mycket nära den kurs som registrerades på fredagen innan marknaden stängde. Det finns dock tillfällen då kurserna kan röra sig betydligt upp eller ner, och detta kan ha en positiv eller negativ effekt på din handelsaktivitet. Om det finns ett stort nyhetsmeddelande eller viktiga ekonomiska händelser som kommer att påverka valutans värde, finns det en större sannolikhet för luckor på marknaden.</p> <p> Tänk på att eftersom priset kan röra sig mot din nuvarande position kan du upptäcka att din position förlorar även om den var i vinst när marknaden stängde. Av denna anledning bör handlare som har positioner eller order under helgen vara medvetna om sådana negativa eventuella luckor och vara redo för potentiella förluster.</p> </div>',
      },
      4: {
        label:
          "Varför fick jag ett Margin Call-meddelande när marknaden var stängd?",
        content:
          '<div class="content"><p>Marknadens öppningsprocess är inte omedelbar - det är en gradvis process som startar före 22:00 UTC.</p><p>Som ett resultat börjar vi också ta emot kurser före 22:00, så vi genererar ett Margin Call eller Stop Out-meddelanden innan dess - men affärer stängs inte före den officiella marknadsöppningen kl. 22:00.</p> <p>Om de tillgängliga kurserna efter marknadsöppningen fortfarande placerar ditt konto under Stop Out-nivån, utlöses Stop Out-mekanismen och stängningen av handeln initieras.</p> </div>',
      },
      5: {
        label:
          "Priset vid marknadens öppning översteg min förutbestämda Stop/Limit för en affär. Vad kommer att hända med affären?",
        content:
          '<div class="content"><p>Om det förutbestämda stoppvärdet överskrids när marknaden öppnar, kommer handeln att stängas med den rådande kursen vid den tidpunkten. Kursen kommer att bero på den likviditet som finns tillgänglig vid den tidpunkten. Utförandet av stopporder vid varje överskriden kurs innebär större förluster än förväntat.</p> <p>Men när marknaden öppnas till en kurs som överstiger ditt inställda gränsvärde kommer handeln att stängas med en högre vinst än förväntat.</p> <p>Låt oss se detta med ett exempel:</p> <p>Du har en KÖP EUR / USD-position öppnad till pris 1.1150 med gräns inställd på 1.1350.</p> <p> På fredag när marknaden stängde nådde priset på paret 1.1250, och på söndag när marknaden öppnade med priset 1.1450.</p> <p> Som ni kan se överskred priset gränsen på 1.1350 så att handeln skulle stängas av detta nya nuvarande pris vilket ger dig vinst på 300 punkter istället för de inställda 200 punkterna.</p> </div>',
      },
      6: {
        label: "Hur kan jag skydda mina affärer som gjorts under helgen?",
        content:
          '<div class="content"><p>Om du tror att marknaden kan vara volatil under helgen och att kurserna kommer att röra sig mot dina öppna positioner, bör du förutse risken. Om denna handelsstrategi inte passar dig rekommenderas att du går ur en handel genom att realisera din nuvarande vinst eller förlust innan marknaden stänger.</p> </div>',
      },
      7: {
        label: "Vad är rollover/swap?",
        content:
          '<div class="content"><p>AAAFx rullar automatiskt fram alla öppna positioner kl. 21:00 UTC. Handeln avbryts vanligtvis i upp till 1 minut under rullningsprocessen. Beloppet som betalas eller tjänas in beror på riktningen för den öppna positionen och räntedifferensen mellan de två valutorna som är inblandade. Om man till exempel antar att de brittiska räntorna är betydligt högre än de japanska, får en handlare som är lång GBP/JPY (dvs. har pund sterling) ränta vid rollover. Omvänt, om en handlare är kort GBP/JPY (dvs. innehar Yen) kommer ränta att debiteras vid rollover.</p> <p>AAAFx dagliga rollover-priser och detaljerad rapportering av rollover-aktivitet finns tillgänglig i Swap-kolumnen i din kontohistorik på MT4-plattformen. För indikativa rollover-avgifter, se vår webbplats.</p></div>',
      },
      8: {
        label: "Vilka är dina Margin-krav för en Stop-Out (Margin Call)?",
        content:
          '<div class="content"><p>Den nivå vid vilken en Stop-Out kommer att utlösas på ditt konto är 70% av marginalkravet, t.ex. om marginalkravet är 1 000 $ och kontots eget kapital når 700 $ kommer alla öppna positioner att stängas automatiskt.</p><p>Observera att AAAFx kommer att utfärda ett Margin Call när ditt eget kapital når 100% av marginalkravet och meddela dig via e-post så att du kan vidta omedelbara åtgärder för att förhindra en Stop-Out.</p></div>',
      },
      9: {
        label: "Hur undviker jag en Stop Out (Margin Call)?",
        content:
          '<div class="innehåll">\n\t\t  <p><b> Tillräcklig marginal</b></p>\n\t\t  <p>I allmänhet bör du, för att undvika en Stop Out, se till att du alltid har tillräcklig marginal för att hålla dina nuvarande positioner öppna och motstå deras potentiella neddragning. Så länge som ditt eget kapital är mer än 70% av den marginal som används för dina nuvarande öppna positioner kommer en Stop-Out inte att inträffa på ditt konto. Observera att du kan övervaka din marginalnivå från din MT4 när som helst; ju högre procentandel av din marginalnivå, desto mindre sannolikt är det att du har en Stop Out.</p>\n\t\t  <p>Vänligen notera att AAAFx kommer att utfärda ett Margin Call när ditt eget kapital når 100% av marginalkravet och meddela dig via e-post så att du kan vidta omedelbara åtgärder för att förhindra en Stop-Out. Vid 100 % marginalnivå kommer dessutom informationslinjen i terminalen på ditt MT4-konto att markeras från grått till rött.</p>\n\t\t  <p><b>Stänga öppna positioner</b></p>\n\t\t  <p>Ett snabbt sätt att öka din marginalnivå och minska risken för en Stop-Out är att stänga några positioner, så att marginalen som användes för att öppna dem kommer att frigöras tillbaka till ditt eget kapital.</p> <p>\n\t\t  <p><b>Fondökning</b></p>\n\t\t  <p>Ett annat sätt att undvika överexponering, öka din marginalnivå och därmed minska risken för en Stop-Out är att sätta in mer pengar. Du kan använda Instant Deposit-metoden för att göra omedelbara kapitalinstallationer på ditt konto. För att göra detta, besök bara fliken Fonder under din kundinloggningssektion.</p>\n\t\t  <p> Undvik överbelåning</b> </p>\n\t\t  <p>En annan faktor som kan sätta ditt konto i riskzonen för en Stop-Out är överbelåning. Att använda mer hävstång kan potentiellt förstora dina vinster, men det kan också förstora förluster som snabbt kommer att tömma din användbara marginal. Ju mer hävstång du använder, desto snabbare kan dina förluster ackumuleras.</p>\n\t\t  <p>När du använder överdriven hävstång kan det faktum att ditt konto har mer handelspotential lätt leda till att du överexponerar det och därmed orsakar förluster. För att tydligt se hur detta kan hända, överväga följande exempel:</p> <p>\n\t\t  <p>Handlare A har ett konto med 500 dollar i eget kapital och använder en hävstång på 200:1, medan handlare B har ett konto med 500 dollar och 100:1 i hävstång.</p> <p>\n\t\t  <p>Handlare A kan handla upp till 100 000 valutaenheter och bestämmer sig för att handla 60% av sitt kapital, så han öppnar 6 affärer på 0,1 standardpartier vardera (totalt $ 60 000) och använder därmed $ 300 av marginalen ($ 50 x 0,6 partier) och behåller $ 200 mer som fri marginal. Varje pip som rör sig i denna handelsstorlek är lika med 1 USD, så om alla öppna affärer når en lägsta nivå på 290 pips (förlust på cirka 48 pips per handel) kommer hans eget kapital att vara 210 USD. När det händer kommer hans marginalnivå att vara 70% (210/300), och därmed kommer en Stop Out att inträffa och stänga alla öppna affärer på hans konto.</p> <p>\n\t\t  <p>Handlare B kan å andra sidan handla upp till 50 000 valutaenheter och bestämmer sig för att handla 60% av sitt kapital. Eftersom ett 0,1 standardparti i det här fallet kräver 100 $ marginal, är hälften av kapitalet tillräckligt för 3 affärer på 0,1 standardparti vardera (totalt 30 000 $). Återigen är varje pip som rör sig i denna handelsstorlek lika med $ 1, så om alla öppna affärer når en lågpunkt på 48 pips, kommer den totala lågpunkten att vara 144, varför hans eget kapital kommer att vara 356. När det händer kommer hans marginalnivå att vara 118% (356/300) så han kommer inte att riskera en Stop Out.</p> <p>\n\t\t  <p>Slutsatsen är att hävstångseffekten är ett verktyg som kan öka dina vinster eller förluster i samma storleksordning; ju större hävstångseffekt på kapitalet du använder, desto högre risk tar du.</p> <p>\n\t\t  </div> </div>',
      },
      10: {
        label:
          "Varför påverkades min handel trots att jag ser på MT4-diagrammet att den kritiska hastigheten inte nåddes?",
        content:
          '<div class="innehåll">\n\t\t  <p>Vänligen notera att MT4-graferna endast visar köpkurser och inte säljkurser (skillnaden mellan dem är spreaden).</p>\n\t\t  <p>Var vänlig och tänk på att när du öppnar en säljhandel öppnas den till köpkursen och stängs till säljkursen, medan när du öppnar en köphandel öppnas den till säljkursen och stängs till köpkursen.</p>\n\t\t  <p>Du kan dock alltid se de exakta kurserna som ditt konto handlas till i fönstret Market Watch i din MT4.</p> <p>\n\t\t  </div> </div>',
      },
      11: {
        label: "Förekommer slippage med AAAFx-kunders order?",
        content:
          '<div class="innehåll">\n\t\t  <p>Slippage avser skillnaden mellan det begärda priset för en order och det pris till vilket ordern faktiskt utförs. Det finns marknadshändelser/förhållanden som orsakar hög volatilitet och därmed gör det mer sannolikt att slippage uppstår, till exempel marknadsnyheter eller tillkännagivanden.</p> <p>\n\t\t  <p>I sådana fall fyller AAAFx ordern till bästa tillgängliga pris, baserat på det begärda priset och beroende på beloppet samt typen av order. Detta kan leda till att en order ger resultat som är mer gynnsamma, lika med eller mindre gynnsamma än de ursprungliga förväntningarna, och resultaten kallas positiv slippage, ingen slippage respektive negativ slippage.</p> <p>\n\t\t  </div> </div>',
      },
      12: {
        label: "Erbjuder AAAFx skydd mot negativ balans?",
        content:
          '<div class="content"><p>AAAFx arbetar med ett "negativt balansskydd", vilket innebär att kunden inte kan förlora mer än sitt totala investerade kapital (insättning). AAAFx fastställer efter eget gottfinnande och i god tro att förekomsten av ett sådant negativt saldo inte beror på något skadligt eller missbrukande beteende hos kunden och inte avsiktligt har orsakats av kunden.</p></div>',
      },
    },
    "Metaller och CFD:er": {
      0: {
        label:
          "Vad är den minsta partistorleken för handel med metaller och CFD:er?",
        content:
          '<div class="content"><p>Minsta partistorlek för metaller och CFD:er är 1 standardparti.</p></div>',
      },
      1: {
        label:
          "Vad är ett standardparti guld (XAU/USD) och silver (XAG/USD) lika med?",
        content:
          '<div class="content"><p>1 standardparti guld (XAU/USD) är lika med 1 uns (oz) guld och 1 standardparti silver (XAG/USD) är lika med 50 uns (oz) silver.</p></div>',
      },
      2: {
        label:
          "Vilken marginal krävs för att handla med CFD:er och vilka är deras öppettider?",
        content:
          '<div class="content"><p>All information om CFD:er finns i avsnittet Ordlista, CFD:er.</p></div>',
      },
      3: {
        label:
          "Vilken marginal krävs för att handla med guld (XAU/USD) och silver (XAG/USD) på mitt AAAFx-konto?",
        content:
          '<div class="content"><p>Marginalen som krävs för guld (XAU/USD) är 100% av det aktuella priset och pip-värdet är $0,01. Marginalen som krävs för silver (XAG/USD) är 200% av det aktuella priset multiplicerat med kontraktsstorlek (multiplikator) och pip-värdet är $0,5.</p></div>',
      },
      4: {
        label:
          "Varför stängdes min USOilSpot/UKOil/NGAS/BUND/Copper-handel? Stoppet eller limiten nåddes inte och jag fick inte heller något Margin Call.",
        content:
          '<div class="content"><p>Tyska obligationer har förfallodatum enligt tabellen i avsnittet Råvaror och aktier, Förfallodatum. Som ett resultat kommer kunderna att realisera eventuella rörliga P/L vid den tidpunkt då positionen stängs på grund av förfallodatum.</p></div>',
      },
      5: {
        label:
          "Vad är marginalen som krävs för att handla med BTC/USD på mitt AAAFx-konto?",
        content:
          '<div class="content"><p>Marginalen som krävs för Bitcoin (BTC/USD) är 1000% av det aktuella priset och pip-värdet är $0,01.</p></div>',
      },
      6: {
        label: "Vad är provisionen som debiteras för ett BTC/USD-kontrakt?",
        content:
          '<div class="content"><p>Kommissionen är 0,0008*Pris på ECN Plus-konto.</p></div>',
      },
      7: {
        label: "Vad är den minsta kontraktsstorleken för handel med BTC/USD?",
        content:
          '<div class="content"><p>Det finns ett minimum på 1 kontraktsstorlek = 1 BTC. Detta innebär att med en kurs på ca 35 000 $ BTC/USD behöver du en marginal på 7 000 $ för att öppna (köpa eller sälja) den minsta ordern.</p></div>',
      },
      8: {
        label:
          "Vad är marginalen som krävs för att handla med ETH/USD på mitt AAAFx-konto?",
        content:
          '<div class="content"><p>Marginalen som krävs för Ethereum (ETH/USD) är 1000% av det aktuella priset.</p></div>',
      },
      9: {
        label: "Vad är det maximala antalet ETH/USD-kontrakt per kund?",
        content:
          '<div class="content"><p>Det finns en gräns på 1000 kontrakt för total exponering (t.ex. 500 köp och 500 sälj = 1 000) per kund.</p></div>',
      },
      10: {
        label:
          "Vad är marginalen som krävs för att handla med LTC/USD på mitt AAAFx-konto?",
        content:
          '<div class="content"><p>Marginalen som krävs för Litecoin (LTC/USD) är 1000% av det aktuella priset.</p></div>',
      },
      11: {
        label: "Vad är det maximala antalet LTC/USD-kontrakt per kund?",
        content:
          '<div class="content"><p>Det finns en gräns på 1000 kontrakt för total exponering (t.ex. 500 köp och 500 sälj = 1K) per kund.</p></div>',
      },
    },
    "Grundläggande Forex information": {
      0: {
        label: "Vad är Forex?",
        content:
          '<div class="content"><p>Valutamarknaden (Forex, FX eller valutamarknad) är en form av utbyte för den globala decentraliserade handeln med valutor. Finanscentra runt om i världen fungerar som ankare för handel mellan ett brett spektrum av olika typer av köpare och säljare dygnet runt, med undantag för helger. Valutamarknaden bestämmer de relativa värdena för olika valutor</p></div>',
      },
      1: {
        label: "Hur stor är valutamarknaden?",
        content:
          '<div class="content"><p>Valutamarknaden är den mest likvida finansiella marknaden i världen. Den genomsnittliga dagliga omsättningen på den globala valutamarknaden och relaterade marknader växer kontinuerligt. Enligt 2010 Triennial Central Bank Survey, som samordnas av Bank for Settlements, uppgick den genomsnittliga dagliga omsättningen till 3,98 biljoner USD i april 2010 (jämfört med 1,7 biljoner USD 1998). Av dessa 3,98 biljoner dollar var 1,5 biljoner dollar avistatransaktioner och 2,5 biljoner dollar handlades i direkta terminer, swappar och andra derivat.</p></div>',
      },
      2: {
        label: "Var är valutamarknaden baserad?",
        content:
          '<div class="content"><p>Det finns ingen enhetlig eller centralt clearad marknad för merparten av handeln och det finns mycket lite gränsöverskridande reglering. På grund av valutamarknadernas OTC-karaktär (over-the-counter) finns det snarare ett antal sammankopplade marknadsplatser där olika valutainstrument handlas. Detta innebär att det inte finns en enda växelkurs utan snarare ett antal olika kurser (priser), beroende på vilken bank eller marknadsgarant som handlar och var den befinner sig.</p></div>',
      },
      3: {
        label: "Vem deltar i marknaden?",
        content:
          '<div class="content"><p>Till skillnad från en aktiemarknad är valutamarknaden uppdelad i olika nivåer. Högst upp finns interbankmarknaden, som består av de största affärsbankerna och värdepappershandlarna. Interbankmarknaden i toppskiktet står för 53% av alla transaktioner. Därifrån sker transaktionerna från mindre banker, följt av stora multinationella företag, stora hedgefonder och till och med några av de privata marknadsgaranterna. Andelen av andra marknadsaktörer som mäklare, multinationella företag, registrerade handlare och privata investerare ökar dock snabbt.</p></div>',
      },
      4: {
        label: "Vad är ett parti?",
        content:
          '<div class="content"><p>En lot är den vanliga enhetsstorleken för en transaktion. För Forex-valutor är en standard lot vanligtvis lika med 100 000 enheter av basvalutan, 10 000 enheter om det är en mini lot eller 1 000 enheter om det är en micro lot.</p></div>',
      },
      5: {
        label: "Vad är spreaden?",
        content:
          '<div class="content"><p>Skillnaden mellan köp- och säljkurs kallas för Spread. AAAFx erbjuder bland de lägsta spreadarna på valutamarknaden.</p></div>',
      },
      6: {
        label: "Vad är en Pip/Tick?",
        content:
          '<div class="content"><p>En pip (eller tick) är den minsta prisökningen som en valuta kan göra. Det är den fjärde siffran i alla valutapar med undantag för den japanska yenen (JPY) där det är den andra siffran (till exempel 1 pip = 0,0001 för EUR/USD eller 0,01 för USD/JPY.)</p></div>',
      },
      7: {
        label: "Hur beräknar jag värdet av 1 Pip?",
        content:
          '<div class="innehåll">\n\t\t  <p>För att uttrycka värdet i termerna valuta, multiplicera 1 pip med lotstorleken.</p>\n\t\t  <ul> <ul>\n\t\t  <li>EUR/USD pip = 0,0001 X 100 000 = $10,00 (för standardpartier)</li>\n\t\t  <li>EUR/USD pip = 0,0001 X 10 000 = 1,00 USD (för minipartier)</li>\n\t\t  <li>EUR/USD pip = 0,0001 X 1 000 = 0,1 USD (för mikropartier)</li>\n\t\t  <li>GBP/JPY pip = 0,01 X 100 000 = 1000 ¥ (för standardpartier)</li>\n\t\t  </ul> </ul>\n\t\t  <p>För att konvertera till basvalutan dividera med växelkursen:</p>\n\t\t  <p>Säg EUR/USD växelkurs = 1,4750, då $10,00 / 1,4750 = 6,78€</p>\n\t\t  <p>För att konvertera till ett kontos valuta (t.ex. USD) dividera med växelkursen $/¥:</p> <p>\n\t\t  <p>Om $/¥ = 82,12 så är 1000 ¥ / 82,12 = 12,17$</p>\n\t\t  </div> </div>',
      },
      8: {
        label: "Vilka är de sju största valutaparen?",
        content:
          '<div class="innehåll">\n\t\t  <p>De sju mest likvida valutaparen handlas mot den amerikanska dollarn, där de fyra första paren är de största, följt av tre råvarupar. Andra valutapar är mer kända som valutakorsningar, och de mest populära korsningarna är de som inkluderar euron: EUR/JPY, EUR/GBP och EUR/CHF.</p>\n\t\t  <p>De största valutaparen är:</p>\n\t\t  <ul> <li>EUR/USD\n\t\t  <li>EUR/USD</li>\n\t\t  <li>USD/JPY</li>\n\t\t  <li>USD/CHF</li>\n\t\t  <li>GBP/USD</li>\n\t\t  </ul> </ul>\n\t\t  <p>Valutaparen för råvaror är:</p>\n\t\t  <ul>\n\t\t  <li>AUD/USD</li>\n\t\t  <li>NZD/USD</li>\n\t\t  <li>USD/CAD</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>.',
      },
      9: {
        label: "Vad är hävstångseffekt?",
        content:
          '<div class="content"><p>Forex hävstång eller hävstångseffekt betyder helt enkelt den procentuella summa pengar du får låna från mäklaren när du öppnar en position. Hävstångseffekten avgör hur stor andel av en handels nominella värde som krävs som marginal. Enkelt uttryckt kan du tänka på hävstångseffekt som ett lån som ger dig möjlighet att köpa valutor.</p> </div>',
      },
      10: {
        label: "Vad är Margin?",
        content:
          '<div class="content"><p>Typiskt sett, för att hävstången ska kunna frigöras, kommer mäklare att begära att ett visst belopp av kontots faktiska medel tilldelas per varje position (lot) som handlas. Marginalen är alltså det minsta belopp som deponeras för att öppna en position. Marginalen beror på kontots hävstång; om hävstången till exempel är 1:30 kan du handla en position som är trettio gånger större än deponeringsbeloppet. Enkelt uttryckt kan du tänka på marginal som en insättning i god tro som krävs för att frigöra lånet (hävstång).</p> <p>Till exempel, med en hävstång på 100:1 (eller 1% av den position som krävs) kan du handla en position värd 100 000 $ med ett eget kapital på bara 5 000 $. Detta skulle vara möjligt eftersom mäklaren skulle avsätta 1 000 USD som handpenning eller "marginal" och låta dig "låna" resten. Naturligtvis kommer eventuella förluster eller vinster att dras av från eller läggas till det återstående kontantsaldot på ditt konto.</p> </div>',
      },
    },
    "Aktie-CFD:er": {
      0: {
        label: "Hur fungerar aktie-CFD:er?",
        content:
          '<div class="content"><p>Det går att spekulera i aktier (eller andelar) i börsnoterade företag. Online-mäklare kan erbjuda CFD-kontrakt (contracts for difference) med olika företags aktier som underliggande tillgångar för dessa CFD:er. När en aktie-CFD köps äger köparen faktiskt inte själva aktien utan spekulerar bara i prisrörelsen för den aktien med hjälp av CFD.</p> <p> Med aktie-CFD: er (kontrakt för skillnad) kan investerare gå långa (köpa) eller gå korta (sälja). Med en lång position kommer en prisökning att ge en vinst. Å andra sidan tjänar en kort position pengar när priset på en aktie rör sig lägre.</p> </div>',
      },
      1: {
        label: "Vad rör sig på aktiemarknaden?",
        content:
          '<div class="content"><p>Priset på en aktie påverkas av utbud och efterfrågan. De krafter som påverkar utbud och efterfrågan är många - grundläggande faktorer (t.ex. vinst per aktie), investerarnas uppfattning, tekniska faktorer, nyheter om det specifika företaget eller dess branschsektor, etc.</p></div>',
      },
      2: {
        label:
          "Vad är skillnaden mellan handel med aktier och CFD-handel med aktier?",
        content:
          "<div class=\"content\"><p>CFD-handel efterliknar aktiehandel med undantaget att du i ett kontrakt för skillnad faktiskt inte äger den underliggande tillgången, till skillnad från företagsaktier, där du gör det. Vad du i huvudsak gör med CFD-handel är att köpa ett kontrakt mellan dig själv och CFD-leverantören som, beroende på din position som (antingen 'Short Sell' eller 'Buy'), kommer att ha ett ingångspris när du går in i en handel och ett utgångspris när du rensar ut din handel med en lika motsatt position.</p> <p> En av de viktigaste skillnaderna mellan att handla en CFD lång jämfört med att köpa en säkerhet är att du kan njuta av större hävstångsfunktioner. Kontrakt för skillnad handlas på marginal, vilket innebär att det inte finns något behov av att binda upp hela marknadsvärdet för att köpa motsvarande aktieposition.</p> <p> Det finns också ett antal viktiga skillnader mellan handel med en underliggande tillgång och en CFD: </p> <\n\t\t  <ul> <ul>\n\t\t  <li>CFD-aktier kan handlas långa eller korta, och du är inte skyldig att leverera den underliggande tillgången vid en kort försäljning.</li>\n\t\t  <li>Investeraren äger inte den underliggande tillgången som CFD:n baseras på, utan ingår istället ett avtal med CFD-mäklaren om att utbyta den kontanta skillnaden i priset mellan öppnings- och stängningspriserna i kontraktet.</li>\n\t\t  <li>Till skillnad från att inneha den underliggande tillgången handlas en CFD på marginal, vilket innebär att en första insättning görs hos CFD-mäklaren, vilket gör det möjligt för investeraren att köpa eller sälja ett antal CFD:er enligt marginalberäkningar, vilket i allmänhet ger extra hävstångseffekt jämfört med själva aktieköpet.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>",
      },
      3: {
        label: "Vad är hävstångseffekten för CFD-aktier?",
        content:
          '<div class="content"><p>Liksom alla andra CFD:er för aktier är hävstångsnivån 1:5. Exempel: Låt oss anta att du köper 5 Facebook CFD:er för 400 USD. Marginalkravet är 20%, du skulle bara behöva lägga ut $ 100, vilket ger dig mer pengar att använda på andra affärer.</p> </div>',
      },
      4: {
        label: "Vilka aktie-CFD:er erbjuder ni?",
        content:
          '<div class="content"><p>För närvarande erbjuder vi de mest populära aktierna från DOW30 och Nasdaq, se en fullständig lista <a href="/aktier">här</a></p></div>',
      },
      5: {
        label: "Vilka är handelstiderna för CFD-handel med aktier?",
        content:
          '<div class="content"><p>Till skillnad från Forex-marknaden som i princip kan handlas 24 timmar om dygnet, 5 dagar i veckan, är de globala aktiemarknaderna endast öppna i cirka 6,5 till 8,5 timmar om dygnet, 5 dagar i veckan, beroende på börsen. De tider då olika länders aktier kan handlas skiljer sig också åt beroende på tidszonen i varje land.</p> <p>Vi stöder CFD: er för den amerikanska aktiemarknaden, så vi följer de vanliga handelssessionerna på den amerikanska aktiemarknaden (NASDAQ, Dow 30): Vardagar 09:30 till 16:00 (Eastern Standard Time - EST).</p> <p>För grekiska aktie-CFD: er är handelstiderna: Vardagar 08:35-15:00 (UTC)</p></div>',
      },
      6: {
        label: "Vad är Corporate Actions?",
        content:
          '<div class="content"><p>Bolagsåtgärder är händelser som initieras av ett börsnoterat bolag och som vanligtvis har en direkt eller indirekt inverkan på aktieägarna och resulterar i väsentliga förändringar av aktien genom att påverka priset, antalet omsatta aktier eller andra egenskaper (t.ex. tickernamn). Företagshändelser omfattar aktiesplit, utdelning, fusioner, förvärv, företrädesemissioner och avknoppningar. Alla dessa är viktiga beslut som vanligtvis måste godkännas av bolagets styrelse och auktoriseras av dess aktieägare. Företagsåtgärder är offentlig information och de relevanta åtgärdsdatumen finns tillgängliga i olika onlinekällor.</p> </div>',
      },
      7: {
        label: "Vad är en aktieutdelning?",
        content:
          '<div class="content"><p>En utdelning är en belöning som företag delar ut till sina aktieägare och den kommer från företagets nettovinst. Sådana belöningar kan antingen vara i form av kontanter, kontantekvivalenter, aktier etc. och betalas oftast från den återstående andelen av vinsten när väsentliga utgifter har uppfyllts. I de enklaste termerna är en utdelning en investerares andel av ett företags vinst.</p> </div>',
      },
      8: {
        label: "Vem har rätt att få utdelning?",
        content:
          '<div class="content"><p>När du köper några CFD-aktier i ett företag drar du vanligtvis nytta av eventuella utdelningar som betalas ut av företaget på dessa aktier. Aktie-CFD-investerare har rätt till utdelningen om de håller aktierna fram till ex-utdelningsdatumet. Beroende på typen av position (lång / kort) kommer de antingen att få eller debiteras utdelningar på betalningsdagen.</p> <p>Om du köper en CFD-aktie på dess ex-utdelningsdatum eller senare kommer du inte att få den kommande utdelningsbetalningen. Istället kommer säljaren i denna situation att få utdelningen.</p> <p> Observera att aktieutdelningar kommer att betalas till ditt konto med eventuella tillämpliga källskatter avdragna. Betalningen kommer faktiskt att visas på ditt konto som ytterligare kontanter.</p> </div>',
      },
      9: {
        label: "Vad är en aktiesplit?",
        content:
          '<div class="content"><p>När ett företag genomför en aktiesplit ökar antalet aktier i företaget, men marknadsvärdet förblir detsamma.denna åtgärd, som kräver förhandsgodkännande från företagets styrelse, innebär vanligtvis att ytterligare aktier emitteras till befintliga aktieägare.</p><p>Till exempel har ABC-företaget 4 miljoner utestående aktier och varje aktie har ett värde på 10 USD. I det här fallet är företagets totala marknadsvärde 40 miljoner dollar (4 miljoner x 10 dollar/aktie). Efter en två-för-en-aktiesplit kommer företagets antal aktier att fördubblas till 8 miljoner, medan värdet på dessa aktier kommer att halveras till $ 5. Företagets totala börsvärde kommer dock att förbli detsamma på bara $ 40 miljoner (8 miljoner * $ 5 / aktie).</p> </div>',
      },
      10: {
        label: "Får jag utdelning från aktie-CFD:er?",
        content:
          '<div class="content"><p>Stock CFD-investerare beroende på typ av position (lång/kort) har rätt att krediteras eller debiteras utdelningsbetalningen om de har en aktieposition efter utgången av ex-dividenddatumet. Utdelningar är offentlig information och datumen kan lätt hittas online.</p></div>',
      },
      11: {
        label: "Vad är den minsta handelsstorleken?",
        content:
          '<div class="content"><p>Minsta handelsstorlek är 1 lot per order som representerar en aktie.</p></div>',
      },
      12: {
        label:
          "Vilket är det officiella semesterschemat för amerikanska aktier?",
        content:
          '<div class="content"><p>Se nedan de dagar som US Market är officiellt stängd:</p> <ul> <ul>>Tidpunkt\n\t\t  <ul> <ul>\n\t\t  <li>God fredag</li>\n\t\t  <li>Memorial Day</li>\n\t\t  <li>Independence Day</li>\n\t\t  <li>Labor Day</li>\n\t\t  <li>Thanksgivingdagen</li>\n\t\t  <li>Julfredag</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
    },
    "Handelsplattformar - Allmänt": {
      0: {
        label: "Vilka priser visar diagrammet på handelsplattformen?",
        content:
          '<div class="content"><p>Diagrammen på handelsplattformen visar köpkurser som standard. Du kan dock se ask-linjen genom att följa stegen nedan:</p>\n\t\t  <ul> <li>Högerklicka\n\t\t  <li>Högerklicka var som helst i diagrammet och välj Egenskaper.</li>\n\t\t  <li>Klicka på fliken Common och markera rutan Show Ask line.</li>\n\t\t  <li>Klicka på OK-knappen så kommer du att se Ask-linjen visas på MT4-diagrammet.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      1: {
        label:
          "Hur kan jag skapa ett kontoutdrag för mitt handelskonto på handelsplattformen?",
        content:
          '<div class="content"><p>Följ vänligen stegen nedan för att ladda ner kontoutdraget från handelsplattformen:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Logga in på ditt handelskonto</li>\n\t\t  <li>Klicka på fliken "Kontohistorik"</li>\n\t\t  <li>Högerklicka på det tomma området och klicka sedan på " all historik"</li>\n\t\t  <li>När hela historiken dyker upp högerklickar du och klickar på "Spara som detaljerad rapport"</li>\n\t\t  </ul> </ul>\n\t\t  <p>Uttalandet kommer att laddas ner på din enhet.</p>\n\t\t  </div> </div>',
      },
      2: {
        label:
          "Hur döljer eller visar jag fler par/instrument i fönstret för marknadsövervakning?",
        content:
          '<div class="innehåll">\n\t\t  <ul>\n\t\t  <li>Högerklicka på valfritt instrument</li>\n\t\t  <li>Välj alternativet "symboler"</li>\n\t\t  </ul> </ul>\n\t\t  <p>Utifrån listan med valutor, index och råvaror väljer du det par du vill dölja eller visa (genväg: Ctrl U)</p>\n\t\t  </div> </div>',
      },
      3: {
        label: "Hur ser jag detaljer om ett handelsinstrument?",
        content:
          '<div class="content"><p>För att se detaljer om ett handelsinstrument :</p>\n\t\t  <ul> <ul>\n\t\t  <li>Högerklicka på handelsinstrumentet</li>\n\t\t  <li>Välj "Specifikation".</li>\n\t\t  </ul> </ul>\n\t\t  <p>Du kan kontrollera genom dialogrutan för kontraktsspecifikation för relevant information som spread, kontraktsstorlek, swappunkter etc</p>\n\t\t  </div> </div>',
      },
      4: {
        label: "Hur kan jag aktivera handel med ett klick på plattformen?",
        content:
          '<div class="content"><p>Snabbgenväg: Alt T eller högerklicka på diagrammet och aktivera One-Click Trading</p></div>',
      },
      5: {
        label: "Vad är ett investerarlösenord? Varför behöver jag det?",
        content:
          '<div class="content"><p>Investerarlösenordet är ett annat namn för "skrivskyddat lösenord". Investerarlösenordet kommer till användning när du vill att en tredje part ska kunna se affärer på ditt konto utan att utföra någon annan aktivitet. För att skapa ett investerarlösenord loggar du in på ditt handelskonto. Klicka på Verktyg>Alternativ>Server och välj sedan Ändra.</p> <p>Du kan också ändra / generera investerarlösenordet direkt från ditt webbkonto. Följ stegen nedan:</p><ol><li>Logga in på ditt webbkonto</li><li>Välj "Hantera konton" i den vänstra rutan</li><li>Klicka på "Återställ handelslösenord" > "Investerarlösenord"</li></ol></div>',
      },
      6: {
        label: "Finns det något sätt att ändra tiden på mina sjökort?",
        content:
          '<div class="content"><p>Tidpunkterna i diagrammen på handelsplattformarna är enligt servertiden. På AAAFx är servertiden inställd på UTC eller UTC+1 beroende på sommartid.</p></div>',
      },
      7: {
        label:
          "Kan jag skräddarsy mina diagram på handelsplattformen? Om ja, hur?",
        content:
          '<div class="content"><p>Ja, diagrammen kan anpassas genom att följa stegen nedan:</p>\n\t\t  <ul> <ul>.\n\t\t  <li>Högerklicka på diagramfönstret.</li>\n\t\t  <li>Välj alternativet "Egenskaper"</li>\n\t\t  <li>Du kan ändra diagrammets färger efter eget val.</li>\n\t\t  </ul> </ul>\n\t\t  <p>För andra ändringar, välj fliken "Gemensamt".</p>\n\t\t  </div> <p>',
      },
      8: {
        label: "Kan jag logga in på mer än ett handelskonto samtidigt?",
        content:
          '<div class="content"><p>Ja, du kan logga in på flera handelskonton på en och samma handelsplattform. Handel kan dock endast utföras på ett handelskonto åt gången.</p> </div>',
      },
    },
    "Handelsplattformar - MT4": {
      0: {
        label: "Hur loggar jag in på mitt MT4-handelskonto?",
        content:
          '<div class="content"><p>Följ dessa steg för att logga in på MT4-plattformen</p>\n\t\t  <ul>\n\t\t  <li>Klicka på alternativet "Arkiv" i menyraden</li>\n\t\t  <li>Välj inloggning till handelskonto</li>\n\t\t  <li>Fyll i ditt handels-ID och lösenord</li>\n\t\t  <li>Välj servernamn: AAAFx-FX-Demo (för demokonto) / AAAFx-FX-Real (för riktigt konto)</li>\n\t\t  <li>Klicka på inloggning</li>\n\t\t  </ul> </ul>\n\t\t  <p>Du kommer att loggas in på ditt handelskonto</p>\n\t\t  </div> </div>',
      },
      1: {
        label: "Hur loggar jag in på ett riktigt konto på MT4?",
        content:
          '<div class="content"><p>För att logga in på ett riktigt konto på MT4-plattformen, vänligen följ dessa steg:</p>\n\t\t  <p>Först måste du skapa ett riktigt konto på portalen. För att skapa ett live-konto, följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Registrera: Klicka på alternativet "Gå med nu" på portalen</li>\n\t\t  <li>Ange dina uppgifter: Namn, e-post-ID, telefonnummer</li>\n\t\t  <li>Ange verifieringskoden som du skulle ha fått i ditt e-postmeddelande</li>\n\t\t  <li>Välj plattform, kontotyp, kontots basvaluta, hävstångseffekt och slutligen ange lösenordet till kontot.</li>\n\t\t  <li>Vidare måste du ladda upp dokument</li>\n\t\t  <li>Nu sätta in pengar</li>\n\t\t  </ul> </ul>\n\t\t  <p>Efter detta följer du dessa steg för att logga in på plattformen:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Klicka på alternativet "Arkiv" i menyraden</li>\n\t\t  <li>Välj "Logga in på ett handelskonto"</li>\n\t\t  <li>Ange ditt handels-ID och lösenord</li>\n\t\t  <li>Välj server: AAA Fx-FX-Real</li>\n\t\t  <li>Klicka på "Logga in"</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      2: {
        label: "Hur skapar jag/loggar jag in på ett demokonto?",
        content:
          '<div class="content"><p>För att skapa ett demokonto, vänligen följ dessa steg:</p>\n\t\t  <ol>\n\t\t  <li>Logga in på ditt webbkonto.</li>\n\t\t  <li>Gå till "Hantera konton"</li>.\n\t\t  <li>Klicka på "Skapa ett demokonto"</li>\n\t\t  <li>Välj handelsplattform, kontohävstång, kontots basvaluta och ange lösenord.</li>\n\t\t  </ol> </ol>\n\t\t  <p>Nu har ett demokonto skapats åt dig.</p>\n\t\t  </div> </div>',
      },
      3: {
        label: "Var kan jag se mina provisioner?",
        content:
          '<div class="content"><p>För att se provision, vänligen följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Klicka på alternativet "Visa" i menyraden</li>\n\t\t  <li>Välj "Terminal"</li>\n\t\t  <li>Välj "Handelsavdelning"</li>\n\t\t  <li>Högerklicka på den placerade affären</li>\n\t\t  <li>Aktivera provisioner </li>\n\t\t  </ul> </ul>\n\t\t  <p>Du kan nu se provisioner som en separat kolumn</p>\n\t\t  </div> </div>',
      },
      4: {
        label:
          "Hur kan jag ändra lösenordet för mitt handelskonto från plattformen?",
        content:
          '<div class="content"><p>Följ dessa steg för att ändra kontolösenordet från MT4:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Klicka på "Verktyg" i menyfältet</li>\n\t\t  <li>Välj "Alternativ" > Dialogrutan kommer att visas</li>\n\t\t  <li>Ange nytt lösenord > Okej</li>\n\t\t  </ul> </ul>\n\t\t  <p>ELLER</p>\n\t\t  <ul> <li>I\n\t\t  <li>I navigeringsfönstret, under konton > Högerklicka på det konto som du vill ändra lösenordet för</li>\n\t\t  <li>Ange det nuvarande lösenordet och det nya lösenordet > Klicka på Okej</li>\n\t\t  </ul>\n\t\t  </div> </div> </div> </div> </div> </div>',
      },
      5: {
        label: "Hur kan jag radera/ta bort mitt konto från MT4-plattformen?",
        content:
          '<div class="content"><p>För att ta bort eller radera ditt konto från MT4-plattformen högerklickar du på det konto som du behöver ta bort och väljer alternativet "Radera".</p></div>',
      },
      6: {
        label: "Varifrån kan jag ladda ner MT4-plattformen?",
        content:
          '<div class="content"><p>För att ladda ner plattformen, följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Klicka på fliken "Plattform" på portalen</li>\n\t\t  <li>Klicka på "Ladda ner här"</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      7: {
        label: "Får jag använda en EA/ BOT/ Trading Robot?",
        content:
          '<div class="content"><p>Du kan definitivt använda en expertrådgivare i MT4. Kolla efter de som är fritt tillgängliga i navigeringsfönstret. Om du vill kan du också köpa EA: er från webbplatsen MQL 5.</p> </div>',
      },
      8: {
        label: "Hur kan jag bifoga EA i MT4?",
        content:
          '<div class="content"><p>För att bifoga en EA, följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Öppna navigationsrutan (Ctrl N)</li>\n\t\t  <li>Expertrådgivare</li>\n\t\t  <li>Högerklicka på EA som du vill använda</li>\n\t\t  <li>Fäst i diagrammet </li>\n\t\t  </ul> </ul>\n\t\t  <p>Och om du är villig att ansöka om en köpt EA från MQL-webbplatsen, följ dessa steg:</p>\n\t\t  <ul> <li>Gå till\n\t\t  <li>Gå till fliken "Arkiv" i menyraden</li>\n\t\t  <li>Klicka på Öppna datamapp </li>\n\t\t  <li>Öppna mappen "Experts" i filen "MQL" </li>\n\t\t  <li>Öppna mappen "Experts" i filen "MQL".</li>\n\t\t  <li>Öppna MT4-plattformen igen.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      9: {
        label: "Hur ställer jag in standarddiagram med indikatorer på MT4?",
        content:
          '<div class="content"><p>Följ stegen nedan:</p>\n\t\t  <p><b>Så här sparar du en profil:</b></p>\n\t\t  <p>När du har placerat allt på det sätt du vill, gå till Arkiv - Profiler och klicka på "Spara som" Ange ett profilnamn och tryck sedan på "Ok"</p> <p>För att ladda en sparad profil, gå till Arkiv - Profiler och klicka på "Spara som".\n\t\t  <p>För att ladda en sparad profil, gå till File - Profiles och välj sedan profilen från listan över profiler som kommer upp. Profilen bör laddas.</p> <p>\n\t\t  <p><b>Så här sparar du en mall:</b></p>\n\t\t  <p>När du har ställt in allt på ditt diagram som du vill, gå till Diagram - Mall - Spara mall för att spara mallen. Ange ett namn för mallen och tryck på spara.\n\t\t  </p>\n\t\t  </div> </div> </div> </div> </div> </div',
      },
      10: {
        label: "Kan jag använda flera handelskonton i MT4?",
        content:
          '<div class="content"><p>Ja, du kan använda flera handelskonton i MT4, för att lägga till ett konto följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Högerklicka på konton i navigatorrutan</li>\n\t\t  <li>Välj "Logga in på handelskonto"</li>\n\t\t  <li>Fyll i ditt handels-ID och lösenord</li>\n\t\t  </ul> </ul>\n\t\t  <p>Ditt handelskonto kommer att läggas in i MT4.</p>\n\t\t  </div> </div>',
      },
      11: {
        label:
          "Var kan jag kontrollera anslutningsstatus för mitt handelskonto?",
        content:
          '<div class="content"><p>Anslutningens status kan kontrolleras i det nedre högra hörnet under terminalfönstret.</p><p>För att göra anslutningsstatusen synlig klickar du på "view" > enable status bar</p></div>',
      },
    },
    "Handelsplattformar - MT5": {
      0: {
        label: "Hur loggar jag in på mitt MT5-handelskonto?",
        content:
          '<div class="content"><p>Följ dessa steg för att logga in på MT5-plattformen</p>\n\t\t  <ul>\n\t\t  <li>Klicka på alternativet "Arkiv" i menyraden</li>\n\t\t  <li>Välj inloggning till handelskonto</li>\n\t\t  <li>Fyll i ditt handels-ID och lösenord</li>\n\t\t  <li>Välj servernamn: AAAFx-FX-Demo (för demokonto) / AAAFx-FX-Real (för riktigt konto)</li>\n\t\t  <li>Klicka på inloggning</li>\n\t\t  <p>Du kommer att loggas in på ditt handelskonto</p>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      1: {
        label: "Hur loggar jag in på ett riktigt konto på MT5?",
        content:
          '<div class="content"><p>För att logga in på ett riktigt konto på MT5-plattformen, följ dessa steg</p>\n\t\t  <p>Först måste du skapa ett riktigt konto på portalen. För att skapa ett live-konto, följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Registrera: Klicka på alternativet "Gå med nu" på portalen</li>\n\t\t  <li>Ange dina uppgifter: Namn, e-post-ID, telefonnummer</li>\n\t\t  <li>Ange verifieringskoden som du skulle ha fått i ditt e-postmeddelande</li>\n\t\t  <li>Välj kontobasvaluta och handelsplattform</li>\n\t\t  <li>Vidare måste du ladda upp dokument</li>\n\t\t  <li>Nu sätter du in pengar.</li>\n\t\t  </ul> </ul>\n\t\t  <p>Efter detta följer du dessa steg för att logga in på plattformen:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Klicka på alternativet "Arkiv" i menyraden</li>\n\t\t  <li>Välj "Logga in på ett handelskonto"</li>\n\t\t  <li>Ange ditt handels-ID och lösenord</li>\n\t\t  <li>Välj server: AAA Fx-FX-Real</li>\n\t\t  <li>Klicka på "Logga in"</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      2: {
        label: "Hur skapar jag/loggar jag in på ett demokonto?",
        content:
          '<div class="content"><p>För att skapa ett demokonto, följ dessa steg:</p>\n\t\t  <ol>\n\t\t  <li>Logga in på ditt webbkonto.</li>\n\t\t  <li>Gå till "Hantera konton"</li>.\n\t\t  <li>Klicka på "Skapa ett demokonto"</li>\n\t\t  <li>Välj handelsplattform, kontohävstång, kontots basvaluta och ange lösenord.</li>\n\t\t  </ol> </ol>\n\t\t  <p>Nu har ett demokonto skapats åt dig.</p>\n\t\t  </div> </div>',
      },
      3: {
        label: "Var kan jag se mina provisioner?",
        content:
          '<div class="content"><p>För att se provision, vänligen följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Klicka på alternativet "Visa" i menyraden</li>\n\t\t  <li>Välj "Terminal"</li>\n\t\t  <li>Välj "Handelsavdelning"</li>\n\t\t  <li>Högerklicka på den placerade affären</li>\n\t\t  <li>Aktivera provisioner</li>\n\t\t  </ul> </ul>\n\t\t  <p>Du kan nu se provisioner som en separat kolumn</p>\n\t\t  </div> </div>',
      },
      4: {
        label:
          "Hur kan jag ändra lösenordet för mitt handelskonto från plattformen?",
        content:
          '<div class="content"><p>Följ dessa steg för att ändra kontolösenordet från MT5:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Klicka på "Verktyg" i menyfältet</li>\n\t\t  <li>Välj "Alternativ" > Dialogrutan kommer att visas</li>\n\t\t  <li>Ange nytt lösenord > Okej</li>\n\t\t  </ul> </ul>\n\t\t  <p>ELLER</p>\n\t\t  <ul> <li>I\n\t\t  <li>I navigeringsfönstret, under konton > Högerklicka på det konto som du vill ändra lösenordet för</li>\n\t\t  <li>Ange det nuvarande lösenordet och det nya lösenordet > Klicka på Okej</li>\n\t\t  </ul>\n\t\t  </div> </div> </div> </div> </div> </div>',
      },
      5: {
        label: "Hur kan jag radera/ta bort mitt konto från MT5-plattformen?",
        content:
          '<div class="content"><p>För att ta bort eller radera ditt konto från MT5-plattformen högerklickar du på det konto som du behöver ta bort och väljer alternativet "Radera".</p></div>',
      },
      6: {
        label: "Varifrån kan jag ladda ner MT5-plattformen?",
        content:
          '<div class="content"><p>För att ladda ner plattformen, följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Klicka på fliken "Plattform" på portalen</li>\n\t\t  <li>Klicka på "Ladda ner här"</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      7: {
        label: "Får jag använda en EA/ BOT/ Trading Robot?",
        content:
          '<div class="content"><p>Du kan definitivt använda en expertrådgivare i MT5. Kolla efter de som är fritt tillgängliga i navigeringsfönstret. Om du vill kan du också köpa EA: er från MQL 5-webbplatsen.</p> </div>',
      },
      8: {
        label: "Hur kan jag bifoga EA i MT5?",
        content:
          '<div class="content"><p>För att bifoga en EA, följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Öppna navigationsrutan (Ctrl N)</li>\n\t\t  <li>Expertrådgivare</li>\n\t\t  <li>Högerklicka på EA som du vill använda</li>\n\t\t  <li>Bifoga till diagrammet </li>\n\t\t  </ul> </ul>\n\t\t  <p>Och om du är villig att ansöka om en köpt EA från MQL-webbplatsen, följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Gå till fliken "Arkiv" i menyraden</li>\n\t\t  <li>Klicka på Öppna datamapp </li>\n\t\t  <li>Öppna mappen "Experts" i filen "MQL" </li>\n\t\t  <li>Öppna mappen "Experts" i filen "MQL".</li>\n\t\t  <li>Öppna MT4-plattformen igen.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      9: {
        label: "Hur ställer jag in standarddiagram med indikatorer på MT5?",
        content:
          '<div class="content"><p>Följ stegen nedan:</p>\n\t\t  <p><b>Så här sparar du en profil:</b></p>\n\t\t  <p>När du har placerat allt som du vill, gå till Arkiv - Profiler och klicka på "Spara som" Ange ett profilnamn och tryck sedan på "Ok"</p> <p>För att ladda en sparad profil\n\t\t  <p>För att ladda en sparad profil, gå till File - Profiles och välj sedan profilen från listan över profiler som kommer upp. Profilen bör laddas.</p> <p>\n\t\t  <p><b>Så här sparar du en mall:</b></p>\n\t\t  <p>När du har ställt in allt på ditt diagram som du vill, gå till Diagram - Mall - Spara mall för att spara mallen. Ange ett namn för mallen och tryck på spara.\n\t\t  </p>\n\t\t  </div> </div> </div> </div> </div> </div> </div',
      },
      10: {
        label: "Kan jag använda flera handelskonton i MT5?",
        content:
          '<div class="content"><p>Ja, du kan använda flera handelskonton i MT5, för att lägga till ett konto följ dessa steg:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Högerklicka på konton i navigatorrutan</li>\n\t\t  <li>Välj "Logga in på handelskonto"</li>\n\t\t  <li>Fyll i ditt handels-ID och lösenord</li>\n\t\t  </ul> </ul>\n\t\t  <p>Ditt handelskonto kommer att läggas in i MT5.</p>\n\t\t  </div> </div>',
      },
      11: {
        label:
          "Var kan jag kontrollera anslutningsstatus för mitt handelskonto?",
        content:
          '<div class="content"><p>Anslutningens status kan kontrolleras i det nedre högra hörnet under terminalfönstret.</p><p>För att göra anslutningsstatusen synlig klickar du på "view" > enable status bar</p></div>',
      },
    },
    "Handelsplattformar - ActTrader": {
      0: {
        label: "Hur loggar jag in på mitt handelskonto på ACT på skrivbordet?",
        content:
          '<div class="content"><p>Följ vänligen stegen nedan för att logga in på ditt handelskonto:</p>\n\t\t  <ul> <li>Klicka på\n\t\t  <li>Klicka på <a href="https://aaafx.com/act-trader" target="_blank">länken</a> för att ladda ner handelsplattformen.</li>\n\t\t  <li>En installation kommer att laddas ner på systemet. Klicka på installationen och plattformen kommer att installeras.</li>\n\t\t  <li>När plattformen är installerad anger du användarnamn och lösenord för handelskontot.</li>\n\t\t  <li>Välj server - "Demo" för ett demokonto och "Real" för ett livekonto.</li>\n\t\t  <li>Klicka på "Logga in". Du är inloggad på ditt konto.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      1: {
        label: "Hur loggar jag in på mitt handelskonto på ACT on web trader?",
        content:
          '<div class="content"><p>Följ stegen nedan för att logga in på ditt handelskonto på web trader:</p>\n\t\t  <ul> <li>Klicka på\n\t\t  <li>Klicka på <a href="https://aaafx.com/act-trader" target="_blank">länken</a> för att öppna web trader</li>\n\t\t  <li>En ny flik kommer att visas.</li>\n\t\t  <li>Ange användarnamn och lösenord för handelskontot.</li>\n\t\t  <li>Klicka på "Logga in". Du är inloggad på ditt konto.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      2: {
        label:
          "Jag är förvirrad över hur man installerar ACT-applikationen på min mobila enhet. Vänligen hjälp mig.",
        content:
          '<div class="content"><p>Följ vänligen stegen nedan för att installera applikationen på din mobila enhet:</p>\n\t\t  <p><b>ANDROID</b></p>\n\t\t  <ul> <ul>\n\t\t  <li>Logga in på din klientportal på din mobila enhet.</li>\n\t\t  <li>Klicka på <a href="https://aaafx.com/act-trader" target="_blank">länken</a></li>\n\t\t  <li>Rulla till botten av fönstret och klicka på "ACT ANDROID".</li>\n\t\t  <li>Google Store öppnar upp en applikation med namnet \'ActDroid\' dyker upp.</li>\n\t\t  <li>Klicka på "Installera" och applikationen kommer att installeras på din enhet.</li>\n\t\t  </ul> </ul>\n\t\t  <p><b>IOS</b></p>\n\t\t  <ul> <ul>\n\t\t  <li>Logga in på din klientportal på din mobila enhet.</li>\n\t\t  <li>Klicka på <a href="https://aaafx.com/act-trader" target="_blank">länken</a></li>\n\t\t  <li>Rulla till botten av fönstret och klicka på ACT IOS.</li>\n\t\t  <li>Google Store öppnas och en applikation med namnet \'ActPhone\' dyker upp.</li>\n\t\t  <li>Klicka på "Installera" och applikationen kommer att installeras på din enhet.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      3: {
        label: "Hur loggar jag in på mitt handelskonto via min mobila enhet?",
        content:
          '<div class="content"><p>Följ stegen nedan för att logga in på ditt handelskonto på din mobila enhet:</p>\n\t\t  <p><b>ANDROID</b></p>\n\t\t  <ul> <li>Klicka på\n\t\t\t<li>Klicka på ActDroid-applikationen på din enhet.</li>\n\t\t\t<li>Tryck på "Acceptera" på licensavtalet.</li>\n\t\t\t<li>Ange användarnamn och lösenord för handelskontot.</li>\n\t\t\t<li>I kontotyp väljer du server enligt kontotyp - "AAAFx-FX-Demo" för ett demokonto och "AAAFx-FX-Real" för ett live-konto.</li>\n\t\t\t<li>Klicka på "Logga in". Du är nu inloggad på ditt konto.</li>\n\t\t  </ul> </ul>\n\t\t  <p><b>IOS</b></p>\n\t\t  <ul> <li>Klicka på\n\t\t\t<li>Klicka på ActPhone-applikationen på din enhet.</li>\n\t\t\t<li>Ange användarnamn och lösenord för handelskontot.</li>\n\t\t\t<li>I kontotyp väljer du server enligt kontotyp - "AAAFx-FX-Demo" för ett demokonto och "AAAFx-FX-Real" för ett live-konto.</li>\n\t\t\t<li>Klicka på "Logga in". Du är nu inloggad på ditt konto.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      4: {
        label: "Hur gör jag en beställning?",
        content:
          '<div class="content"><p>Du kan enkelt göra en affär genom att klicka på knapparna Sälj eller Köp under fliken Hem i FXVoyagers verktygsfält.</p><p>Du kan också lägga en marknadsorder direkt från fönstret Handelskurser, fönstret Instrument eller tabellen Handelskurser. Vänsterklicka bara på köp- eller säljkursen eller högerklicka på kursen och välj Marknadsorder.</p></div>',
      },
      5: {
        label:
          "Hur kan jag kontrollera saldot på mitt handelskonto på handelsplattformen?",
        content:
          '<div class="content"><p>Du kan kontrollera kontosaldot på följande sätt:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Logga in på ditt handelskonto.</li>\n\t\t  </li>Klicka på fliken "Sammanfattning".\n\t\t  </ul> </ul>\n\t\t  <p>All kontoinformation inklusive saldo kommer att visas.</p>\n\t\t  <p>ELLER</p> <p>\n\t\t  <p>Kontosaldot kan kontrolleras längst ner till vänster på plattformen.</p>\n\t\t  </div> </div>',
      },
      6: {
        label: "Kan jag logga in på flera konton samtidigt på ACT?",
        content:
          '<div class="content"><p>Nej, ACT tillåter inte användaren att logga in på flera handelskonton samtidigt.</p></div>',
      },
      7: {
        label: "Hur kan jag aktivera handel med ett klick?",
        content:
          '<div class="innehåll">\n\t\t  <ul>\n\t\t  <li>Klicka på inställningsikonen i det övre vänstra hörnet</li>\n\t\t  <li>Välj "huvudinställning"</li>\n\t\t  <li>Markera "Handel med ett klick"</li>\n\t\t  <li>Klicka på tillämpa</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      8: {
        label:
          "Kan jag använda indikatorer på mitt diagram? Hur kan jag göra det?",
        content:
          '<div class="content"><p>Följ stegen nedan för att tillämpa indikatorer på ditt diagram:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Öppna diagrammet som du vill använda indikatorn på.</li>\n\t\t  <li>Flytta markören till diagrammet. Högerklicka på diagrammets område.</li>\n\t\t  <li>Välj "Konfigurera indikatorer".</li>\n\t\t  <li>En pop med olika indikatorer kommer att öppnas.</li>\n\t\t  <li>Välj indikator och tryck på framåtknappen " > "</li>\n\t\t  <li>Du kan ändra inställningarna för den valda indikatorn på kuvertområdet innan du applicerar.</li>\n\t\t  <li>Klicka på "Apply" och sedan på "Ok".</li>\n\t\t  </ul> </ul>\n\t\t  <p>Du kommer att se att indikatorn har tillämpats på ditt diagram.</p>\n\t\t  </div> </div>',
      },
      9: {
        label: "Hur kan jag ta bort en indikator från mitt diagram?",
        content:
          '<div class="content"><p>Följ vänligen stegen nedan för att ta bort indikatorer i ditt diagram:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Öppna diagrammet där du vill ta bort indikatorn.</li>\n\t\t  <li>Flytta markören till diagrammet. Högerklicka på diagrammets område.</li>\n\t\t  <li>Välj "Konfigurera indikatorer".</li>\n\t\t  <li>En pop med olika indikatorer kommer att öppnas.</li>\n\t\t  <li>Du kan se listan över alla tillämpade indikatorer under "aktiva indikatorer".</li>\n\t\t  <li>Välj indikatorn och tryck på bakåtknappen " <"</li>\n\t\t  <li>Klicka på "Apply" och sedan på "Ok".</li>\n\t\t  </ul> </ul>\n\t\t  <p>Du kommer att se att indikatorn har tagits bort från diagrammet.</p>\n\t\t  </div> </div>',
      },
      10: {
        label: "Kan jag ta bort flera indikatorer från diagrammet?",
        content:
          '<div class="content"><p>Ja, det kan du säkert göra.</p>\n\t\t  <ul> <ul>\n\t\t  <li>Öppna diagrammet där du vill ta bort indikatorn.</li>\n\t\t  <li>Flytta markören till diagrammet. Högerklicka på diagrammets område.</li>\n\t\t  <li>Välj "Konfigurera indikatorer".</li>\n\t\t  <li>En pop med olika indikatorer kommer att öppnas.</li>\n\t\t  <li>Du kan se listan över alla tillämpade indikatorer under "aktiva indikatorer".</li>\n\t\t  <li>Klicka på snabbbackknappen " << " för att ta bort alla indikatorer</li>\n\t\t  <li>Klicka på "Apply" och sedan på "Ok".</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      11: {
        label: "Varifrån kan jag öppna fönstret för handelsräntan?",
        content:
          '<div class="content"><p>Följ vänligen stegen nedan för att öppna fönstret för handelsräntan:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Logga in på ditt handelskonto på plattformen.</li>\n\t\t  <li>Klicka på fliken "Instrument".</li>\n\t\t  <li>Flytta markören mot det specifika instrumentet.</li>\n\t\t  <li>Högerklicka och välj "Fönstret för individuell handelsränta".</li>\n\t\t  <li>En popup-fönster öppnas med handelskursen för det paret.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      12: {
        label: "Hur kan jag lägga en order från fönstret för handelskurser?",
        content:
          '<div class="content"><p>Följ vänligen stegen nedan för att öppna fönstret för handelsräntan:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Logga in på ditt handelskonto på plattformen.</li>\n\t\t  <li>Klicka på fliken "Instrument".</li>\n\t\t  <li>Flytta markören mot det specifika instrumentet.</li>\n\t\t  <li>Högerklicka och välj "Fönstret för individuell handelsränta".</li>\n\t\t  <li>Ett popup-fönster öppnas med handelskursen för det paret.</li>\n\t\t  <li>Dubbelklicka på popup-fönstret, ändra önskade inställningar och klicka på "OK" för att lägga ordern.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      13: {
        label: "Kan jag ladda ner mitt kontoutdrag från handelsplattformen?",
        content:
          '<div class="content"><p>Ja, handelskontoutdraget kan laddas ner från plattformen genom att följa stegen nedan:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Logga in på ditt handelskonto på plattformen.</li>\n\t\t  <li>Klicka på "Rapporter".</li>\n\t\t  <li>Välj "Kontoutdrag".</li>\n\t\t  <li>Välj tidsformat och klicka på "Kör rapport".</li>\n\t\t  <li>Rapporten kommer att öppnas på skärmen. Välj "Exportera till excel". Rapporten öppnas på Excel-arket och kan sparas därifrån.</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      14: {
        label:
          " Jag vill ändra min säljorder. Hur kan jag tillämpa Stop Loss- och Take Profit-nivåer på min order?",
        content:
          '<div class="content"><p>För att ändra en order öppnar du fliken "Handel" i verktygsfältet och klickar på knappen "Stop eller Limit". Du kan ange en Stop- eller Limit-order från fönstret Öppna positioner. Du kan också ange ett fördefinierat stopp eller limit i dialogfönstret Ny position.</p></div>',
      },
      15: {
        label: "Hur kan jag stänga en handel på diagrammet?",
        content:
          '<div class="content"><p>För att stänga eller säkra en position högerklickar du på positionstriangeln och väljer lämpligt kommando.</p></div>',
      },
      16: {
        label: "Hur kan jag lägga till Trailing Stop på en order?",
        content:
          '<div class="content"><p>Följ vänligen stegen nedan för att lägga till Trailing Stop i din order:</p>\n\t\t  <ul> <ul>\n\t\t  <li>Högerklicka på önskad position i fönstret Öppna positioner.</li>\n\t\t  <li>En popup-meny kommer att visas på skärmen.</li>\n\t\t  <li>Välj Trailing Stop-nivå och klicka på "OK".</li>\n\t\t  </ul> </ul>\n\t\t  </div> </div>',
      },
      17: {
        label: "Var kan jag se min handelshistorik?",
        content:
          '<div class="content"><p>Positionshistoriken kan ses i fönstret Stängda positioner.</p></div>',
      },
      18: {
        label: "Hur kan jag se handelshistoriken på IOS?",
        content:
          '<div class="content"><p>För att visa historik på Ios, klicka på Meny > Historik. Som standard kan upp till 15 positioner visas. Antalet positioner kan ökas genom att öppna Meny > Inställningar.</p></div>',
      },
      19: {
        label: "Hur kan jag öppna ett diagram över ett handelsinstrument?",
        content:
          '<div class="content"><p>För att öppna ett diagramfönster på din handelsarbetsyta, välj "Diagram" på menyn i den övre panelen och välj sedan "Nytt diagram".</p>\n\t\t  <p>ELLER</p> <p>\n\t\t  <p>Högerklicka på ett instrument i fönstret Dealing Rates och välj Open Chart. Välj instrument (om du högerklickade på ett instrument för att komma till dialogrutan Nytt diagram kommer det instrumentet att vara förvalt) och tidsskala från menyn Nytt diagram och tryck på OK.\n\t\t  </p>\n\t\t  </div>',
      },
      20: {
        label: "Hur kan jag zooma in och zooma ut i diagrammet?",
        content:
          '<div class="content"><p>På toppen av diagrammet finns ikonerna plus "+" och minus "-" som gör det möjligt att zooma in, zooma ut och visa standarddiagram.</p></div>',
      },
      21: {
        label: "Kan jag ändra färgerna i diagrammet?",
        content:
          '<div class="content"><p>Ja, det går att ändra färgerna i diagrammet. Högerklicka på diagrammet och välj "Diagraminställningar". Du kommer att se rullgardinsmenyn "Färger". Färgerna kan ändras i enlighet med detta.</p></div>',
      },
      22: {
        label: "Var ser jag prislinjen på diagrammet?",
        content:
          '<div class="content"><p>Prislinjen är den blåfärgade linjen i diagrammets bakgrund. Den rör sig i enlighet med instrumentets prisrörelse.</p></div>',
      },
    },
    Handelsvillkor: {
      0: {
        label:
          "Finns det någon form av begränsningar för att anta handelsstilar? Jag är en scalper.",
        content:
          '<div class="content"><p>Att vara en handelsvänlig mäklare begränsar vi inte några handelsstilar. Du kan göra säkring, scalping och använda EA på din handelsplattform.</p> </div>',
      },
      1: {
        label: "Följer du FIFO-regeln för handelsutförande?",
        content:
          '<div class="content"><p>Nej, vi följer inte FIFO-regeln. Handlaren kan stänga affären enligt sin egen strategi.</p> </div>',
      },
      2: {
        label: "Vilken typ av handelsutförande tillhandahåller du?",
        content:
          '<div class="content"><p>På AAAFx sker handelsutförandet omedelbart.</p></div>',
      },
      3: {
        label:
          "Finns det en gräns för hur många avslut som kan göras varje månad?",
        content:
          '<div class="content"><p>Nej, det finns inga sådana gränser. Du kan placera affärer enligt ditt eget val.</p> </div>',
      },
      4: {
        label: "Kan jag handla över helgen?",
        content:
          '<div class="content"><p>Nej, handeln är inte tillgänglig på helgerna.</p></div>',
      },
      5: {
        label: "Hur länge kan jag behålla mina öppna positioner?",
        content:
          '<div class="content"><p>Det finns inget tvång på den tid som en handel kan hållas öppen. Du kan hålla den öppen så länge du har tillräcklig fri marginal på kontot.</p> </div>',
      },
      6: {
        label:
          "Kan jag förlora mer än vad jag sätter in när jag handlar med dig?",
        content:
          '<div class="content"><p>När du handlar med AAAFx kan du inte förlora mer än vad du sätter in eftersom vi tillhandahåller skydd mot negativt saldo. AAAFx fastställer efter eget gottfinnande och i god tro att förekomsten av ett sådant negativt saldo inte beror på något skadligt eller missbrukande beteende hos kunden och inte avsiktligt har orsakats av kunden.</p></div>',
      },
      7: {
        label:
          "Vad händer om det inte finns någon fri marginal kvar på mitt handelskonto?",
        content:
          '<div class="content"><p>Om det inte finns någon fri marginal kvar kan du inte lägga några ytterligare order. Du kan inte heller göra en begäran om uttag eftersom du alltid kan ta ut det belopp som finns tillgängligt som fri marginal på ditt konto.</p></div>',
      },
      8: {
        label: "Vilken typ av spreads erbjuder ni på AAAFx?",
        content:
          '<div class="content"><p>Vi erbjuder knivskarpa spreadar till alla våra kunder oavsett kontotyp. </p> </div>',
      },
      9: {
        label: "Vilken hävstång erbjuds av AAAFx?",
        content:
          '<div class="content"><p>Den maximala hävstång som erbjuds för AAAFX Europe är 30X.</p></div>',
      },
      10: {
        label: "Vilken tidszon är dina servrar inställda på?",
        content:
          '<div class="content"><p>Den är inställd på UTC-tid [UTC +1 under sommartid].</p></div>',
      },
      11: {
        label: "Var är dina servrar placerade?",
        content:
          '<div class="content"><p>Våra servrar finns i London och New York.</p></div>',
      },
      12: {
        label: "Erbjuder du tradingrådgivning till dina kunder?",
        content:
          '<div class="content"><p>Att vara en mäklare ger vi inte någon form av handelsråd till våra kunder. För de perfekta handelsstrategierna kan du hänvisa till Zulutrade-webbplatsen och lära dig så mycket du kan. Dessutom kan du också läsa om förhållandet mellan hävstångseffekt och marginal för att investera dina medel klokt. Forex trading handlar om att investera din tid och pengar på ett klokt sätt. Börja investera nu!</p> </div>',
      },
    },
  },
};
